//
// THIS FILE IS GENERATED DO NOT EDIT!
// DO NOT MODIFY BY HAND!
// @eapcj THANKS YOU!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type EntireFieldWrapper<T> = T;
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  citext: any;
  date: any;
  float8: any;
  numeric: any;
  timestamp: any;
  timestamptz: string;
  timetz: any;
  uuid: string;
}


export interface StudentOrTeacherBbbJoinLink {
  id: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherBooleanComparisonExp {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherIntComparisonExp {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
}

export interface StudentOrTeacherMessageResponse {
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface StudentOrTeacherSession {
  directus_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_expires_in?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherStringComparisonExp {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
}

export interface StudentOrTeacherUserData {
  assignments?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  birthday_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  chat?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  email: EntireFieldWrapper<Scalars['String']>;
  first_name: EntireFieldWrapper<Scalars['String']>;
  grading?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  is_verified?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  live_class?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  mobile?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street_address?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** columns and relationships of "assignment_attendee_type" */
export interface StudentOrTeacherAssignmentAttendeeType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrTeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentsAggregate>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  value: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface StudentOrTeacherAssignmentAttendeeTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface StudentOrTeacherAssignmentAttendeeTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_attendee_type". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentAttendeeTypeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentAttendeeTypeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeBoolExp>>;
  assignments?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  comment?: Maybe<StudentOrTeacherStringComparisonExp>;
  value?: Maybe<StudentOrTeacherStringComparisonExp>;
}

export const enum StudentOrTeacherAssignmentAttendeeTypeEnum {
  CLASS = 'CLASS',
  USER = 'USER'
};

/** Boolean expression to compare columns of type "assignment_attendee_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherAssignmentAttendeeTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherAssignmentAttendeeTypeEnum>;
  _in?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherAssignmentAttendeeTypeEnum>;
  _nin?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_attendee_type". */
export interface StudentOrTeacherAssignmentAttendeeTypeOrderBy {
  assignments_aggregate?: Maybe<StudentOrTeacherAssignmentsAggregateOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  value?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_attendee_type" */
export const enum StudentOrTeacherAssignmentAttendeeTypeSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "assignment_book_chapter" */
export interface StudentOrTeacherAssignmentBookChapter {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrTeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<StudentOrTeacherBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_book_chapter" */
export interface StudentOrTeacherAssignmentBookChapterAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentBookChapterMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentBookChapterMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_book_chapter". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentBookChapterBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentBookChapterBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentBookChapterBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentBookChapterBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  book_chapter?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
  book_chapter_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_book_chapter" */
export interface StudentOrTeacherAssignmentBookChapterMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  book_chapter_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_book_chapter" */
export interface StudentOrTeacherAssignmentBookChapterMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  book_chapter_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "assignment_book_chapter". */
export interface StudentOrTeacherAssignmentBookChapterOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  book_chapter?: Maybe<StudentOrTeacherBookChaptersOrderBy>;
  book_chapter_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_book_chapter" */
export const enum StudentOrTeacherAssignmentBookChapterSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussion {
  /** An array relationship */
  assignment_discussion_contents: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionContent>>;
  /** An array relationship */
  assignment_discussion_subscriptions: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionSubscription>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionAssignmentDiscussionContentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionContentBoolExp>;
}


/** columns and relationships of "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionAssignmentDiscussionSubscriptionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentDiscussionMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentDiscussionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionArrRelInsertInput {
  data: Array<StudentOrTeacherAssignmentDiscussionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentDiscussionBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentDiscussionBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentDiscussionBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentDiscussionBoolExp>>;
  assignment_discussion_contents?: Maybe<StudentOrTeacherAssignmentDiscussionContentBoolExp>;
  assignment_discussion_subscriptions?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion" */
export const enum StudentOrTeacherAssignmentDiscussionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_PKEY = 'assignment_discussion_pkey'
};

/** columns and relationships of "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContent {
  /** An object relationship */
  assignment_discussion: EntireFieldWrapper<StudentOrTeacherAssignmentDiscussion>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  replay_to?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContent>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentOrTeacherStudents>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentDiscussionContentMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentDiscussionContentMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentArrRelInsertInput {
  data: Array<StudentOrTeacherAssignmentDiscussionContentInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionContentOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_content". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentDiscussionContentBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentDiscussionContentBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentBoolExp>>;
  assignment_discussion?: Maybe<StudentOrTeacherAssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  content?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  parent_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  replay_to?: Maybe<StudentOrTeacherAssignmentDiscussionContentBoolExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  teacher?: Maybe<StudentOrTeacherTeachersBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_content" */
export const enum StudentOrTeacherAssignmentDiscussionContentConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_CONTENT_PKEY = 'assignment_discussion_content_pkey'
};

/** input type for inserting data into table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentInsertInput {
  assignment_discussion?: Maybe<StudentOrTeacherAssignmentDiscussionObjRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  replay_to?: Maybe<StudentOrTeacherAssignmentDiscussionContentObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentMaxOrderBy {
  assignment_discussion_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  parent_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentMinOrderBy {
  assignment_discussion_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  parent_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionContent>>;
}

/** input type for inserting object relation for remote table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentObjRelInsertInput {
  data: StudentOrTeacherAssignmentDiscussionContentInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionContentOnConflict>;
}

/** on conflict condition type for table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentOnConflict {
  constraint: StudentOrTeacherAssignmentDiscussionContentConstraint;
  update_columns?: Array<StudentOrTeacherAssignmentDiscussionContentUpdateColumn>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionContentBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_content". */
export interface StudentOrTeacherAssignmentDiscussionContentOrderBy {
  assignment_discussion?: Maybe<StudentOrTeacherAssignmentDiscussionOrderBy>;
  assignment_discussion_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  parent_id?: Maybe<StudentOrTeacherOrderBy>;
  replay_to?: Maybe<StudentOrTeacherAssignmentDiscussionContentOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  teacher?: Maybe<StudentOrTeacherTeachersOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: assignment_discussion_content */
export interface StudentOrTeacherAssignmentDiscussionContentPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_content" */
export const enum StudentOrTeacherAssignmentDiscussionContentSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_content" */
export interface StudentOrTeacherAssignmentDiscussionContentSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_content" */
export const enum StudentOrTeacherAssignmentDiscussionContentUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for inserting data into table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionInsertInput {
  assignment_discussion_contents?: Maybe<StudentOrTeacherAssignmentDiscussionContentArrRelInsertInput>;
  assignment_discussion_subscriptions?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionArrRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussion>>;
}

/** input type for inserting object relation for remote table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionObjRelInsertInput {
  data: StudentOrTeacherAssignmentDiscussionInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionOnConflict>;
}

/** on conflict condition type for table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionOnConflict {
  constraint: StudentOrTeacherAssignmentDiscussionConstraint;
  update_columns?: Array<StudentOrTeacherAssignmentDiscussionUpdateColumn>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion". */
export interface StudentOrTeacherAssignmentDiscussionOrderBy {
  assignment_discussion_contents_aggregate?: Maybe<StudentOrTeacherAssignmentDiscussionContentAggregateOrderBy>;
  assignment_discussion_subscriptions_aggregate?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionAggregateOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: assignment_discussion */
export interface StudentOrTeacherAssignmentDiscussionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion" */
export const enum StudentOrTeacherAssignmentDiscussionSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion" */
export interface StudentOrTeacherAssignmentDiscussionSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** columns and relationships of "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscription {
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussion>>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_notification_enabled: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionArrRelInsertInput {
  data: Array<StudentOrTeacherAssignmentDiscussionSubscriptionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_subscription". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>>;
  assignment_discussion?: Maybe<StudentOrTeacherAssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_notification_enabled?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_subscription" */
export const enum StudentOrTeacherAssignmentDiscussionSubscriptionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_SUBSCRIPTION_PKEY = 'assignment_discussion_subscription_pkey'
};

/** input type for inserting data into table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionInsertInput {
  assignment_discussion?: Maybe<StudentOrTeacherAssignmentDiscussionArrRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionMaxOrderBy {
  assignment_discussion_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionMinOrderBy {
  assignment_discussion_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionSubscription>>;
}

/** on conflict condition type for table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionOnConflict {
  constraint: StudentOrTeacherAssignmentDiscussionSubscriptionConstraint;
  update_columns?: Array<StudentOrTeacherAssignmentDiscussionSubscriptionUpdateColumn>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_subscription". */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionOrderBy {
  assignment_discussion_aggregate?: Maybe<StudentOrTeacherAssignmentDiscussionAggregateOrderBy>;
  assignment_discussion_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_notification_enabled?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: assignment_discussion_subscription */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_subscription" */
export const enum StudentOrTeacherAssignmentDiscussionSubscriptionSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_subscription" */
export interface StudentOrTeacherAssignmentDiscussionSubscriptionSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_subscription" */
export const enum StudentOrTeacherAssignmentDiscussionSubscriptionUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** update columns of table "assignment_discussion" */
export const enum StudentOrTeacherAssignmentDiscussionUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_files" */
export interface StudentOrTeacherAssignmentFiles {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_files" */
export interface StudentOrTeacherAssignmentFilesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentFilesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentFilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_files". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentFilesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentFilesBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentFilesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentFilesBoolExp>>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  hash?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  path?: Maybe<StudentOrTeacherStringComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** input type for inserting data into table "assignment_files" */
export interface StudentOrTeacherAssignmentFilesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_files" */
export interface StudentOrTeacherAssignmentFilesMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  hash?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_files" */
export interface StudentOrTeacherAssignmentFilesMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  hash?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "assignment_files" */
export interface StudentOrTeacherAssignmentFilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentFiles>>;
}

/** Ordering options when selecting data from "assignment_files". */
export interface StudentOrTeacherAssignmentFilesOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  hash?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_files" */
export const enum StudentOrTeacherAssignmentFilesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Possible values for assisgment grade weights.
 *
 *
 * columns and relationships of "assignment_grade_weights"
 */
export interface StudentOrTeacherAssignmentGradeWeights {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  value: EntireFieldWrapper<Scalars['numeric']>;
}

/** aggregated selection of "assignment_grade_weights" */
export interface StudentOrTeacherAssignmentGradeWeightsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAssignmentGradeWeights>>;
}

/** aggregate fields of "assignment_grade_weights" */
export interface StudentOrTeacherAssignmentGradeWeightsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeightsVarianceFields>>;
}


/** aggregate fields of "assignment_grade_weights" */
export interface StudentOrTeacherAssignmentGradeWeightsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** aggregate avg on columns */
export interface StudentOrTeacherAssignmentGradeWeightsAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** Boolean expression to filter rows from the table "assignment_grade_weights". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentGradeWeightsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentGradeWeightsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsBoolExp>>;
  comment?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  value?: Maybe<StudentOrTeacherNumericComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAssignmentGradeWeightsMaxFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAssignmentGradeWeightsMinFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** Ordering options when selecting data from "assignment_grade_weights". */
export interface StudentOrTeacherAssignmentGradeWeightsOrderBy {
  comment?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  value?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_grade_weights" */
export const enum StudentOrTeacherAssignmentGradeWeightsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  ID = 'id',
  /** column name */
  VALUE = 'value'
};

/** aggregate stddev on columns */
export interface StudentOrTeacherAssignmentGradeWeightsStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrTeacherAssignmentGradeWeightsStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrTeacherAssignmentGradeWeightsStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate sum on columns */
export interface StudentOrTeacherAssignmentGradeWeightsSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate var_pop on columns */
export interface StudentOrTeacherAssignmentGradeWeightsVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate var_samp on columns */
export interface StudentOrTeacherAssignmentGradeWeightsVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate variance on columns */
export interface StudentOrTeacherAssignmentGradeWeightsVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** columns and relationships of "assignment_notes" */
export interface StudentOrTeacherAssignmentNotes {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignments>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentOrTeacherStudents>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachers>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "assignment_notes". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentNotesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentNotesBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentNotesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentNotesBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  content?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  teacher?: Maybe<StudentOrTeacherTeachersBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_notes" */
export const enum StudentOrTeacherAssignmentNotesConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_NOTES_PKEY = 'assignment_notes_pkey'
};

/** input type for inserting data into table "assignment_notes" */
export interface StudentOrTeacherAssignmentNotesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "assignment_notes" */
export interface StudentOrTeacherAssignmentNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentNotes>>;
}

/** on conflict condition type for table "assignment_notes" */
export interface StudentOrTeacherAssignmentNotesOnConflict {
  constraint: StudentOrTeacherAssignmentNotesConstraint;
  update_columns?: Array<StudentOrTeacherAssignmentNotesUpdateColumn>;
  where?: Maybe<StudentOrTeacherAssignmentNotesBoolExp>;
}

/** Ordering options when selecting data from "assignment_notes". */
export interface StudentOrTeacherAssignmentNotesOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  teacher?: Maybe<StudentOrTeacherTeachersOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: assignment_notes */
export interface StudentOrTeacherAssignmentNotesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_notes" */
export const enum StudentOrTeacherAssignmentNotesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_notes" */
export interface StudentOrTeacherAssignmentNotesSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_notes" */
export const enum StudentOrTeacherAssignmentNotesUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswers {
  assignment_question_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherAssignmentQuestionAnswersAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentQuestionAnswersMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentQuestionAnswersMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherAssignmentQuestionAnswersStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherAssignmentQuestionAnswersStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherAssignmentQuestionAnswersStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherAssignmentQuestionAnswersSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherAssignmentQuestionAnswersVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherAssignmentQuestionAnswersVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherAssignmentQuestionAnswersVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersAvgOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_answers". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentQuestionAnswersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentQuestionAnswersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersBoolExp>>;
  assignment_question_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  assignment_question_option_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  content?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_correct?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  order?: Maybe<StudentOrTeacherIntComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** input type for inserting data into table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersInsertInput {
  assignment_question_id?: Maybe<Scalars['uuid']>;
  assignment_question_option_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersMaxOrderBy {
  assignment_question_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_option_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersMinOrderBy {
  assignment_question_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_option_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionAnswers>>;
}

/** Ordering options when selecting data from "assignment_question_answers". */
export interface StudentOrTeacherAssignmentQuestionAnswersOrderBy {
  assignment_question_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_option_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_correct?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_question_answers" */
export const enum StudentOrTeacherAssignmentQuestionAnswersSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_ID = 'assignment_question_option_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  USER_ID = 'user_id'
};

/** order by stddev() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersStddevOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersStddevPopOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersStddevSampOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by sum() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersSumOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_pop() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersVarPopOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersVarSampOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by variance() on columns of table "assignment_question_answers" */
export interface StudentOrTeacherAssignmentQuestionAnswersVarianceOrderBy {
  order?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "assignment_question_option_relations" */
export interface StudentOrTeacherAssignmentQuestionOptionRelations {
  /** An object relationship */
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionOptions>>;
  /** An object relationship */
  assignment_question_option?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionOptions>>;
  assignment_question_option_matched_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_matching_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_question_option_relations" */
export interface StudentOrTeacherAssignmentQuestionOptionRelationsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_option_relations". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp>>;
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<StudentOrTeacherAssignmentQuestionOptionsBoolExp>;
  assignment_question_option?: Maybe<StudentOrTeacherAssignmentQuestionOptionsBoolExp>;
  assignment_question_option_matched_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  assignment_question_option_matching_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "assignment_question_option_relations" */
export interface StudentOrTeacherAssignmentQuestionOptionRelationsMaxOrderBy {
  assignment_question_option_matched_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_option_matching_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_question_option_relations" */
export interface StudentOrTeacherAssignmentQuestionOptionRelationsMinOrderBy {
  assignment_question_option_matched_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_option_matching_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "assignment_question_option_relations". */
export interface StudentOrTeacherAssignmentQuestionOptionRelationsOrderBy {
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<StudentOrTeacherAssignmentQuestionOptionsOrderBy>;
  assignment_question_option?: Maybe<StudentOrTeacherAssignmentQuestionOptionsOrderBy>;
  assignment_question_option_matched_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_option_matching_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_question_option_relations" */
export const enum StudentOrTeacherAssignmentQuestionOptionRelationsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHED_ID = 'assignment_question_option_matched_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHING_ID = 'assignment_question_option_matching_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptions {
  /** An object relationship */
  assignment_question: EntireFieldWrapper<StudentOrTeacherAssignmentQuestions>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionAnswers>>;
  assignment_question_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionOptionRelations>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  group?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  score?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}


/** columns and relationships of "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionAnswersBoolExp>;
}


/** columns and relationships of "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp>;
}

/** order by aggregate values of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherAssignmentQuestionOptionsAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentQuestionOptionsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentQuestionOptionsMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherAssignmentQuestionOptionsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherAssignmentQuestionOptionsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherAssignmentQuestionOptionsStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherAssignmentQuestionOptionsSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherAssignmentQuestionOptionsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherAssignmentQuestionOptionsVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherAssignmentQuestionOptionsVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsAvgOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_options". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentQuestionOptionsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentQuestionOptionsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsBoolExp>>;
  assignment_question?: Maybe<StudentOrTeacherAssignmentQuestionsBoolExp>;
  assignment_question_answers?: Maybe<StudentOrTeacherAssignmentQuestionAnswersBoolExp>;
  assignment_question_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  assignment_question_option_relations?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp>;
  comment?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  group?: Maybe<StudentOrTeacherIntComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_correct?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  order?: Maybe<StudentOrTeacherIntComparisonExp>;
  score?: Maybe<StudentOrTeacherIntComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsMaxOrderBy {
  assignment_question_id?: Maybe<StudentOrTeacherOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  group?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsMinOrderBy {
  assignment_question_id?: Maybe<StudentOrTeacherOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  group?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "assignment_question_options". */
export interface StudentOrTeacherAssignmentQuestionOptionsOrderBy {
  assignment_question?: Maybe<StudentOrTeacherAssignmentQuestionsOrderBy>;
  assignment_question_answers_aggregate?: Maybe<StudentOrTeacherAssignmentQuestionAnswersAggregateOrderBy>;
  assignment_question_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_option_relations_aggregate?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsAggregateOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  group?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_correct?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_question_options" */
export const enum StudentOrTeacherAssignmentQuestionOptionsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  SCORE = 'score',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsStddevOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsStddevPopOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsStddevSampOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by sum() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsSumOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_pop() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsVarPopOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsVarSampOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by variance() on columns of table "assignment_question_options" */
export interface StudentOrTeacherAssignmentQuestionOptionsVarianceOrderBy {
  group?: Maybe<StudentOrTeacherOrderBy>;
  order?: Maybe<StudentOrTeacherOrderBy>;
  score?: Maybe<StudentOrTeacherOrderBy>;
}

export const enum StudentOrTeacherAssignmentQuestionTypesEnum {
  /** quiz.fill_in_black */
  FILL_IN_BLANK = 'FILL_IN_BLANK',
  /** quiz.matching */
  MATCHING = 'MATCHING',
  /** quiz.open_question */
  OPEN_QUESTION = 'OPEN_QUESTION',
  /** quiz.pick_options */
  PICK_OPTIONS = 'PICK_OPTIONS'
};

/** Boolean expression to compare columns of type "assignment_question_types_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherAssignmentQuestionTypesEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherAssignmentQuestionTypesEnum>;
  _in?: Maybe<Array<StudentOrTeacherAssignmentQuestionTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherAssignmentQuestionTypesEnum>;
  _nin?: Maybe<Array<StudentOrTeacherAssignmentQuestionTypesEnum>>;
}

/** columns and relationships of "assignment_questions" */
export interface StudentOrTeacherAssignmentQuestions {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrTeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionOptions>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentOrTeacherAssignmentQuestionTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "assignment_questions" */
export interface StudentOrTeacherAssignmentQuestionsAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionOptionsBoolExp>;
}

/** order by aggregate values of table "assignment_questions" */
export interface StudentOrTeacherAssignmentQuestionsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentQuestionsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentQuestionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_questions". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentQuestionsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentQuestionsBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentQuestionsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentQuestionsBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  assignment_question_options?: Maybe<StudentOrTeacherAssignmentQuestionOptionsBoolExp>;
  content?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  type?: Maybe<StudentOrTeacherAssignmentQuestionTypesEnumComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_questions" */
export interface StudentOrTeacherAssignmentQuestionsMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_questions" */
export interface StudentOrTeacherAssignmentQuestionsMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "assignment_questions". */
export interface StudentOrTeacherAssignmentQuestionsOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_question_options_aggregate?: Maybe<StudentOrTeacherAssignmentQuestionOptionsAggregateOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_questions" */
export const enum StudentOrTeacherAssignmentQuestionsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuiz {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrTeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  attempts?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  pass_percentage: EntireFieldWrapper<Scalars['Int']>;
  time_control: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherAssignmentQuizAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentQuizMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentQuizMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherAssignmentQuizStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherAssignmentQuizStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherAssignmentQuizStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherAssignmentQuizSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherAssignmentQuizVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherAssignmentQuizVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherAssignmentQuizVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizAvgOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_quiz". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentQuizBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentQuizBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentQuizBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentQuizBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  attempts?: Maybe<StudentOrTeacherIntComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  pass_percentage?: Maybe<StudentOrTeacherIntComparisonExp>;
  time_control?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "assignment_quiz". */
export interface StudentOrTeacherAssignmentQuizOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
  time_control?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_quiz" */
export const enum StudentOrTeacherAssignmentQuizSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  ATTEMPTS = 'attempts',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PASS_PERCENTAGE = 'pass_percentage',
  /** column name */
  TIME_CONTROL = 'time_control',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizStddevOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizStddevPopOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizStddevSampOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by sum() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizSumOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_pop() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizVarPopOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_samp() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizVarSampOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by variance() on columns of table "assignment_quiz" */
export interface StudentOrTeacherAssignmentQuizVarianceOrderBy {
  attempts?: Maybe<StudentOrTeacherOrderBy>;
  pass_percentage?: Maybe<StudentOrTeacherOrderBy>;
}

/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface StudentOrTeacherAssignmentSubmits {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrTeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  completed_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamp']>;
  file?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrTeacherFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_submited: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface StudentOrTeacherAssignmentSubmitsFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherFilesBoolExp>;
}

/** order by aggregate values of table "assignment_submits" */
export interface StudentOrTeacherAssignmentSubmitsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentSubmitsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentSubmitsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_submits". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentSubmitsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentSubmitsBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentSubmitsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentSubmitsBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  completed_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  content?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestampComparisonExp>;
  file?: Maybe<StudentOrTeacherStringComparisonExp>;
  files?: Maybe<StudentOrTeacherFilesBoolExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_submited?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_submits" */
export const enum StudentOrTeacherAssignmentSubmitsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_SUBMITS_ASSIGNMENT_ID_USER_ID_KEY = 'assignment_submits_assignment_id_user_id_key',
  /** unique or primary key constraint */
  ASSIGNMENT_USER_PKEY = 'assignment_user_pkey'
};

/** input type for inserting data into table "assignment_submits" */
export interface StudentOrTeacherAssignmentSubmitsInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_submited?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_submits" */
export interface StudentOrTeacherAssignmentSubmitsMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  completed_at?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  file?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_submits" */
export interface StudentOrTeacherAssignmentSubmitsMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  completed_at?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  file?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "assignment_submits" */
export interface StudentOrTeacherAssignmentSubmitsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentSubmits>>;
}

/** on conflict condition type for table "assignment_submits" */
export interface StudentOrTeacherAssignmentSubmitsOnConflict {
  constraint: StudentOrTeacherAssignmentSubmitsConstraint;
  update_columns?: Array<StudentOrTeacherAssignmentSubmitsUpdateColumn>;
  where?: Maybe<StudentOrTeacherAssignmentSubmitsBoolExp>;
}

/** Ordering options when selecting data from "assignment_submits". */
export interface StudentOrTeacherAssignmentSubmitsOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  completed_at?: Maybe<StudentOrTeacherOrderBy>;
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  file?: Maybe<StudentOrTeacherOrderBy>;
  files_aggregate?: Maybe<StudentOrTeacherFilesAggregateOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_submited?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: assignment_submits */
export interface StudentOrTeacherAssignmentSubmitsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_submits" */
export const enum StudentOrTeacherAssignmentSubmitsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_submits" */
export interface StudentOrTeacherAssignmentSubmitsSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_submited?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_submits" */
export const enum StudentOrTeacherAssignmentSubmitsUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_type" */
export interface StudentOrTeacherAssignmentType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrTeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentsAggregate>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_type" */
export interface StudentOrTeacherAssignmentTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_type" */
export interface StudentOrTeacherAssignmentTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_type". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentTypeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentTypeBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentTypeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentTypeBoolExp>>;
  assignments?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  icon?: Maybe<StudentOrTeacherStringComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
}

export const enum StudentOrTeacherAssignmentTypeEnum {
  HAUSAUFGABE = 'HAUSAUFGABE',
  KLASSENARBEIT = 'KLASSENARBEIT',
  MATERIAL = 'MATERIAL',
  ONLINE = 'ONLINE',
  PRUFUNG = 'PRUFUNG',
  QUIZ = 'QUIZ',
  STUDY = 'STUDY',
  TASK = 'TASK'
};

/** Boolean expression to compare columns of type "assignment_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherAssignmentTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherAssignmentTypeEnum>;
  _in?: Maybe<Array<StudentOrTeacherAssignmentTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherAssignmentTypeEnum>;
  _nin?: Maybe<Array<StudentOrTeacherAssignmentTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_type". */
export interface StudentOrTeacherAssignmentTypeOrderBy {
  assignments_aggregate?: Maybe<StudentOrTeacherAssignmentsAggregateOrderBy>;
  icon?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignment_type" */
export const enum StudentOrTeacherAssignmentTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/**
 * All users that assignment is assigned to and the table that teachers insert grades for each of them
 *
 *
 * columns and relationships of "assignment_user"
 */
export interface StudentOrTeacherAssignmentUser {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrTeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentOrTeacherMarks>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_user" */
export interface StudentOrTeacherAssignmentUserAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentUserMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_user". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentUserBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentUserBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentUserBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentUserBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_completed?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  mark?: Maybe<StudentOrTeacherMarksBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "assignment_user" */
export interface StudentOrTeacherAssignmentUserMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "assignment_user" */
export interface StudentOrTeacherAssignmentUserMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "assignment_user" */
export interface StudentOrTeacherAssignmentUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAssignmentUser>>;
}

/** Ordering options when selecting data from "assignment_user". */
export interface StudentOrTeacherAssignmentUserOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_completed?: Maybe<StudentOrTeacherOrderBy>;
  mark?: Maybe<StudentOrTeacherMarksOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: assignment_user */
export interface StudentOrTeacherAssignmentUserPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_user" */
export const enum StudentOrTeacherAssignmentUserSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_user" */
export interface StudentOrTeacherAssignmentUserSetInput {
  is_completed?: Maybe<Scalars['Boolean']>;
}

/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignments {
  /** An object relationship */
  assignmentAttendeeType?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentAttendeeType>>;
  assignment_attendee_type?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentAttendeeTypeEnum>>;
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<StudentOrTeacherAssignmentBookChapter>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<StudentOrTeacherAssignmentFiles>>;
  /** An object relationship */
  assignment_grade_weight?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeights>>;
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestions>>;
  /** An object relationship */
  assignment_quiz?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_quizzes: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentOrTeacherAssignmentSubmits>>;
  /** An object relationship */
  assignment_type: EntireFieldWrapper<StudentOrTeacherAssignmentType>;
  /** An array relationship */
  assignment_users: EntireFieldWrapper<Array<StudentOrTeacherAssignmentUser>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<StudentOrTeacherChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrTeacherViewAssignmentClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** A computed field, executes function "assignment_due_at_filter" */
  due_at_filter?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrTeacherFiles>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrTeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrTeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "assignment_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_gradeable: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  lesson?: EntireFieldWrapper<Maybe<StudentOrTeacherLessons>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentOrTeacherAssignmentTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsAssignmentFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsAssignmentQuizzesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuizOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuizBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentSubmitsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsAssignmentUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentUserOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentUserBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentOrTeacherViewAssignmentClassBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrTeacherAssignmentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}

/** aggregated selection of "assignments" */
export interface StudentOrTeacherAssignmentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAssignments>>;
}

/** aggregate fields of "assignments" */
export interface StudentOrTeacherAssignmentsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentsVarianceFields>>;
}


/** aggregate fields of "assignments" */
export interface StudentOrTeacherAssignmentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "assignments" */
export interface StudentOrTeacherAssignmentsAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherAssignmentsAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAssignmentsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAssignmentsMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherAssignmentsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherAssignmentsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherAssignmentsStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherAssignmentsSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherAssignmentsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherAssignmentsVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherAssignmentsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrTeacherAssignmentsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsAvgOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "assignments". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAssignmentsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAssignmentsBoolExp>>;
  _not?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAssignmentsBoolExp>>;
  assignmentAttendeeType?: Maybe<StudentOrTeacherAssignmentAttendeeTypeBoolExp>;
  assignment_attendee_type?: Maybe<StudentOrTeacherAssignmentAttendeeTypeEnumComparisonExp>;
  assignment_book_chapters?: Maybe<StudentOrTeacherAssignmentBookChapterBoolExp>;
  assignment_files?: Maybe<StudentOrTeacherAssignmentFilesBoolExp>;
  assignment_grade_weight?: Maybe<StudentOrTeacherAssignmentGradeWeightsBoolExp>;
  assignment_grade_weight_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  assignment_questions?: Maybe<StudentOrTeacherAssignmentQuestionsBoolExp>;
  assignment_quiz?: Maybe<StudentOrTeacherAssignmentQuizBoolExp>;
  assignment_quizzes?: Maybe<StudentOrTeacherAssignmentQuizBoolExp>;
  assignment_submits?: Maybe<StudentOrTeacherAssignmentSubmitsBoolExp>;
  assignment_type?: Maybe<StudentOrTeacherAssignmentTypeBoolExp>;
  assignment_users?: Maybe<StudentOrTeacherAssignmentUserBoolExp>;
  chat?: Maybe<StudentOrTeacherChatsBoolExp>;
  chat_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  classes?: Maybe<StudentOrTeacherViewAssignmentClassBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  due_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  due_at_filter?: Maybe<StudentOrTeacherStringComparisonExp>;
  duration?: Maybe<StudentOrTeacherIntComparisonExp>;
  files?: Maybe<StudentOrTeacherFilesBoolExp>;
  grades?: Maybe<StudentOrTeacherGradesBoolExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_completed?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  is_everybody?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  is_gradeable?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  lesson?: Maybe<StudentOrTeacherLessonsBoolExp>;
  lesson_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  type?: Maybe<StudentOrTeacherAssignmentTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAssignmentsMaxFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsMaxOrderBy {
  assignment_grade_weight_id?: Maybe<StudentOrTeacherOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  due_at?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure_id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAssignmentsMinFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsMinOrderBy {
  assignment_grade_weight_id?: Maybe<StudentOrTeacherOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  due_at?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure_id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "assignments". */
export interface StudentOrTeacherAssignmentsOrderBy {
  assignmentAttendeeType?: Maybe<StudentOrTeacherAssignmentAttendeeTypeOrderBy>;
  assignment_attendee_type?: Maybe<StudentOrTeacherOrderBy>;
  assignment_book_chapters_aggregate?: Maybe<StudentOrTeacherAssignmentBookChapterAggregateOrderBy>;
  assignment_files_aggregate?: Maybe<StudentOrTeacherAssignmentFilesAggregateOrderBy>;
  assignment_grade_weight?: Maybe<StudentOrTeacherAssignmentGradeWeightsOrderBy>;
  assignment_grade_weight_id?: Maybe<StudentOrTeacherOrderBy>;
  assignment_questions_aggregate?: Maybe<StudentOrTeacherAssignmentQuestionsAggregateOrderBy>;
  assignment_quiz?: Maybe<StudentOrTeacherAssignmentQuizOrderBy>;
  assignment_quizzes_aggregate?: Maybe<StudentOrTeacherAssignmentQuizAggregateOrderBy>;
  assignment_submits_aggregate?: Maybe<StudentOrTeacherAssignmentSubmitsAggregateOrderBy>;
  assignment_type?: Maybe<StudentOrTeacherAssignmentTypeOrderBy>;
  assignment_users_aggregate?: Maybe<StudentOrTeacherAssignmentUserAggregateOrderBy>;
  chat?: Maybe<StudentOrTeacherChatsOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  classes_aggregate?: Maybe<StudentOrTeacherViewAssignmentClassAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  due_at?: Maybe<StudentOrTeacherOrderBy>;
  due_at_filter?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  files_aggregate?: Maybe<StudentOrTeacherFilesAggregateOrderBy>;
  grades_aggregate?: Maybe<StudentOrTeacherGradesAggregateOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_completed?: Maybe<StudentOrTeacherOrderBy>;
  is_everybody?: Maybe<StudentOrTeacherOrderBy>;
  is_gradeable?: Maybe<StudentOrTeacherOrderBy>;
  lesson?: Maybe<StudentOrTeacherLessonsOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "assignments" */
export const enum StudentOrTeacherAssignmentsSelectColumn {
  /** column name */
  ASSIGNMENT_ATTENDEE_TYPE = 'assignment_attendee_type',
  /** column name */
  ASSIGNMENT_GRADE_WEIGHT_ID = 'assignment_grade_weight_id',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_GRADEABLE = 'is_gradeable',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate stddev on columns */
export interface StudentOrTeacherAssignmentsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsStddevOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrTeacherAssignmentsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsStddevPopOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrTeacherAssignmentsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsStddevSampOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrTeacherAssignmentsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsSumOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrTeacherAssignmentsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsVarPopOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrTeacherAssignmentsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsVarSampOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrTeacherAssignmentsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "assignments" */
export interface StudentOrTeacherAssignmentsVarianceOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "attendance_types" */
export interface StudentOrTeacherAttendanceTypes {
  icon: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "attendance_types". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAttendanceTypesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAttendanceTypesBoolExp>>;
  _not?: Maybe<StudentOrTeacherAttendanceTypesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAttendanceTypesBoolExp>>;
  icon?: Maybe<StudentOrTeacherStringComparisonExp>;
  text?: Maybe<StudentOrTeacherStringComparisonExp>;
  value?: Maybe<StudentOrTeacherStringComparisonExp>;
}

/** Ordering options when selecting data from "attendance_types". */
export interface StudentOrTeacherAttendanceTypesOrderBy {
  icon?: Maybe<StudentOrTeacherOrderBy>;
  text?: Maybe<StudentOrTeacherOrderBy>;
  value?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "attendance_types" */
export const enum StudentOrTeacherAttendanceTypesSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  TEXT = 'text',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "attendances" */
export interface StudentOrTeacherAttendances {
  attendance_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  class: EntireFieldWrapper<StudentOrTeacherTeachingStructures>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  semester: EntireFieldWrapper<StudentOrTeacherTeachingStructures>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  student?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentOrTeacherTeachingStructures>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  teacher?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  type?: EntireFieldWrapper<Maybe<StudentOrTeacherAttendanceTypes>>;
}

/** Boolean expression to filter rows from the table "attendances". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAttendancesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAttendancesBoolExp>>;
  _not?: Maybe<StudentOrTeacherAttendancesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAttendancesBoolExp>>;
  attendance_type?: Maybe<StudentOrTeacherStringComparisonExp>;
  class?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  comment?: Maybe<StudentOrTeacherStringComparisonExp>;
  date?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  semester?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  semester_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teacher_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  type?: Maybe<StudentOrTeacherAttendanceTypesBoolExp>;
}

/** Ordering options when selecting data from "attendances". */
export interface StudentOrTeacherAttendancesOrderBy {
  attendance_type?: Maybe<StudentOrTeacherOrderBy>;
  class?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  date?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  semester?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherAttendanceTypesOrderBy>;
}

/** select columns of table "attendances" */
export const enum StudentOrTeacherAttendancesSelectColumn {
  /** column name */
  ATTENDANCE_TYPE = 'attendance_type',
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProviders {
  /** An object relationship */
  account: EntireFieldWrapper<StudentOrTeacherAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  auth_provider: EntireFieldWrapper<Scalars['String']>;
  auth_provider_unique_id: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  provider: EntireFieldWrapper<StudentOrTeacherAuthProviders>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountProviders>>;
}

/** aggregate fields of "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProvidersMinFields>>;
}


/** aggregate fields of "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAuthAccountProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAuthAccountProvidersMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAuthAccountProvidersMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersArrRelInsertInput {
  data: Array<StudentOrTeacherAuthAccountProvidersInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAuthAccountProvidersOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_providers". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAuthAccountProvidersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAuthAccountProvidersBoolExp>>;
  _not?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAuthAccountProvidersBoolExp>>;
  account?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
  account_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  auth_provider?: Maybe<StudentOrTeacherStringComparisonExp>;
  auth_provider_unique_id?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  provider?: Maybe<StudentOrTeacherAuthProvidersBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "auth.account_providers" */
export const enum StudentOrTeacherAuthAccountProvidersConstraint {
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_ACCOUNT_ID_AUTH_PROVIDER_KEY = 'account_providers_account_id_auth_provider_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_AUTH_PROVIDER_AUTH_PROVIDER_UNIQUE_ID_KEY = 'account_providers_auth_provider_auth_provider_unique_id_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_PKEY = 'account_providers_pkey'
};

/** input type for inserting data into table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersInsertInput {
  account?: Maybe<StudentOrTeacherAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<StudentOrTeacherAuthProvidersObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAuthAccountProvidersMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersMaxOrderBy {
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  auth_provider?: Maybe<StudentOrTeacherOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAuthAccountProvidersMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersMinOrderBy {
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  auth_provider?: Maybe<StudentOrTeacherOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountProviders>>;
}

/** on conflict condition type for table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersOnConflict {
  constraint: StudentOrTeacherAuthAccountProvidersConstraint;
  update_columns?: Array<StudentOrTeacherAuthAccountProvidersUpdateColumn>;
  where?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.account_providers". */
export interface StudentOrTeacherAuthAccountProvidersOrderBy {
  account?: Maybe<StudentOrTeacherAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  auth_provider?: Maybe<StudentOrTeacherOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  provider?: Maybe<StudentOrTeacherAuthProvidersOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: auth_account_providers */
export interface StudentOrTeacherAuthAccountProvidersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_providers" */
export const enum StudentOrTeacherAuthAccountProvidersSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "auth.account_providers" */
export interface StudentOrTeacherAuthAccountProvidersSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "auth.account_providers" */
export const enum StudentOrTeacherAuthAccountProvidersUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRoles {
  /** An object relationship */
  account: EntireFieldWrapper<StudentOrTeacherAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<StudentOrTeacherAuthRoles>;
}

/** aggregated selection of "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountRoles>>;
}

/** aggregate fields of "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRolesMinFields>>;
}


/** aggregate fields of "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAuthAccountRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAuthAccountRolesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAuthAccountRolesMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesArrRelInsertInput {
  data: Array<StudentOrTeacherAuthAccountRolesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAuthAccountRolesOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_roles". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAuthAccountRolesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAuthAccountRolesBoolExp>>;
  _not?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAuthAccountRolesBoolExp>>;
  account?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
  account_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  role?: Maybe<StudentOrTeacherStringComparisonExp>;
  roleByRole?: Maybe<StudentOrTeacherAuthRolesBoolExp>;
}

/** unique or primary key constraints on table "auth.account_roles" */
export const enum StudentOrTeacherAuthAccountRolesConstraint {
  /** unique or primary key constraint */
  ACCOUNT_ROLES_PKEY = 'account_roles_pkey',
  /** unique or primary key constraint */
  USER_ROLES_ACCOUNT_ID_ROLE_KEY = 'user_roles_account_id_role_key'
};

/** input type for inserting data into table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesInsertInput {
  account?: Maybe<StudentOrTeacherAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<StudentOrTeacherAuthRolesObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAuthAccountRolesMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by max() on columns of table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesMaxOrderBy {
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  role?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAuthAccountRolesMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by min() on columns of table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesMinOrderBy {
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  role?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountRoles>>;
}

/** on conflict condition type for table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesOnConflict {
  constraint: StudentOrTeacherAuthAccountRolesConstraint;
  update_columns?: Array<StudentOrTeacherAuthAccountRolesUpdateColumn>;
  where?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.account_roles". */
export interface StudentOrTeacherAuthAccountRolesOrderBy {
  account?: Maybe<StudentOrTeacherAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  role?: Maybe<StudentOrTeacherOrderBy>;
  roleByRole?: Maybe<StudentOrTeacherAuthRolesOrderBy>;
}

/** primary key columns input for table: auth_account_roles */
export interface StudentOrTeacherAuthAccountRolesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_roles" */
export const enum StudentOrTeacherAuthAccountRolesSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.account_roles" */
export interface StudentOrTeacherAuthAccountRolesSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.account_roles" */
export const enum StudentOrTeacherAuthAccountRolesUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** columns and relationships of "auth.accounts" */
export interface StudentOrTeacherAuthAccounts {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountProvidersAggregate>;
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountRolesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  default_role: EntireFieldWrapper<Scalars['String']>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbers>>;
  is_active: EntireFieldWrapper<Scalars['Boolean']>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  refresh_tokens: EntireFieldWrapper<Array<StudentOrTeacherAuthRefreshTokens>>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: EntireFieldWrapper<StudentOrTeacherAuthRefreshTokensAggregate>;
  /** An object relationship */
  role: EntireFieldWrapper<StudentOrTeacherAuthRoles>;
  ticket: EntireFieldWrapper<Scalars['uuid']>;
  ticket_expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsRefreshTokensArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthRefreshTokensBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthRefreshTokensBoolExp>;
}

/** aggregated selection of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAuthAccounts>>;
}

/** aggregate fields of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountsMinFields>>;
}


/** aggregate fields of "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAuthAccountsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAuthAccountsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAuthAccountsMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsArrRelInsertInput {
  data: Array<StudentOrTeacherAuthAccountsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAuthAccountsOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.accounts". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAuthAccountsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAuthAccountsBoolExp>>;
  _not?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAuthAccountsBoolExp>>;
  account_providers?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
  account_roles?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  default_role?: Maybe<StudentOrTeacherStringComparisonExp>;
  email?: Maybe<StudentOrTeacherCitextComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  insurance_number?: Maybe<StudentOrTeacherPrivateInsuranceNumbersBoolExp>;
  is_active?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  new_email?: Maybe<StudentOrTeacherCitextComparisonExp>;
  password_hash?: Maybe<StudentOrTeacherStringComparisonExp>;
  refresh_tokens?: Maybe<StudentOrTeacherAuthRefreshTokensBoolExp>;
  role?: Maybe<StudentOrTeacherAuthRolesBoolExp>;
  ticket?: Maybe<StudentOrTeacherUuidComparisonExp>;
  ticket_expires_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user?: Maybe<StudentOrTeacherUsersBoolExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.accounts" */
export const enum StudentOrTeacherAuthAccountsConstraint {
  /** unique or primary key constraint */
  ACCOUNTS_EMAIL_KEY = 'accounts_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_NEW_EMAIL_KEY = 'accounts_new_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_PKEY = 'accounts_pkey',
  /** unique or primary key constraint */
  ACCOUNTS_USER_ID_KEY = 'accounts_user_id_key'
};

/** input type for inserting data into table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsInsertInput {
  account_providers?: Maybe<StudentOrTeacherAuthAccountProvidersArrRelInsertInput>;
  account_roles?: Maybe<StudentOrTeacherAuthAccountRolesArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<StudentOrTeacherPrivateInsuranceNumbersObjRelInsertInput>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  refresh_tokens?: Maybe<StudentOrTeacherAuthRefreshTokensArrRelInsertInput>;
  role?: Maybe<StudentOrTeacherAuthRolesObjRelInsertInput>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrTeacherUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAuthAccountsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  default_role?: Maybe<StudentOrTeacherOrderBy>;
  email?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  new_email?: Maybe<StudentOrTeacherOrderBy>;
  password_hash?: Maybe<StudentOrTeacherOrderBy>;
  ticket?: Maybe<StudentOrTeacherOrderBy>;
  ticket_expires_at?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAuthAccountsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  default_role?: Maybe<StudentOrTeacherOrderBy>;
  email?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  new_email?: Maybe<StudentOrTeacherOrderBy>;
  password_hash?: Maybe<StudentOrTeacherOrderBy>;
  ticket?: Maybe<StudentOrTeacherOrderBy>;
  ticket_expires_at?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAuthAccounts>>;
}

/** input type for inserting object relation for remote table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsObjRelInsertInput {
  data: StudentOrTeacherAuthAccountsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAuthAccountsOnConflict>;
}

/** on conflict condition type for table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsOnConflict {
  constraint: StudentOrTeacherAuthAccountsConstraint;
  update_columns?: Array<StudentOrTeacherAuthAccountsUpdateColumn>;
  where?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
}

/** Ordering options when selecting data from "auth.accounts". */
export interface StudentOrTeacherAuthAccountsOrderBy {
  account_providers_aggregate?: Maybe<StudentOrTeacherAuthAccountProvidersAggregateOrderBy>;
  account_roles_aggregate?: Maybe<StudentOrTeacherAuthAccountRolesAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  default_role?: Maybe<StudentOrTeacherOrderBy>;
  email?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  insurance_number?: Maybe<StudentOrTeacherPrivateInsuranceNumbersOrderBy>;
  is_active?: Maybe<StudentOrTeacherOrderBy>;
  new_email?: Maybe<StudentOrTeacherOrderBy>;
  password_hash?: Maybe<StudentOrTeacherOrderBy>;
  refresh_tokens_aggregate?: Maybe<StudentOrTeacherAuthRefreshTokensAggregateOrderBy>;
  role?: Maybe<StudentOrTeacherAuthRolesOrderBy>;
  ticket?: Maybe<StudentOrTeacherOrderBy>;
  ticket_expires_at?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user?: Maybe<StudentOrTeacherUsersOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: auth_accounts */
export interface StudentOrTeacherAuthAccountsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.accounts" */
export const enum StudentOrTeacherAuthAccountsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "auth.accounts" */
export interface StudentOrTeacherAuthAccountsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.accounts" */
export const enum StudentOrTeacherAuthAccountsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "auth.providers" */
export interface StudentOrTeacherAuthProviders {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountProvidersAggregate>;
  provider: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.providers" */
export interface StudentOrTeacherAuthProvidersAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.providers" */
export interface StudentOrTeacherAuthProvidersAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
}

/** aggregated selection of "auth.providers" */
export interface StudentOrTeacherAuthProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAuthProviders>>;
}

/** aggregate fields of "auth.providers" */
export interface StudentOrTeacherAuthProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProvidersMinFields>>;
}


/** aggregate fields of "auth.providers" */
export interface StudentOrTeacherAuthProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAuthProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAuthProvidersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAuthProvidersBoolExp>>;
  _not?: Maybe<StudentOrTeacherAuthProvidersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAuthProvidersBoolExp>>;
  account_providers?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
  provider?: Maybe<StudentOrTeacherStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.providers" */
export const enum StudentOrTeacherAuthProvidersConstraint {
  /** unique or primary key constraint */
  PROVIDERS_PKEY = 'providers_pkey'
};

/** input type for inserting data into table "auth.providers" */
export interface StudentOrTeacherAuthProvidersInsertInput {
  account_providers?: Maybe<StudentOrTeacherAuthAccountProvidersArrRelInsertInput>;
  provider?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAuthProvidersMaxFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAuthProvidersMinFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.providers" */
export interface StudentOrTeacherAuthProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAuthProviders>>;
}

/** input type for inserting object relation for remote table "auth.providers" */
export interface StudentOrTeacherAuthProvidersObjRelInsertInput {
  data: StudentOrTeacherAuthProvidersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAuthProvidersOnConflict>;
}

/** on conflict condition type for table "auth.providers" */
export interface StudentOrTeacherAuthProvidersOnConflict {
  constraint: StudentOrTeacherAuthProvidersConstraint;
  update_columns?: Array<StudentOrTeacherAuthProvidersUpdateColumn>;
  where?: Maybe<StudentOrTeacherAuthProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.providers". */
export interface StudentOrTeacherAuthProvidersOrderBy {
  account_providers_aggregate?: Maybe<StudentOrTeacherAuthAccountProvidersAggregateOrderBy>;
  provider?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: auth_providers */
export interface StudentOrTeacherAuthProvidersPkColumnsInput {
  provider: Scalars['String'];
}

/** select columns of table "auth.providers" */
export const enum StudentOrTeacherAuthProvidersSelectColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** input type for updating data in table "auth.providers" */
export interface StudentOrTeacherAuthProvidersSetInput {
  provider?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.providers" */
export const enum StudentOrTeacherAuthProvidersUpdateColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** columns and relationships of "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokens {
  /** An object relationship */
  account: EntireFieldWrapper<StudentOrTeacherAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  refresh_token: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokensAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAuthRefreshTokens>>;
}

/** aggregate fields of "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokensMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokensMinFields>>;
}


/** aggregate fields of "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAuthRefreshTokensSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherAuthRefreshTokensMaxOrderBy>;
  min?: Maybe<StudentOrTeacherAuthRefreshTokensMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensArrRelInsertInput {
  data: Array<StudentOrTeacherAuthRefreshTokensInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAuthRefreshTokensOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAuthRefreshTokensBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAuthRefreshTokensBoolExp>>;
  _not?: Maybe<StudentOrTeacherAuthRefreshTokensBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAuthRefreshTokensBoolExp>>;
  account?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
  account_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  expires_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  refresh_token?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.refresh_tokens" */
export const enum StudentOrTeacherAuthRefreshTokensConstraint {
  /** unique or primary key constraint */
  REFRESH_TOKENS_PKEY = 'refresh_tokens_pkey'
};

/** input type for inserting data into table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensInsertInput {
  account?: Maybe<StudentOrTeacherAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAuthRefreshTokensMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensMaxOrderBy {
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  expires_at?: Maybe<StudentOrTeacherOrderBy>;
  refresh_token?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAuthRefreshTokensMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensMinOrderBy {
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  expires_at?: Maybe<StudentOrTeacherOrderBy>;
  refresh_token?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAuthRefreshTokens>>;
}

/** on conflict condition type for table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensOnConflict {
  constraint: StudentOrTeacherAuthRefreshTokensConstraint;
  update_columns?: Array<StudentOrTeacherAuthRefreshTokensUpdateColumn>;
  where?: Maybe<StudentOrTeacherAuthRefreshTokensBoolExp>;
}

/** Ordering options when selecting data from "auth.refresh_tokens". */
export interface StudentOrTeacherAuthRefreshTokensOrderBy {
  account?: Maybe<StudentOrTeacherAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  expires_at?: Maybe<StudentOrTeacherOrderBy>;
  refresh_token?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: auth_refresh_tokens */
export interface StudentOrTeacherAuthRefreshTokensPkColumnsInput {
  refresh_token: Scalars['uuid'];
}

/** select columns of table "auth.refresh_tokens" */
export const enum StudentOrTeacherAuthRefreshTokensSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** input type for updating data in table "auth.refresh_tokens" */
export interface StudentOrTeacherAuthRefreshTokensSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.refresh_tokens" */
export const enum StudentOrTeacherAuthRefreshTokensUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** columns and relationships of "auth.roles" */
export interface StudentOrTeacherAuthRoles {
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountRolesAggregate>;
  /** An array relationship */
  accounts: EntireFieldWrapper<Array<StudentOrTeacherAuthAccounts>>;
  /** An aggregate relationship */
  accounts_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountsAggregate>;
  role: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrTeacherAuthRolesAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrTeacherAuthRolesAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrTeacherAuthRolesAccountsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrTeacherAuthRolesAccountsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
}

/** aggregated selection of "auth.roles" */
export interface StudentOrTeacherAuthRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherAuthRoles>>;
}

/** aggregate fields of "auth.roles" */
export interface StudentOrTeacherAuthRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRolesMinFields>>;
}


/** aggregate fields of "auth.roles" */
export interface StudentOrTeacherAuthRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherAuthRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherAuthRolesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherAuthRolesBoolExp>>;
  _not?: Maybe<StudentOrTeacherAuthRolesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherAuthRolesBoolExp>>;
  account_roles?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
  accounts?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
  role?: Maybe<StudentOrTeacherStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.roles" */
export const enum StudentOrTeacherAuthRolesConstraint {
  /** unique or primary key constraint */
  ROLES_PKEY = 'roles_pkey'
};

/** input type for inserting data into table "auth.roles" */
export interface StudentOrTeacherAuthRolesInsertInput {
  account_roles?: Maybe<StudentOrTeacherAuthAccountRolesArrRelInsertInput>;
  accounts?: Maybe<StudentOrTeacherAuthAccountsArrRelInsertInput>;
  role?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherAuthRolesMaxFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherAuthRolesMinFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.roles" */
export interface StudentOrTeacherAuthRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherAuthRoles>>;
}

/** input type for inserting object relation for remote table "auth.roles" */
export interface StudentOrTeacherAuthRolesObjRelInsertInput {
  data: StudentOrTeacherAuthRolesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherAuthRolesOnConflict>;
}

/** on conflict condition type for table "auth.roles" */
export interface StudentOrTeacherAuthRolesOnConflict {
  constraint: StudentOrTeacherAuthRolesConstraint;
  update_columns?: Array<StudentOrTeacherAuthRolesUpdateColumn>;
  where?: Maybe<StudentOrTeacherAuthRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.roles". */
export interface StudentOrTeacherAuthRolesOrderBy {
  account_roles_aggregate?: Maybe<StudentOrTeacherAuthAccountRolesAggregateOrderBy>;
  accounts_aggregate?: Maybe<StudentOrTeacherAuthAccountsAggregateOrderBy>;
  role?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: auth_roles */
export interface StudentOrTeacherAuthRolesPkColumnsInput {
  role: Scalars['String'];
}

/** select columns of table "auth.roles" */
export const enum StudentOrTeacherAuthRolesSelectColumn {
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.roles" */
export interface StudentOrTeacherAuthRolesSetInput {
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.roles" */
export const enum StudentOrTeacherAuthRolesUpdateColumn {
  /** column name */
  ROLE = 'role'
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherBigintComparisonExp {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
}

/** columns and relationships of "book_chapter_type" */
export interface StudentOrTeacherBookChapterType {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrTeacherBookChapters>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "book_chapter_type" */
export interface StudentOrTeacherBookChapterTypeBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookChaptersOrderBy>>;
  where?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
}

/** Boolean expression to filter rows from the table "book_chapter_type". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherBookChapterTypeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherBookChapterTypeBoolExp>>;
  _not?: Maybe<StudentOrTeacherBookChapterTypeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherBookChapterTypeBoolExp>>;
  book_chapters?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
}

export const enum StudentOrTeacherBookChapterTypeEnum {
  HTML = 'HTML',
  QUIZZ = 'QUIZZ'
};

/** Boolean expression to compare columns of type "book_chapter_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherBookChapterTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherBookChapterTypeEnum>;
  _in?: Maybe<Array<StudentOrTeacherBookChapterTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherBookChapterTypeEnum>;
  _nin?: Maybe<Array<StudentOrTeacherBookChapterTypeEnum>>;
}

/** Ordering options when selecting data from "book_chapter_type". */
export interface StudentOrTeacherBookChapterTypeOrderBy {
  book_chapters_aggregate?: Maybe<StudentOrTeacherBookChaptersAggregateOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "book_chapter_type" */
export const enum StudentOrTeacherBookChapterTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "book_chapters" */
export interface StudentOrTeacherBookChapters {
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<StudentOrTeacherAssignmentBookChapter>>;
  /** An object relationship */
  book: EntireFieldWrapper<StudentOrTeacherBooks>;
  /** An object relationship */
  book_chapter_type: EntireFieldWrapper<StudentOrTeacherBookChapterType>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrTeacherChapterSections>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  due_at: EntireFieldWrapper<Scalars['date']>;
  /** A computed field, executes function "book_chapter_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentOrTeacherBookChapterTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "book_chapters" */
export interface StudentOrTeacherBookChaptersAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "book_chapters" */
export interface StudentOrTeacherBookChaptersChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
}

/** order by aggregate values of table "book_chapters" */
export interface StudentOrTeacherBookChaptersAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherBookChaptersMaxOrderBy>;
  min?: Maybe<StudentOrTeacherBookChaptersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_chapters". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherBookChaptersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherBookChaptersBoolExp>>;
  _not?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherBookChaptersBoolExp>>;
  assignment_book_chapters?: Maybe<StudentOrTeacherAssignmentBookChapterBoolExp>;
  book?: Maybe<StudentOrTeacherBooksBoolExp>;
  book_chapter_type?: Maybe<StudentOrTeacherBookChapterTypeBoolExp>;
  book_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  chapter_sections?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  due_at?: Maybe<StudentOrTeacherDateComparisonExp>;
  duration_left?: Maybe<StudentOrTeacherBigintComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  status?: Maybe<StudentOrTeacherStringComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  type?: Maybe<StudentOrTeacherBookChapterTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "book_chapters" */
export interface StudentOrTeacherBookChaptersMaxOrderBy {
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  due_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "book_chapters" */
export interface StudentOrTeacherBookChaptersMinOrderBy {
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  due_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "book_chapters". */
export interface StudentOrTeacherBookChaptersOrderBy {
  assignment_book_chapters_aggregate?: Maybe<StudentOrTeacherAssignmentBookChapterAggregateOrderBy>;
  book?: Maybe<StudentOrTeacherBooksOrderBy>;
  book_chapter_type?: Maybe<StudentOrTeacherBookChapterTypeOrderBy>;
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  chapter_sections_aggregate?: Maybe<StudentOrTeacherChapterSectionsAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  due_at?: Maybe<StudentOrTeacherOrderBy>;
  duration_left?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "book_chapters" */
export const enum StudentOrTeacherBookChaptersSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "book_course" */
export interface StudentOrTeacherBookCourse {
  /** An object relationship */
  book: EntireFieldWrapper<StudentOrTeacherBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrTeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_course" */
export interface StudentOrTeacherBookCourseAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherBookCourseMaxOrderBy>;
  min?: Maybe<StudentOrTeacherBookCourseMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_course". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherBookCourseBoolExp {
  _and?: Maybe<Array<StudentOrTeacherBookCourseBoolExp>>;
  _not?: Maybe<StudentOrTeacherBookCourseBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherBookCourseBoolExp>>;
  book?: Maybe<StudentOrTeacherBooksBoolExp>;
  book_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  course?: Maybe<StudentOrTeacherCoursesBoolExp>;
  course_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "book_course" */
export interface StudentOrTeacherBookCourseMaxOrderBy {
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "book_course" */
export interface StudentOrTeacherBookCourseMinOrderBy {
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "book_course". */
export interface StudentOrTeacherBookCourseOrderBy {
  book?: Maybe<StudentOrTeacherBooksOrderBy>;
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  course?: Maybe<StudentOrTeacherCoursesOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "book_course" */
export const enum StudentOrTeacherBookCourseSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "book_user" */
export interface StudentOrTeacherBookUser {
  /** An object relationship */
  book: EntireFieldWrapper<StudentOrTeacherBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_user" */
export interface StudentOrTeacherBookUserAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherBookUserMaxOrderBy>;
  min?: Maybe<StudentOrTeacherBookUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_user". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherBookUserBoolExp {
  _and?: Maybe<Array<StudentOrTeacherBookUserBoolExp>>;
  _not?: Maybe<StudentOrTeacherBookUserBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherBookUserBoolExp>>;
  book?: Maybe<StudentOrTeacherBooksBoolExp>;
  book_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "book_user" */
export interface StudentOrTeacherBookUserMaxOrderBy {
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "book_user" */
export interface StudentOrTeacherBookUserMinOrderBy {
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "book_user". */
export interface StudentOrTeacherBookUserOrderBy {
  book?: Maybe<StudentOrTeacherBooksOrderBy>;
  book_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "book_user" */
export const enum StudentOrTeacherBookUserSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "books" */
export interface StudentOrTeacherBooks {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrTeacherBookChapters>>;
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<StudentOrTeacherBookCourse>>;
  /** An array relationship */
  book_users: EntireFieldWrapper<Array<StudentOrTeacherBookUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentOrTeacherSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "books" */
export interface StudentOrTeacherBooksBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookChaptersOrderBy>>;
  where?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
}


/** columns and relationships of "books" */
export interface StudentOrTeacherBooksBookCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookCourseOrderBy>>;
  where?: Maybe<StudentOrTeacherBookCourseBoolExp>;
}


/** columns and relationships of "books" */
export interface StudentOrTeacherBooksBookUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookUserOrderBy>>;
  where?: Maybe<StudentOrTeacherBookUserBoolExp>;
}

/** order by aggregate values of table "books" */
export interface StudentOrTeacherBooksAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherBooksAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherBooksMaxOrderBy>;
  min?: Maybe<StudentOrTeacherBooksMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherBooksStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherBooksStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherBooksStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherBooksSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherBooksVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherBooksVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherBooksVarianceOrderBy>;
}

/** order by avg() on columns of table "books" */
export interface StudentOrTeacherBooksAvgOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "books". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherBooksBoolExp {
  _and?: Maybe<Array<StudentOrTeacherBooksBoolExp>>;
  _not?: Maybe<StudentOrTeacherBooksBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherBooksBoolExp>>;
  book_chapters?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
  book_courses?: Maybe<StudentOrTeacherBookCourseBoolExp>;
  book_users?: Maybe<StudentOrTeacherBookUserBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  sort?: Maybe<StudentOrTeacherIntComparisonExp>;
  status?: Maybe<StudentOrTeacherStringComparisonExp>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "books" */
export interface StudentOrTeacherBooksMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "books" */
export interface StudentOrTeacherBooksMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "books". */
export interface StudentOrTeacherBooksOrderBy {
  book_chapters_aggregate?: Maybe<StudentOrTeacherBookChaptersAggregateOrderBy>;
  book_courses_aggregate?: Maybe<StudentOrTeacherBookCourseAggregateOrderBy>;
  book_users_aggregate?: Maybe<StudentOrTeacherBookUserAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "books" */
export const enum StudentOrTeacherBooksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "books" */
export interface StudentOrTeacherBooksStddevOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "books" */
export interface StudentOrTeacherBooksStddevPopOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "books" */
export interface StudentOrTeacherBooksStddevSampOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by sum() on columns of table "books" */
export interface StudentOrTeacherBooksSumOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_pop() on columns of table "books" */
export interface StudentOrTeacherBooksVarPopOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_samp() on columns of table "books" */
export interface StudentOrTeacherBooksVarSampOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by variance() on columns of table "books" */
export interface StudentOrTeacherBooksVarianceOrderBy {
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/**
 * DEPRECATED - change to assignments_notes
 *
 *
 * columns and relationships of "chapter_section_notes"
 */
export interface StudentOrTeacherChapterSectionNotes {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chapter_section: EntireFieldWrapper<StudentOrTeacherChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrTeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
}

/** order by aggregate values of table "chapter_section_notes" */
export interface StudentOrTeacherChapterSectionNotesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChapterSectionNotesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChapterSectionNotesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_notes". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChapterSectionNotesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChapterSectionNotesBoolExp>>;
  _not?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChapterSectionNotesBoolExp>>;
  body?: Maybe<StudentOrTeacherStringComparisonExp>;
  chapter_section?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "chapter_section_notes" */
export const enum StudentOrTeacherChapterSectionNotesConstraint {
  /** unique or primary key constraint */
  CHAPTER_SECTION_NOTES_PKEY = 'chapter_section_notes_pkey'
};

/** input type for inserting data into table "chapter_section_notes" */
export interface StudentOrTeacherChapterSectionNotesInsertInput {
  body?: Maybe<Scalars['String']>;
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chapter_section_notes" */
export interface StudentOrTeacherChapterSectionNotesMaxOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  chapter_section_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "chapter_section_notes" */
export interface StudentOrTeacherChapterSectionNotesMinOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  chapter_section_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "chapter_section_notes" */
export interface StudentOrTeacherChapterSectionNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionNotes>>;
}

/** on conflict condition type for table "chapter_section_notes" */
export interface StudentOrTeacherChapterSectionNotesOnConflict {
  constraint: StudentOrTeacherChapterSectionNotesConstraint;
  update_columns?: Array<StudentOrTeacherChapterSectionNotesUpdateColumn>;
  where?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
}

/** Ordering options when selecting data from "chapter_section_notes". */
export interface StudentOrTeacherChapterSectionNotesOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  chapter_section?: Maybe<StudentOrTeacherChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: chapter_section_notes */
export interface StudentOrTeacherChapterSectionNotesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chapter_section_notes" */
export const enum StudentOrTeacherChapterSectionNotesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "chapter_section_notes" */
export interface StudentOrTeacherChapterSectionNotesSetInput {
  body?: Maybe<Scalars['String']>;
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "chapter_section_notes" */
export const enum StudentOrTeacherChapterSectionNotesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmits {
  /** An object relationship */
  chapter_section: EntireFieldWrapper<StudentOrTeacherChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration_spent: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrTeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherChapterSectionSubmitsAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChapterSectionSubmitsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChapterSectionSubmitsMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherChapterSectionSubmitsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherChapterSectionSubmitsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherChapterSectionSubmitsStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherChapterSectionSubmitsSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherChapterSectionSubmitsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherChapterSectionSubmitsVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherChapterSectionSubmitsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsAvgOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_submits". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChapterSectionSubmitsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsBoolExp>>;
  _not?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsBoolExp>>;
  chapter_section?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  duration_spent?: Maybe<StudentOrTeacherIntComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_completed?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "chapter_section_submits" */
export const enum StudentOrTeacherChapterSectionSubmitsConstraint {
  /** unique or primary key constraint */
  CHAPTER_SECTION_STUDENT_PKEY = 'chapter_section_student_pkey',
  /** unique or primary key constraint */
  CHAPTER_SECTION_SUBMITS_CHAPTER_SECTION_ID_STUDENT_ID_KEY = 'chapter_section_submits_chapter_section_id_student_id_key'
};

/** input type for incrementing numeric columns in table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsIncInput {
  duration_spent?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsInsertInput {
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration_spent?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsMaxOrderBy {
  chapter_section_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsMinOrderBy {
  chapter_section_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionSubmits>>;
}

/** on conflict condition type for table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsOnConflict {
  constraint: StudentOrTeacherChapterSectionSubmitsConstraint;
  update_columns?: Array<StudentOrTeacherChapterSectionSubmitsUpdateColumn>;
  where?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
}

/** Ordering options when selecting data from "chapter_section_submits". */
export interface StudentOrTeacherChapterSectionSubmitsOrderBy {
  chapter_section?: Maybe<StudentOrTeacherChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_completed?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: chapter_section_submits */
export interface StudentOrTeacherChapterSectionSubmitsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chapter_section_submits" */
export const enum StudentOrTeacherChapterSectionSubmitsSelectColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsSetInput {
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration_spent?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by stddev() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsStddevOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsStddevPopOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsStddevSampOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by sum() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsSumOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** update columns of table "chapter_section_submits" */
export const enum StudentOrTeacherChapterSectionSubmitsUpdateColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by var_pop() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsVarPopOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_samp() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsVarSampOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by variance() on columns of table "chapter_section_submits" */
export interface StudentOrTeacherChapterSectionSubmitsVarianceOrderBy {
  duration_spent?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "chapter_section_type" */
export interface StudentOrTeacherChapterSectionType {
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrTeacherChapterSections>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chapter_section_type" */
export interface StudentOrTeacherChapterSectionTypeChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
}

/** Boolean expression to filter rows from the table "chapter_section_type". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChapterSectionTypeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChapterSectionTypeBoolExp>>;
  _not?: Maybe<StudentOrTeacherChapterSectionTypeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChapterSectionTypeBoolExp>>;
  chapter_sections?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
  icon?: Maybe<StudentOrTeacherStringComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
}

export const enum StudentOrTeacherChapterSectionTypeEnum {
  HTML = 'HTML',
  INFORMATION = 'Information',
  QUIZZ = 'Quizz'
};

/** Boolean expression to compare columns of type "chapter_section_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherChapterSectionTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherChapterSectionTypeEnum>;
  _in?: Maybe<Array<StudentOrTeacherChapterSectionTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherChapterSectionTypeEnum>;
  _nin?: Maybe<Array<StudentOrTeacherChapterSectionTypeEnum>>;
}

/** Ordering options when selecting data from "chapter_section_type". */
export interface StudentOrTeacherChapterSectionTypeOrderBy {
  chapter_sections_aggregate?: Maybe<StudentOrTeacherChapterSectionsAggregateOrderBy>;
  icon?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "chapter_section_type" */
export const enum StudentOrTeacherChapterSectionTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chapter_sections" */
export interface StudentOrTeacherChapterSections {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<StudentOrTeacherBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionSubmits>>;
  /** An object relationship */
  chapter_section_type: EntireFieldWrapper<StudentOrTeacherChapterSectionType>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** A computed field, executes function "section_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "section_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentOrTeacherChapterSectionTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "chapter_sections" */
export interface StudentOrTeacherChapterSectionsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
}


/** columns and relationships of "chapter_sections" */
export interface StudentOrTeacherChapterSectionsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
}

/** order by aggregate values of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherChapterSectionsAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChapterSectionsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChapterSectionsMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherChapterSectionsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherChapterSectionsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherChapterSectionsStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherChapterSectionsSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherChapterSectionsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherChapterSectionsVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherChapterSectionsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsAvgOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_sections". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChapterSectionsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChapterSectionsBoolExp>>;
  _not?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChapterSectionsBoolExp>>;
  body?: Maybe<StudentOrTeacherStringComparisonExp>;
  book_chapter?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
  book_chapter_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  chapter_section_notes?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
  chapter_section_type?: Maybe<StudentOrTeacherChapterSectionTypeBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  duration?: Maybe<StudentOrTeacherIntComparisonExp>;
  duration_left?: Maybe<StudentOrTeacherIntComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_completed?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  sort?: Maybe<StudentOrTeacherIntComparisonExp>;
  status?: Maybe<StudentOrTeacherStringComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  type?: Maybe<StudentOrTeacherChapterSectionTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsMaxOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  book_chapter_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsMinOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  book_chapter_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "chapter_sections". */
export interface StudentOrTeacherChapterSectionsOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  book_chapter?: Maybe<StudentOrTeacherBookChaptersOrderBy>;
  book_chapter_id?: Maybe<StudentOrTeacherOrderBy>;
  chapter_section_notes_aggregate?: Maybe<StudentOrTeacherChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<StudentOrTeacherChapterSectionSubmitsAggregateOrderBy>;
  chapter_section_type?: Maybe<StudentOrTeacherChapterSectionTypeOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  duration_left?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_completed?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "chapter_sections" */
export const enum StudentOrTeacherChapterSectionsSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsStddevOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsStddevPopOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsStddevSampOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by sum() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsSumOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_pop() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsVarPopOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_samp() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsVarSampOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by variance() on columns of table "chapter_sections" */
export interface StudentOrTeacherChapterSectionsVarianceOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
  sort?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikes {
  chat_like_user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessages>>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherChatMessageLikes>>;
}

/** aggregate fields of "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikesMinFields>>;
}


/** aggregate fields of "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherChatMessageLikesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChatMessageLikesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChatMessageLikesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesArrRelInsertInput {
  data: Array<StudentOrTeacherChatMessageLikesInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_message_likes". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChatMessageLikesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChatMessageLikesBoolExp>>;
  _not?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChatMessageLikesBoolExp>>;
  chat_message?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** input type for inserting data into table "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesInsertInput {
  chat_message?: Maybe<StudentOrTeacherChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherChatMessageLikesMaxFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesMaxOrderBy {
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherChatMessageLikesMinFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesMinOrderBy {
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "chat_message_likes" */
export interface StudentOrTeacherChatMessageLikesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherChatMessageLikes>>;
}

/** Ordering options when selecting data from "chat_message_likes". */
export interface StudentOrTeacherChatMessageLikesOrderBy {
  chat_message?: Maybe<StudentOrTeacherChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "chat_message_likes" */
export const enum StudentOrTeacherChatMessageLikesSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chat_message_reads" */
export interface StudentOrTeacherChatMessageReads {
  /** An object relationship */
  chat_message: EntireFieldWrapper<StudentOrTeacherChatMessages>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChatMessageReadsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChatMessageReadsMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsArrRelInsertInput {
  data: Array<StudentOrTeacherChatMessageReadsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherChatMessageReadsOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_message_reads". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChatMessageReadsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChatMessageReadsBoolExp>>;
  _not?: Maybe<StudentOrTeacherChatMessageReadsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChatMessageReadsBoolExp>>;
  chat_message?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_read?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_message_reads" */
export const enum StudentOrTeacherChatMessageReadsConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGE_USER_PKEY = 'chat_message_user_pkey'
};

/** input type for inserting data into table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsInsertInput {
  chat_message?: Maybe<StudentOrTeacherChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
}

/** order by max() on columns of table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsMaxOrderBy {
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsMinOrderBy {
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherChatMessageReads>>;
}

/** on conflict condition type for table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsOnConflict {
  constraint: StudentOrTeacherChatMessageReadsConstraint;
  update_columns?: Array<StudentOrTeacherChatMessageReadsUpdateColumn>;
  where?: Maybe<StudentOrTeacherChatMessageReadsBoolExp>;
}

/** Ordering options when selecting data from "chat_message_reads". */
export interface StudentOrTeacherChatMessageReadsOrderBy {
  chat_message?: Maybe<StudentOrTeacherChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_read?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: chat_message_reads */
export interface StudentOrTeacherChatMessageReadsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_message_reads" */
export const enum StudentOrTeacherChatMessageReadsSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_message_reads" */
export interface StudentOrTeacherChatMessageReadsSetInput {
  is_read?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_message_reads" */
export const enum StudentOrTeacherChatMessageReadsUpdateColumn {
  /** column name */
  IS_READ = 'is_read'
};

/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessages {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chat: EntireFieldWrapper<StudentOrTeacherChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessages>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentOrTeacherChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentOrTeacherChatMessageLikesAggregate>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentOrTeacherChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrTeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrTeacherChatMessagesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrTeacherFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_pinned: EntireFieldWrapper<Scalars['Boolean']>;
  /** A computed field, executes function "chat_message_replys" */
  replys?: EntireFieldWrapper<Maybe<Array<StudentOrTeacherChatMessages>>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessagesChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessagesChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessagesChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageReadsOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageReadsBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessagesChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessagesChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessagesFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherFilesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrTeacherChatMessagesReplysArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}

/** aggregated selection of "chat_messages" */
export interface StudentOrTeacherChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherChatMessages>>;
}

/** aggregate fields of "chat_messages" */
export interface StudentOrTeacherChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessagesMinFields>>;
}


/** aggregate fields of "chat_messages" */
export interface StudentOrTeacherChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_messages" */
export interface StudentOrTeacherChatMessagesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChatMessagesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChatMessagesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_messages" */
export interface StudentOrTeacherChatMessagesArrRelInsertInput {
  data: Array<StudentOrTeacherChatMessagesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherChatMessagesOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChatMessagesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChatMessagesBoolExp>>;
  _not?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChatMessagesBoolExp>>;
  body?: Maybe<StudentOrTeacherStringComparisonExp>;
  chat?: Maybe<StudentOrTeacherChatsBoolExp>;
  chat_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  chat_message?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  chat_message_likes?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
  chat_message_reads?: Maybe<StudentOrTeacherChatMessageReadsBoolExp>;
  chat_messages?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  files?: Maybe<StudentOrTeacherFilesBoolExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_pinned?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  replys?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_messages" */
export const enum StudentOrTeacherChatMessagesConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGES_PKEY = 'chat_messages_pkey'
};

/** input type for inserting data into table "chat_messages" */
export interface StudentOrTeacherChatMessagesInsertInput {
  body?: Maybe<Scalars['String']>;
  chat?: Maybe<StudentOrTeacherChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message?: Maybe<StudentOrTeacherChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  chat_message_likes?: Maybe<StudentOrTeacherChatMessageLikesArrRelInsertInput>;
  chat_message_reads?: Maybe<StudentOrTeacherChatMessageReadsArrRelInsertInput>;
  chat_messages?: Maybe<StudentOrTeacherChatMessagesArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_messages" */
export interface StudentOrTeacherChatMessagesMaxOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_messages" */
export interface StudentOrTeacherChatMessagesMinOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "chat_messages" */
export interface StudentOrTeacherChatMessagesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherChatMessages>>;
}

/** input type for inserting object relation for remote table "chat_messages" */
export interface StudentOrTeacherChatMessagesObjRelInsertInput {
  data: StudentOrTeacherChatMessagesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherChatMessagesOnConflict>;
}

/** on conflict condition type for table "chat_messages" */
export interface StudentOrTeacherChatMessagesOnConflict {
  constraint: StudentOrTeacherChatMessagesConstraint;
  update_columns?: Array<StudentOrTeacherChatMessagesUpdateColumn>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}

/** Ordering options when selecting data from "chat_messages". */
export interface StudentOrTeacherChatMessagesOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  chat?: Maybe<StudentOrTeacherChatsOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  chat_message?: Maybe<StudentOrTeacherChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrTeacherOrderBy>;
  chat_message_likes_aggregate?: Maybe<StudentOrTeacherChatMessageLikesAggregateOrderBy>;
  chat_message_reads_aggregate?: Maybe<StudentOrTeacherChatMessageReadsAggregateOrderBy>;
  chat_messages_aggregate?: Maybe<StudentOrTeacherChatMessagesAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  files_aggregate?: Maybe<StudentOrTeacherFilesAggregateOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_pinned?: Maybe<StudentOrTeacherOrderBy>;
  replys_aggregate?: Maybe<StudentOrTeacherChatMessagesAggregateOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: chat_messages */
export interface StudentOrTeacherChatMessagesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_messages" */
export const enum StudentOrTeacherChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_messages" */
export interface StudentOrTeacherChatMessagesSetInput {
  body?: Maybe<Scalars['String']>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_messages" */
export const enum StudentOrTeacherChatMessagesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned'
};

/** columns and relationships of "chat_type" */
export interface StudentOrTeacherChatType {
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentOrTeacherChats>>;
  description: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chat_type" */
export interface StudentOrTeacherChatTypeChatsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatsOrderBy>>;
  where?: Maybe<StudentOrTeacherChatsBoolExp>;
}

/** Boolean expression to filter rows from the table "chat_type". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChatTypeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChatTypeBoolExp>>;
  _not?: Maybe<StudentOrTeacherChatTypeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChatTypeBoolExp>>;
  chats?: Maybe<StudentOrTeacherChatsBoolExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
}

export const enum StudentOrTeacherChatTypeEnum {
  /** Group conversation */
  GROUP = 'GROUP',
  /** Private conversation */
  PRIVATE = 'PRIVATE'
};

/** Boolean expression to compare columns of type "chat_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherChatTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherChatTypeEnum>;
  _in?: Maybe<Array<StudentOrTeacherChatTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherChatTypeEnum>;
  _nin?: Maybe<Array<StudentOrTeacherChatTypeEnum>>;
}

/** Ordering options when selecting data from "chat_type". */
export interface StudentOrTeacherChatTypeOrderBy {
  chats_aggregate?: Maybe<StudentOrTeacherChatsAggregateOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "chat_type" */
export const enum StudentOrTeacherChatTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chat_user" */
export interface StudentOrTeacherChatUser {
  /** An object relationship */
  chat: EntireFieldWrapper<StudentOrTeacherChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_user" */
export interface StudentOrTeacherChatUserAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChatUserMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChatUserMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_user" */
export interface StudentOrTeacherChatUserArrRelInsertInput {
  data: Array<StudentOrTeacherChatUserInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_user". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChatUserBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChatUserBoolExp>>;
  _not?: Maybe<StudentOrTeacherChatUserBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChatUserBoolExp>>;
  chat?: Maybe<StudentOrTeacherChatsBoolExp>;
  chat_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** input type for inserting data into table "chat_user" */
export interface StudentOrTeacherChatUserInsertInput {
  chat?: Maybe<StudentOrTeacherChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "chat_user" */
export interface StudentOrTeacherChatUserMaxOrderBy {
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "chat_user" */
export interface StudentOrTeacherChatUserMinOrderBy {
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "chat_user" */
export interface StudentOrTeacherChatUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherChatUser>>;
}

/** Ordering options when selecting data from "chat_user". */
export interface StudentOrTeacherChatUserOrderBy {
  chat?: Maybe<StudentOrTeacherChatsOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "chat_user" */
export const enum StudentOrTeacherChatUserSelectColumn {
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chats" */
export interface StudentOrTeacherChats {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrTeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrTeacherChatMessagesAggregate>;
  /** An object relationship */
  chat_type: EntireFieldWrapper<StudentOrTeacherChatType>;
  /** An array relationship */
  chat_users: EntireFieldWrapper<Array<StudentOrTeacherChatUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<StudentOrTeacherChatTypeEnum>;
  /** A computed field, executes function "unread_messages" */
  unread_messages?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chats" */
export interface StudentOrTeacherChatsChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface StudentOrTeacherChatsChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface StudentOrTeacherChatsChatUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatUserOrderBy>>;
  where?: Maybe<StudentOrTeacherChatUserBoolExp>;
}

/** order by aggregate values of table "chats" */
export interface StudentOrTeacherChatsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherChatsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherChatsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chats". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherChatsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherChatsBoolExp>>;
  _not?: Maybe<StudentOrTeacherChatsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherChatsBoolExp>>;
  avatar_url?: Maybe<StudentOrTeacherStringComparisonExp>;
  chat_messages?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
  chat_type?: Maybe<StudentOrTeacherChatTypeBoolExp>;
  chat_users?: Maybe<StudentOrTeacherChatUserBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  type?: Maybe<StudentOrTeacherChatTypeEnumComparisonExp>;
  unread_messages?: Maybe<StudentOrTeacherBigintComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "chats" */
export const enum StudentOrTeacherChatsConstraint {
  /** unique or primary key constraint */
  CHATS_PKEY = 'chats_pkey'
};

/** input type for inserting data into table "chats" */
export interface StudentOrTeacherChatsInsertInput {
  avatar_url?: Maybe<Scalars['String']>;
  chat_messages?: Maybe<StudentOrTeacherChatMessagesArrRelInsertInput>;
  chat_users?: Maybe<StudentOrTeacherChatUserArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<StudentOrTeacherChatTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chats" */
export interface StudentOrTeacherChatsMaxOrderBy {
  avatar_url?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "chats" */
export interface StudentOrTeacherChatsMinOrderBy {
  avatar_url?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "chats" */
export interface StudentOrTeacherChatsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherChats>>;
}

/** input type for inserting object relation for remote table "chats" */
export interface StudentOrTeacherChatsObjRelInsertInput {
  data: StudentOrTeacherChatsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherChatsOnConflict>;
}

/** on conflict condition type for table "chats" */
export interface StudentOrTeacherChatsOnConflict {
  constraint: StudentOrTeacherChatsConstraint;
  update_columns?: Array<StudentOrTeacherChatsUpdateColumn>;
  where?: Maybe<StudentOrTeacherChatsBoolExp>;
}

/** Ordering options when selecting data from "chats". */
export interface StudentOrTeacherChatsOrderBy {
  avatar_url?: Maybe<StudentOrTeacherOrderBy>;
  chat_messages_aggregate?: Maybe<StudentOrTeacherChatMessagesAggregateOrderBy>;
  chat_type?: Maybe<StudentOrTeacherChatTypeOrderBy>;
  chat_users_aggregate?: Maybe<StudentOrTeacherChatUserAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  unread_messages?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: chats */
export interface StudentOrTeacherChatsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chats" */
export const enum StudentOrTeacherChatsSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chats" */
export interface StudentOrTeacherChatsSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** update columns of table "chats" */
export const enum StudentOrTeacherChatsUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  TITLE = 'title'
};


/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherCitextComparisonExp {
  _eq?: Maybe<Scalars['citext']>;
  _gt?: Maybe<Scalars['citext']>;
  _gte?: Maybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['citext']>;
  _in?: Maybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['citext']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['citext']>;
  _lt?: Maybe<Scalars['citext']>;
  _lte?: Maybe<Scalars['citext']>;
  _neq?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['citext']>;
  _nin?: Maybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['citext']>;
}

/** columns and relationships of "class_levels" */
export interface StudentOrTeacherClassLevels {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrTeacherClasses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  number: EntireFieldWrapper<Scalars['Int']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "class_levels" */
export interface StudentOrTeacherClassLevelsClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassesOrderBy>>;
  where?: Maybe<StudentOrTeacherClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_levels". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherClassLevelsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherClassLevelsBoolExp>>;
  _not?: Maybe<StudentOrTeacherClassLevelsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherClassLevelsBoolExp>>;
  classes?: Maybe<StudentOrTeacherClassesBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  number?: Maybe<StudentOrTeacherIntComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "class_levels". */
export interface StudentOrTeacherClassLevelsOrderBy {
  classes_aggregate?: Maybe<StudentOrTeacherClassesAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  number?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "class_levels" */
export const enum StudentOrTeacherClassLevelsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "class_type" */
export interface StudentOrTeacherClassType {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrTeacherClasses>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "class_type" */
export interface StudentOrTeacherClassTypeClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassesOrderBy>>;
  where?: Maybe<StudentOrTeacherClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_type". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherClassTypeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherClassTypeBoolExp>>;
  _not?: Maybe<StudentOrTeacherClassTypeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherClassTypeBoolExp>>;
  classes?: Maybe<StudentOrTeacherClassesBoolExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
}

export const enum StudentOrTeacherClassTypeEnum {
  C = 'C',
  GEISTESWISSENSCHAFTEN = 'Geisteswissenschaften',
  TECHNOLOGIE = 'Technologie'
};

/** Boolean expression to compare columns of type "class_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherClassTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherClassTypeEnum>;
  _in?: Maybe<Array<StudentOrTeacherClassTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherClassTypeEnum>;
  _nin?: Maybe<Array<StudentOrTeacherClassTypeEnum>>;
}

/** Ordering options when selecting data from "class_type". */
export interface StudentOrTeacherClassTypeOrderBy {
  classes_aggregate?: Maybe<StudentOrTeacherClassesAggregateOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "class_type" */
export const enum StudentOrTeacherClassTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "classes" */
export interface StudentOrTeacherClasses {
  /** An object relationship */
  class_type: EntireFieldWrapper<StudentOrTeacherClassType>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<StudentOrTeacherCourseClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  identifier?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  level: EntireFieldWrapper<StudentOrTeacherClassLevels>;
  level_id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "class_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentOrTeacherStudents>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentOrTeacherStudentsAggregate>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentOrTeacherTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<StudentOrTeacherClassTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classes" */
export interface StudentOrTeacherClassesCourseClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassBoolExp>;
}


/** columns and relationships of "classes" */
export interface StudentOrTeacherClassesStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentsBoolExp>;
}


/** columns and relationships of "classes" */
export interface StudentOrTeacherClassesStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentsBoolExp>;
}

/** order by aggregate values of table "classes" */
export interface StudentOrTeacherClassesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherClassesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherClassesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classes". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherClassesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherClassesBoolExp>>;
  _not?: Maybe<StudentOrTeacherClassesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherClassesBoolExp>>;
  class_type?: Maybe<StudentOrTeacherClassTypeBoolExp>;
  course_classes?: Maybe<StudentOrTeacherCourseClassBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  identifier?: Maybe<StudentOrTeacherStringComparisonExp>;
  level?: Maybe<StudentOrTeacherClassLevelsBoolExp>;
  level_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  students?: Maybe<StudentOrTeacherStudentsBoolExp>;
  teacher?: Maybe<StudentOrTeacherTeachersBoolExp>;
  teacher_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  type?: Maybe<StudentOrTeacherClassTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classes" */
export interface StudentOrTeacherClassesMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  identifier?: Maybe<StudentOrTeacherOrderBy>;
  level_id?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "classes" */
export interface StudentOrTeacherClassesMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  identifier?: Maybe<StudentOrTeacherOrderBy>;
  level_id?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "classes". */
export interface StudentOrTeacherClassesOrderBy {
  class_type?: Maybe<StudentOrTeacherClassTypeOrderBy>;
  course_classes_aggregate?: Maybe<StudentOrTeacherCourseClassAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  identifier?: Maybe<StudentOrTeacherOrderBy>;
  level?: Maybe<StudentOrTeacherClassLevelsOrderBy>;
  level_id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  students_aggregate?: Maybe<StudentOrTeacherStudentsAggregateOrderBy>;
  teacher?: Maybe<StudentOrTeacherTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "classes" */
export const enum StudentOrTeacherClassesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IDENTIFIER = 'identifier',
  /** column name */
  LEVEL_ID = 'level_id',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "classrooms" */
export interface StudentOrTeacherClassrooms {
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<StudentOrTeacherCourseClassroom>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  floor: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrTeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentOrTeacherLessonsAggregate>;
  name: EntireFieldWrapper<Scalars['String']>;
  room: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrTeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentOrTeacherTeachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classrooms" */
export interface StudentOrTeacherClassroomsCourseClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassroomBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentOrTeacherClassroomsLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentOrTeacherClassroomsLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentOrTeacherClassroomsTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachersOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachersBoolExp>;
}

/** order by aggregate values of table "classrooms" */
export interface StudentOrTeacherClassroomsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherClassroomsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherClassroomsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classrooms". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherClassroomsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherClassroomsBoolExp>>;
  _not?: Maybe<StudentOrTeacherClassroomsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherClassroomsBoolExp>>;
  course_classrooms?: Maybe<StudentOrTeacherCourseClassroomBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  floor?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  lessons?: Maybe<StudentOrTeacherLessonsBoolExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  room?: Maybe<StudentOrTeacherStringComparisonExp>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teachers?: Maybe<StudentOrTeacherTeachersBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classrooms" */
export interface StudentOrTeacherClassroomsMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  floor?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  room?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "classrooms" */
export interface StudentOrTeacherClassroomsMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  floor?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  room?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "classrooms". */
export interface StudentOrTeacherClassroomsOrderBy {
  course_classrooms_aggregate?: Maybe<StudentOrTeacherCourseClassroomAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  floor?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  lessons_aggregate?: Maybe<StudentOrTeacherLessonsAggregateOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  room?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teachers_aggregate?: Maybe<StudentOrTeacherTeachersAggregateOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "classrooms" */
export const enum StudentOrTeacherClassroomsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FLOOR = 'floor',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ROOM = 'room',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_class" */
export interface StudentOrTeacherCourseClass {
  /** An object relationship */
  class: EntireFieldWrapper<StudentOrTeacherClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrTeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_class" */
export interface StudentOrTeacherCourseClassAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherCourseClassMaxOrderBy>;
  min?: Maybe<StudentOrTeacherCourseClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_class". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherCourseClassBoolExp {
  _and?: Maybe<Array<StudentOrTeacherCourseClassBoolExp>>;
  _not?: Maybe<StudentOrTeacherCourseClassBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherCourseClassBoolExp>>;
  class?: Maybe<StudentOrTeacherClassesBoolExp>;
  class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  course?: Maybe<StudentOrTeacherCoursesBoolExp>;
  course_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_class" */
export interface StudentOrTeacherCourseClassMaxOrderBy {
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "course_class" */
export interface StudentOrTeacherCourseClassMinOrderBy {
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "course_class". */
export interface StudentOrTeacherCourseClassOrderBy {
  class?: Maybe<StudentOrTeacherClassesOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  course?: Maybe<StudentOrTeacherCoursesOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "course_class" */
export const enum StudentOrTeacherCourseClassSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_classroom" */
export interface StudentOrTeacherCourseClassroom {
  /** An object relationship */
  classroom: EntireFieldWrapper<StudentOrTeacherClassrooms>;
  classroom_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrTeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_classroom" */
export interface StudentOrTeacherCourseClassroomAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherCourseClassroomMaxOrderBy>;
  min?: Maybe<StudentOrTeacherCourseClassroomMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_classroom". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherCourseClassroomBoolExp {
  _and?: Maybe<Array<StudentOrTeacherCourseClassroomBoolExp>>;
  _not?: Maybe<StudentOrTeacherCourseClassroomBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherCourseClassroomBoolExp>>;
  classroom?: Maybe<StudentOrTeacherClassroomsBoolExp>;
  classroom_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  course?: Maybe<StudentOrTeacherCoursesBoolExp>;
  course_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_classroom" */
export interface StudentOrTeacherCourseClassroomMaxOrderBy {
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "course_classroom" */
export interface StudentOrTeacherCourseClassroomMinOrderBy {
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "course_classroom". */
export interface StudentOrTeacherCourseClassroomOrderBy {
  classroom?: Maybe<StudentOrTeacherClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  course?: Maybe<StudentOrTeacherCoursesOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "course_classroom" */
export const enum StudentOrTeacherCourseClassroomSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_student" */
export interface StudentOrTeacherCourseStudent {
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrTeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrTeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_student" */
export interface StudentOrTeacherCourseStudentAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherCourseStudentMaxOrderBy>;
  min?: Maybe<StudentOrTeacherCourseStudentMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_student". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherCourseStudentBoolExp {
  _and?: Maybe<Array<StudentOrTeacherCourseStudentBoolExp>>;
  _not?: Maybe<StudentOrTeacherCourseStudentBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherCourseStudentBoolExp>>;
  course?: Maybe<StudentOrTeacherCoursesBoolExp>;
  course_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_student" */
export interface StudentOrTeacherCourseStudentMaxOrderBy {
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "course_student" */
export interface StudentOrTeacherCourseStudentMinOrderBy {
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "course_student". */
export interface StudentOrTeacherCourseStudentOrderBy {
  course?: Maybe<StudentOrTeacherCoursesOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "course_student" */
export const enum StudentOrTeacherCourseStudentSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_teacher" */
export interface StudentOrTeacherCourseTeacher {
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrTeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_primary: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentOrTeacherTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_teacher" */
export interface StudentOrTeacherCourseTeacherAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherCourseTeacherMaxOrderBy>;
  min?: Maybe<StudentOrTeacherCourseTeacherMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_teacher". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherCourseTeacherBoolExp {
  _and?: Maybe<Array<StudentOrTeacherCourseTeacherBoolExp>>;
  _not?: Maybe<StudentOrTeacherCourseTeacherBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherCourseTeacherBoolExp>>;
  course?: Maybe<StudentOrTeacherCoursesBoolExp>;
  course_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_primary?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  teacher?: Maybe<StudentOrTeacherTeachersBoolExp>;
  teacher_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_teacher" */
export interface StudentOrTeacherCourseTeacherMaxOrderBy {
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "course_teacher" */
export interface StudentOrTeacherCourseTeacherMinOrderBy {
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "course_teacher". */
export interface StudentOrTeacherCourseTeacherOrderBy {
  course?: Maybe<StudentOrTeacherCoursesOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_primary?: Maybe<StudentOrTeacherOrderBy>;
  teacher?: Maybe<StudentOrTeacherTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "course_teacher" */
export const enum StudentOrTeacherCourseTeacherSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRIMARY = 'is_primary',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "courses" */
export interface StudentOrTeacherCourses {
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<StudentOrTeacherBookCourse>>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<StudentOrTeacherCourseClass>>;
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<StudentOrTeacherCourseClassroom>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<StudentOrTeacherCourseTeacher>>;
  /** An array relationship */
  course_users: EntireFieldWrapper<Array<StudentOrTeacherCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_mandatory: EntireFieldWrapper<Scalars['Boolean']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrTeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentOrTeacherLessonsAggregate>;
  /** An object relationship */
  semester: EntireFieldWrapper<StudentOrTeacherSemesters>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentOrTeacherSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "courses" */
export interface StudentOrTeacherCoursesBookCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookCourseOrderBy>>;
  where?: Maybe<StudentOrTeacherBookCourseBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrTeacherCoursesCourseClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrTeacherCoursesCourseClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassroomBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrTeacherCoursesCourseTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseTeacherBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrTeacherCoursesCourseUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseStudentOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseStudentBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrTeacherCoursesLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrTeacherCoursesLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}

/** order by aggregate values of table "courses" */
export interface StudentOrTeacherCoursesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherCoursesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherCoursesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherCoursesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherCoursesBoolExp>>;
  _not?: Maybe<StudentOrTeacherCoursesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherCoursesBoolExp>>;
  book_courses?: Maybe<StudentOrTeacherBookCourseBoolExp>;
  course_classes?: Maybe<StudentOrTeacherCourseClassBoolExp>;
  course_classrooms?: Maybe<StudentOrTeacherCourseClassroomBoolExp>;
  course_teachers?: Maybe<StudentOrTeacherCourseTeacherBoolExp>;
  course_users?: Maybe<StudentOrTeacherCourseStudentBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_everybody?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  is_mandatory?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  lessons?: Maybe<StudentOrTeacherLessonsBoolExp>;
  semester?: Maybe<StudentOrTeacherSemestersBoolExp>;
  semester_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "courses" */
export interface StudentOrTeacherCoursesMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "courses" */
export interface StudentOrTeacherCoursesMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "courses". */
export interface StudentOrTeacherCoursesOrderBy {
  book_courses_aggregate?: Maybe<StudentOrTeacherBookCourseAggregateOrderBy>;
  course_classes_aggregate?: Maybe<StudentOrTeacherCourseClassAggregateOrderBy>;
  course_classrooms_aggregate?: Maybe<StudentOrTeacherCourseClassroomAggregateOrderBy>;
  course_teachers_aggregate?: Maybe<StudentOrTeacherCourseTeacherAggregateOrderBy>;
  course_users_aggregate?: Maybe<StudentOrTeacherCourseStudentAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_everybody?: Maybe<StudentOrTeacherOrderBy>;
  is_mandatory?: Maybe<StudentOrTeacherOrderBy>;
  lessons_aggregate?: Maybe<StudentOrTeacherLessonsAggregateOrderBy>;
  semester?: Maybe<StudentOrTeacherSemestersOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "courses" */
export const enum StudentOrTeacherCoursesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_MANDATORY = 'is_mandatory',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherDateComparisonExp {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
}

/** columns and relationships of "event_users" */
export interface StudentOrTeacherEventUsers {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  event: EntireFieldWrapper<StudentOrTeacherEvents>;
  event_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  paid?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "event_users". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherEventUsersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherEventUsersBoolExp>>;
  _not?: Maybe<StudentOrTeacherEventUsersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherEventUsersBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  event?: Maybe<StudentOrTeacherEventsBoolExp>;
  event_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  paid?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "event_users". */
export interface StudentOrTeacherEventUsersOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  event?: Maybe<StudentOrTeacherEventsOrderBy>;
  event_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  paid?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "event_users" */
export const enum StudentOrTeacherEventUsersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENT_ID = 'event_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAID = 'paid',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "events" */
export interface StudentOrTeacherEvents {
  cost: EntireFieldWrapper<Scalars['float8']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherEventsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherEventsBoolExp>>;
  _not?: Maybe<StudentOrTeacherEventsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherEventsBoolExp>>;
  cost?: Maybe<StudentOrTeacherFloat8ComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  date?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  status?: Maybe<StudentOrTeacherStringComparisonExp>;
  time?: Maybe<StudentOrTeacherIntComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "events". */
export interface StudentOrTeacherEventsOrderBy {
  cost?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  date?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  time?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "events" */
export const enum StudentOrTeacherEventsSelectColumn {
  /** column name */
  COST = 'cost',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DATE = 'date',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TIME = 'time',
  /** column name */
  TITLE = 'title',
  /** column name */
  USER_ID = 'user_id'
};

export const enum StudentOrTeacherFileTableTypesEnum {
  ASSIGNMENT_SUBMITS = 'assignment_submits',
  ASSIGNMENTS = 'assignments',
  CHATS = 'chats',
  PROFILE_PICTURES = 'profile_pictures'
};

/** Boolean expression to compare columns of type "file_table_types_enum". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherFileTableTypesEnumComparisonExp {
  _eq?: Maybe<StudentOrTeacherFileTableTypesEnum>;
  _in?: Maybe<Array<StudentOrTeacherFileTableTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrTeacherFileTableTypesEnum>;
  _nin?: Maybe<Array<StudentOrTeacherFileTableTypesEnum>>;
}

/** columns and relationships of "files" */
export interface StudentOrTeacherFiles {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  file_name: EntireFieldWrapper<Scalars['String']>;
  foreign_id: EntireFieldWrapper<Scalars['uuid']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  table: EntireFieldWrapper<StudentOrTeacherFileTableTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "files" */
export interface StudentOrTeacherFilesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherFilesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherFilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherFilesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherFilesBoolExp>>;
  _not?: Maybe<StudentOrTeacherFilesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherFilesBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  file_name?: Maybe<StudentOrTeacherStringComparisonExp>;
  foreign_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  hash?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  path?: Maybe<StudentOrTeacherStringComparisonExp>;
  table?: Maybe<StudentOrTeacherFileTableTypesEnumComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "files" */
export interface StudentOrTeacherFilesMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  file_name?: Maybe<StudentOrTeacherOrderBy>;
  foreign_id?: Maybe<StudentOrTeacherOrderBy>;
  hash?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "files" */
export interface StudentOrTeacherFilesMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  file_name?: Maybe<StudentOrTeacherOrderBy>;
  foreign_id?: Maybe<StudentOrTeacherOrderBy>;
  hash?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "files" */
export interface StudentOrTeacherFilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherFiles>>;
}

/** Ordering options when selecting data from "files". */
export interface StudentOrTeacherFilesOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  file_name?: Maybe<StudentOrTeacherOrderBy>;
  foreign_id?: Maybe<StudentOrTeacherOrderBy>;
  hash?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  table?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "files" */
export const enum StudentOrTeacherFilesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE_NAME = 'file_name',
  /** column name */
  FOREIGN_ID = 'foreign_id',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TABLE = 'table',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherFloat8ComparisonExp {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
}

/** columns and relationships of "grade_types" */
export interface StudentOrTeacherGradeTypes {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentOrTeacherGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrTeacherGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrTeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrTeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrTeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrTeacherViewGradesAggregate>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrTeacherGradeTypesGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradeTypesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrTeacherGradeTypesGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrTeacherGradeTypesGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrTeacherGradeTypesViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrTeacherGradeTypesViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}

/** order by aggregate values of table "grade_types" */
export interface StudentOrTeacherGradeTypesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherGradeTypesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherGradeTypesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "grade_types". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherGradeTypesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherGradeTypesBoolExp>>;
  _not?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherGradeTypesBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  grade_type?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  grade_types?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
  grades?: Maybe<StudentOrTeacherGradesBoolExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  view_grades?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}

/** order by max() on columns of table "grade_types" */
export interface StudentOrTeacherGradeTypesMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "grade_types" */
export interface StudentOrTeacherGradeTypesMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "grade_types". */
export interface StudentOrTeacherGradeTypesOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grade_type?: Maybe<StudentOrTeacherGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  grade_types_aggregate?: Maybe<StudentOrTeacherGradeTypesAggregateOrderBy>;
  grades_aggregate?: Maybe<StudentOrTeacherGradesAggregateOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  view_grades_aggregate?: Maybe<StudentOrTeacherViewGradesAggregateOrderBy>;
}

/** select columns of table "grade_types" */
export const enum StudentOrTeacherGradeTypesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "grades" */
export interface StudentOrTeacherGrades {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrTeacherAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentOrTeacherGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentOrTeacherMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrTeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  weight: EntireFieldWrapper<Scalars['Int']>;
}

/** aggregated selection of "grades" */
export interface StudentOrTeacherGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherGrades>>;
}

/** aggregate fields of "grades" */
export interface StudentOrTeacherGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrTeacherGradesVarianceFields>>;
}


/** aggregate fields of "grades" */
export interface StudentOrTeacherGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "grades" */
export interface StudentOrTeacherGradesAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherGradesAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherGradesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherGradesMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherGradesStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherGradesStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherGradesSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherGradesVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherGradesVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrTeacherGradesAvgFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "grades" */
export interface StudentOrTeacherGradesAvgOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "grades". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherGradesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherGradesBoolExp>>;
  _not?: Maybe<StudentOrTeacherGradesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherGradesBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  comment?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  grade_type?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  mark?: Maybe<StudentOrTeacherMarksBoolExp>;
  mark_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  weight?: Maybe<StudentOrTeacherIntComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherGradesMaxFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "grades" */
export interface StudentOrTeacherGradesMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  mark_id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherGradesMinFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "grades" */
export interface StudentOrTeacherGradesMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  mark_id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "grades". */
export interface StudentOrTeacherGradesOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grade_type?: Maybe<StudentOrTeacherGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  mark?: Maybe<StudentOrTeacherMarksOrderBy>;
  mark_id?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "grades" */
export const enum StudentOrTeacherGradesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface StudentOrTeacherGradesStddevFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "grades" */
export interface StudentOrTeacherGradesStddevOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrTeacherGradesStddevPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "grades" */
export interface StudentOrTeacherGradesStddevPopOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrTeacherGradesStddevSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "grades" */
export interface StudentOrTeacherGradesStddevSampOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrTeacherGradesSumFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "grades" */
export interface StudentOrTeacherGradesSumOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrTeacherGradesVarPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "grades" */
export interface StudentOrTeacherGradesVarPopOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrTeacherGradesVarSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "grades" */
export interface StudentOrTeacherGradesVarSampOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrTeacherGradesVarianceFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "grades" */
export interface StudentOrTeacherGradesVarianceOrderBy {
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "latest_activities" */
export interface StudentOrTeacherLatestActivities {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  message: EntireFieldWrapper<Scalars['String']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "latest_activities". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherLatestActivitiesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherLatestActivitiesBoolExp>>;
  _not?: Maybe<StudentOrTeacherLatestActivitiesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherLatestActivitiesBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  message?: Maybe<StudentOrTeacherStringComparisonExp>;
  path?: Maybe<StudentOrTeacherStringComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "latest_activities". */
export interface StudentOrTeacherLatestActivitiesOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  message?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "latest_activities" */
export const enum StudentOrTeacherLatestActivitiesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  PATH = 'path',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lesson_attendace_type" */
export interface StudentOrTeacherLessonAttendaceType {
  name: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "lesson_attendace_type". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherLessonAttendaceTypeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherLessonAttendaceTypeBoolExp>>;
  _not?: Maybe<StudentOrTeacherLessonAttendaceTypeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherLessonAttendaceTypeBoolExp>>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
}

/** Ordering options when selecting data from "lesson_attendace_type". */
export interface StudentOrTeacherLessonAttendaceTypeOrderBy {
  name?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "lesson_attendace_type" */
export const enum StudentOrTeacherLessonAttendaceTypeSelectColumn {
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "lesson_attendances" */
export interface StudentOrTeacherLessonAttendances {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  lesson: EntireFieldWrapper<StudentOrTeacherLessons>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "lesson_attendances" */
export interface StudentOrTeacherLessonAttendancesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherLessonAttendancesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherLessonAttendancesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "lesson_attendances". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherLessonAttendancesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherLessonAttendancesBoolExp>>;
  _not?: Maybe<StudentOrTeacherLessonAttendancesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherLessonAttendancesBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  lesson?: Maybe<StudentOrTeacherLessonsBoolExp>;
  lesson_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  type?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "lesson_attendances" */
export interface StudentOrTeacherLessonAttendancesMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "lesson_attendances" */
export interface StudentOrTeacherLessonAttendancesMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "lesson_attendances". */
export interface StudentOrTeacherLessonAttendancesOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson?: Maybe<StudentOrTeacherLessonsOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "lesson_attendances" */
export const enum StudentOrTeacherLessonAttendancesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lessons" */
export interface StudentOrTeacherLessons {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrTeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentsAggregate>;
  /** An array relationship */
  attendaces: EntireFieldWrapper<Array<StudentOrTeacherLessonAttendances>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<StudentOrTeacherClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrTeacherCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_online: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_classes?: EntireFieldWrapper<Maybe<StudentOrTeacherLiveClasses>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "lessons" */
export interface StudentOrTeacherLessonsAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface StudentOrTeacherLessonsAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface StudentOrTeacherLessonsAttendacesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonAttendancesOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonAttendancesBoolExp>;
}

/** aggregated selection of "lessons" */
export interface StudentOrTeacherLessonsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherLessons>>;
}

/** aggregate fields of "lessons" */
export interface StudentOrTeacherLessonsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonsVarianceFields>>;
}


/** aggregate fields of "lessons" */
export interface StudentOrTeacherLessonsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "lessons" */
export interface StudentOrTeacherLessonsAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherLessonsAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherLessonsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherLessonsMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherLessonsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherLessonsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherLessonsStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherLessonsSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherLessonsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherLessonsVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherLessonsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrTeacherLessonsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "lessons" */
export interface StudentOrTeacherLessonsAvgOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherLessonsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherLessonsBoolExp>>;
  _not?: Maybe<StudentOrTeacherLessonsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherLessonsBoolExp>>;
  assignments?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  attendaces?: Maybe<StudentOrTeacherLessonAttendancesBoolExp>;
  classroom?: Maybe<StudentOrTeacherClassroomsBoolExp>;
  classroom_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  course?: Maybe<StudentOrTeacherCoursesBoolExp>;
  course_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  duration?: Maybe<StudentOrTeacherIntComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_online?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  live_classes?: Maybe<StudentOrTeacherLiveClassesBoolExp>;
  start_at?: Maybe<StudentOrTeacherTimetzComparisonExp>;
  start_date?: Maybe<StudentOrTeacherDateComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherLessonsMaxFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "lessons" */
export interface StudentOrTeacherLessonsMaxOrderBy {
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  start_at?: Maybe<StudentOrTeacherOrderBy>;
  start_date?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherLessonsMinFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "lessons" */
export interface StudentOrTeacherLessonsMinOrderBy {
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  start_at?: Maybe<StudentOrTeacherOrderBy>;
  start_date?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "lessons". */
export interface StudentOrTeacherLessonsOrderBy {
  assignments_aggregate?: Maybe<StudentOrTeacherAssignmentsAggregateOrderBy>;
  attendaces_aggregate?: Maybe<StudentOrTeacherLessonAttendancesAggregateOrderBy>;
  classroom?: Maybe<StudentOrTeacherClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  course?: Maybe<StudentOrTeacherCoursesOrderBy>;
  course_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_online?: Maybe<StudentOrTeacherOrderBy>;
  live_classes?: Maybe<StudentOrTeacherLiveClassesOrderBy>;
  start_at?: Maybe<StudentOrTeacherOrderBy>;
  start_date?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "lessons" */
export const enum StudentOrTeacherLessonsSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ONLINE = 'is_online',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface StudentOrTeacherLessonsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "lessons" */
export interface StudentOrTeacherLessonsStddevOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrTeacherLessonsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "lessons" */
export interface StudentOrTeacherLessonsStddevPopOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrTeacherLessonsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "lessons" */
export interface StudentOrTeacherLessonsStddevSampOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrTeacherLessonsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "lessons" */
export interface StudentOrTeacherLessonsSumOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrTeacherLessonsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "lessons" */
export interface StudentOrTeacherLessonsVarPopOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrTeacherLessonsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "lessons" */
export interface StudentOrTeacherLessonsVarSampOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrTeacherLessonsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "lessons" */
export interface StudentOrTeacherLessonsVarianceOrderBy {
  duration?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "live_class_attendees" */
export interface StudentOrTeacherLiveClassAttendees {
  group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_present: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_class: EntireFieldWrapper<StudentOrTeacherLiveClasses>;
  live_class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  students?: EntireFieldWrapper<Maybe<StudentOrTeacherStudents>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "live_class_attendees" */
export interface StudentOrTeacherLiveClassAttendeesAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherLiveClassAttendeesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherLiveClassAttendeesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "live_class_attendees". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherLiveClassAttendeesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherLiveClassAttendeesBoolExp>>;
  _not?: Maybe<StudentOrTeacherLiveClassAttendeesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherLiveClassAttendeesBoolExp>>;
  group_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_present?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  live_class?: Maybe<StudentOrTeacherLiveClassesBoolExp>;
  live_class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  students?: Maybe<StudentOrTeacherStudentsBoolExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "live_class_attendees" */
export interface StudentOrTeacherLiveClassAttendeesMaxOrderBy {
  group_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  live_class_id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "live_class_attendees" */
export interface StudentOrTeacherLiveClassAttendeesMinOrderBy {
  group_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  live_class_id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "live_class_attendees". */
export interface StudentOrTeacherLiveClassAttendeesOrderBy {
  group_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_present?: Maybe<StudentOrTeacherOrderBy>;
  live_class?: Maybe<StudentOrTeacherLiveClassesOrderBy>;
  live_class_id?: Maybe<StudentOrTeacherOrderBy>;
  students?: Maybe<StudentOrTeacherStudentsOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "live_class_attendees" */
export const enum StudentOrTeacherLiveClassAttendeesSelectColumn {
  /** column name */
  GROUP_ID = 'group_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRESENT = 'is_present',
  /** column name */
  LIVE_CLASS_ID = 'live_class_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "live_classes" */
export interface StudentOrTeacherLiveClasses {
  attendeePW: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<StudentOrTeacherLiveClassAttendees>>;
  meetingID: EntireFieldWrapper<Scalars['String']>;
  moderatorPW: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  starting_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  voice_bridge?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}


/** columns and relationships of "live_classes" */
export interface StudentOrTeacherLiveClassesLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<StudentOrTeacherLiveClassAttendeesBoolExp>;
}

/** Boolean expression to filter rows from the table "live_classes". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherLiveClassesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherLiveClassesBoolExp>>;
  _not?: Maybe<StudentOrTeacherLiveClassesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherLiveClassesBoolExp>>;
  attendeePW?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  description?: Maybe<StudentOrTeacherStringComparisonExp>;
  duration?: Maybe<StudentOrTeacherIntComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  lesson_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  live_class_attendees?: Maybe<StudentOrTeacherLiveClassAttendeesBoolExp>;
  meetingID?: Maybe<StudentOrTeacherStringComparisonExp>;
  moderatorPW?: Maybe<StudentOrTeacherStringComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  recording_private_id?: Maybe<StudentOrTeacherIntComparisonExp>;
  starting_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  status?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  voice_bridge?: Maybe<StudentOrTeacherStringComparisonExp>;
}

/** Ordering options when selecting data from "live_classes". */
export interface StudentOrTeacherLiveClassesOrderBy {
  attendeePW?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  description?: Maybe<StudentOrTeacherOrderBy>;
  duration?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  live_class_attendees_aggregate?: Maybe<StudentOrTeacherLiveClassAttendeesAggregateOrderBy>;
  meetingID?: Maybe<StudentOrTeacherOrderBy>;
  moderatorPW?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  recording_private_id?: Maybe<StudentOrTeacherOrderBy>;
  starting_at?: Maybe<StudentOrTeacherOrderBy>;
  status?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  voice_bridge?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "live_classes" */
export const enum StudentOrTeacherLiveClassesSelectColumn {
  /** column name */
  ATTENDEEPW = 'attendeePW',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  MEETINGID = 'meetingID',
  /** column name */
  MODERATORPW = 'moderatorPW',
  /** column name */
  NAME = 'name',
  /** column name */
  RECORDING_PRIVATE_ID = 'recording_private_id',
  /** column name */
  STARTING_AT = 'starting_at',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VOICE_BRIDGE = 'voice_bridge'
};

/** columns and relationships of "marks" */
export interface StudentOrTeacherMarks {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrTeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrTeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  value: EntireFieldWrapper<Scalars['Int']>;
}


/** columns and relationships of "marks" */
export interface StudentOrTeacherMarksGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


/** columns and relationships of "marks" */
export interface StudentOrTeacherMarksGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}

/** Boolean expression to filter rows from the table "marks". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherMarksBoolExp {
  _and?: Maybe<Array<StudentOrTeacherMarksBoolExp>>;
  _not?: Maybe<StudentOrTeacherMarksBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherMarksBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  grades?: Maybe<StudentOrTeacherGradesBoolExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  value?: Maybe<StudentOrTeacherIntComparisonExp>;
}

/** Ordering options when selecting data from "marks". */
export interface StudentOrTeacherMarksOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grades_aggregate?: Maybe<StudentOrTeacherGradesAggregateOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  value?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "marks" */
export const enum StudentOrTeacherMarksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "meeting_user" */
export interface StudentOrTeacherMeetingUser {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  meeting_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "meeting_user" */
export interface StudentOrTeacherMeetingUserAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherMeetingUserAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherMeetingUser>>;
}

/** aggregate fields of "meeting_user" */
export interface StudentOrTeacherMeetingUserAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherMeetingUserMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherMeetingUserMinFields>>;
}


/** aggregate fields of "meeting_user" */
export interface StudentOrTeacherMeetingUserAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherMeetingUserSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "meeting_user". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherMeetingUserBoolExp {
  _and?: Maybe<Array<StudentOrTeacherMeetingUserBoolExp>>;
  _not?: Maybe<StudentOrTeacherMeetingUserBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherMeetingUserBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  meeting_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherMeetingUserMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherMeetingUserMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "meeting_user". */
export interface StudentOrTeacherMeetingUserOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  meeting_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "meeting_user" */
export const enum StudentOrTeacherMeetingUserSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MEETING_ID = 'meeting_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** mutation root */
export interface StudentOrTeacherMutationRoot {
  change_password?: EntireFieldWrapper<Maybe<StudentOrTeacherMessageResponse>>;
  /** delete data from the table: "assignment_discussion" */
  delete_assignment_discussion?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionMutationResponse>>;
  /** delete single row from the table: "assignment_discussion" */
  delete_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussion>>;
  /** delete data from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContentMutationResponse>>;
  /** delete single row from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContent>>;
  /** delete data from the table: "assignment_files" */
  delete_assignment_files?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentFilesMutationResponse>>;
  /** delete single row from the table: "assignment_files" */
  delete_assignment_files_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentFiles>>;
  /** delete data from the table: "assignment_notes" */
  delete_assignment_notes?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotesMutationResponse>>;
  /** delete single row from the table: "assignment_notes" */
  delete_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotes>>;
  /** delete data from the table: "auth.account_providers" */
  delete_auth_account_providers?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProvidersMutationResponse>>;
  /** delete single row from the table: "auth.account_providers" */
  delete_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProviders>>;
  /** delete data from the table: "auth.account_roles" */
  delete_auth_account_roles?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRolesMutationResponse>>;
  /** delete single row from the table: "auth.account_roles" */
  delete_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRoles>>;
  /** delete data from the table: "auth.accounts" */
  delete_auth_accounts?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountsMutationResponse>>;
  /** delete single row from the table: "auth.accounts" */
  delete_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccounts>>;
  /** delete data from the table: "auth.providers" */
  delete_auth_providers?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProvidersMutationResponse>>;
  /** delete single row from the table: "auth.providers" */
  delete_auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProviders>>;
  /** delete data from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokensMutationResponse>>;
  /** delete single row from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokens>>;
  /** delete data from the table: "auth.roles" */
  delete_auth_roles?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRolesMutationResponse>>;
  /** delete single row from the table: "auth.roles" */
  delete_auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRoles>>;
  /** delete data from the table: "chapter_section_notes" */
  delete_chapter_section_notes?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotesMutationResponse>>;
  /** delete single row from the table: "chapter_section_notes" */
  delete_chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotes>>;
  /** delete data from the table: "chapter_section_submits" */
  delete_chapter_section_submits?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmitsMutationResponse>>;
  /** delete single row from the table: "chapter_section_submits" */
  delete_chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmits>>;
  /** delete data from the table: "chat_message_likes" */
  delete_chat_message_likes?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikesMutationResponse>>;
  /** delete single row from the table: "chat_message_likes" */
  delete_chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikes>>;
  /** delete data from the table: "chat_messages" */
  delete_chat_messages?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessagesMutationResponse>>;
  /** delete single row from the table: "chat_messages" */
  delete_chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessages>>;
  /** delete data from the table: "chats" */
  delete_chats?: EntireFieldWrapper<Maybe<StudentOrTeacherChatsMutationResponse>>;
  /** delete single row from the table: "chats" */
  delete_chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChats>>;
  /** delete data from the table: "files" */
  delete_files?: EntireFieldWrapper<Maybe<StudentOrTeacherFilesMutationResponse>>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherFiles>>;
  /** delete data from the table: "private.adresses" */
  delete_private_adresses?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdressesMutationResponse>>;
  /** delete single row from the table: "private.adresses" */
  delete_private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdresses>>;
  /** delete data from the table: "private.birthdays" */
  delete_private_birthdays?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdaysMutationResponse>>;
  /** delete single row from the table: "private.birthdays" */
  delete_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdays>>;
  /** delete data from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbersMutationResponse>>;
  /** delete single row from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbers>>;
  /** delete data from the table: "private.phone_numbers" */
  delete_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbersMutationResponse>>;
  /** delete single row from the table: "private.phone_numbers" */
  delete_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbers>>;
  /** delete data from the table: "relationships" */
  delete_relationships?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationshipsMutationResponse>>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationships>>;
  /** delete data from the table: "school_settings" */
  delete_school_settings?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsMutationResponse>>;
  /** delete single row from the table: "school_settings" */
  delete_school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettings>>;
  /** delete data from the table: "school_settings_modules" */
  delete_school_settings_modules?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModulesMutationResponse>>;
  /** delete single row from the table: "school_settings_modules" */
  delete_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModules>>;
  /** delete data from the table: "schools" */
  delete_schools?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolsMutationResponse>>;
  /** delete single row from the table: "schools" */
  delete_schools_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchools>>;
  /** delete data from the table: "tasks" */
  delete_tasks?: EntireFieldWrapper<Maybe<StudentOrTeacherTasksMutationResponse>>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTasks>>;
  /** delete data from the table: "users" */
  delete_users?: EntireFieldWrapper<Maybe<StudentOrTeacherUsersMutationResponse>>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  /** insert data into the table: "assignment_discussion" */
  insert_assignment_discussion?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionMutationResponse>>;
  /** insert data into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContentMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContent>>;
  /** insert a single row into the table: "assignment_discussion" */
  insert_assignment_discussion_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussion>>;
  /** insert data into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionSubscription>>;
  /** insert data into the table: "assignment_files" */
  insert_assignment_files?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentFilesMutationResponse>>;
  /** insert a single row into the table: "assignment_files" */
  insert_assignment_files_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentFiles>>;
  /** insert data into the table: "assignment_notes" */
  insert_assignment_notes?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotesMutationResponse>>;
  /** insert a single row into the table: "assignment_notes" */
  insert_assignment_notes_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotes>>;
  /** insert data into the table: "assignment_question_answers" */
  insert_assignment_question_answers?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionAnswersMutationResponse>>;
  /** insert a single row into the table: "assignment_question_answers" */
  insert_assignment_question_answers_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionAnswers>>;
  /** insert data into the table: "assignment_submits" */
  insert_assignment_submits?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentSubmitsMutationResponse>>;
  /** insert a single row into the table: "assignment_submits" */
  insert_assignment_submits_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentSubmits>>;
  /** insert data into the table: "auth.account_providers" */
  insert_auth_account_providers?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.account_providers" */
  insert_auth_account_providers_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProviders>>;
  /** insert data into the table: "auth.account_roles" */
  insert_auth_account_roles?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRolesMutationResponse>>;
  /** insert a single row into the table: "auth.account_roles" */
  insert_auth_account_roles_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRoles>>;
  /** insert data into the table: "auth.accounts" */
  insert_auth_accounts?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountsMutationResponse>>;
  /** insert a single row into the table: "auth.accounts" */
  insert_auth_accounts_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccounts>>;
  /** insert data into the table: "auth.providers" */
  insert_auth_providers?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.providers" */
  insert_auth_providers_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProviders>>;
  /** insert data into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokensMutationResponse>>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokens>>;
  /** insert data into the table: "auth.roles" */
  insert_auth_roles?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRolesMutationResponse>>;
  /** insert a single row into the table: "auth.roles" */
  insert_auth_roles_one?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRoles>>;
  /** insert data into the table: "chapter_section_notes" */
  insert_chapter_section_notes?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotesMutationResponse>>;
  /** insert a single row into the table: "chapter_section_notes" */
  insert_chapter_section_notes_one?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotes>>;
  /** insert data into the table: "chapter_section_submits" */
  insert_chapter_section_submits?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmitsMutationResponse>>;
  /** insert a single row into the table: "chapter_section_submits" */
  insert_chapter_section_submits_one?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmits>>;
  /** insert data into the table: "chat_message_likes" */
  insert_chat_message_likes?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikesMutationResponse>>;
  /** insert a single row into the table: "chat_message_likes" */
  insert_chat_message_likes_one?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikes>>;
  /** insert data into the table: "chat_message_reads" */
  insert_chat_message_reads?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageReadsMutationResponse>>;
  /** insert a single row into the table: "chat_message_reads" */
  insert_chat_message_reads_one?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageReads>>;
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessagesMutationResponse>>;
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessages>>;
  /** insert data into the table: "chat_user" */
  insert_chat_user?: EntireFieldWrapper<Maybe<StudentOrTeacherChatUserMutationResponse>>;
  /** insert a single row into the table: "chat_user" */
  insert_chat_user_one?: EntireFieldWrapper<Maybe<StudentOrTeacherChatUser>>;
  /** insert data into the table: "chats" */
  insert_chats?: EntireFieldWrapper<Maybe<StudentOrTeacherChatsMutationResponse>>;
  /** insert a single row into the table: "chats" */
  insert_chats_one?: EntireFieldWrapper<Maybe<StudentOrTeacherChats>>;
  /** insert data into the table: "notifications" */
  insert_notifications?: EntireFieldWrapper<Maybe<StudentOrTeacherNotificationsMutationResponse>>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: EntireFieldWrapper<Maybe<StudentOrTeacherNotifications>>;
  /** insert data into the table: "private.adresses" */
  insert_private_adresses?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdressesMutationResponse>>;
  /** insert a single row into the table: "private.adresses" */
  insert_private_adresses_one?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdresses>>;
  /** insert data into the table: "private.birthdays" */
  insert_private_birthdays?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdaysMutationResponse>>;
  /** insert a single row into the table: "private.birthdays" */
  insert_private_birthdays_one?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdays>>;
  /** insert data into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbersMutationResponse>>;
  /** insert a single row into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers_one?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbers>>;
  /** insert data into the table: "private.phone_numbers" */
  insert_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbersMutationResponse>>;
  /** insert a single row into the table: "private.phone_numbers" */
  insert_private_phone_numbers_one?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbers>>;
  /** insert data into the table: "relationships" */
  insert_relationships?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationshipsMutationResponse>>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationships>>;
  /** insert data into the table: "school_settings" */
  insert_school_settings?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsMutationResponse>>;
  /** insert data into the table: "school_settings_modules" */
  insert_school_settings_modules?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModulesMutationResponse>>;
  /** insert a single row into the table: "school_settings_modules" */
  insert_school_settings_modules_one?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModules>>;
  /** insert a single row into the table: "school_settings" */
  insert_school_settings_one?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettings>>;
  /** insert data into the table: "schools" */
  insert_schools?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolsMutationResponse>>;
  /** insert a single row into the table: "schools" */
  insert_schools_one?: EntireFieldWrapper<Maybe<StudentOrTeacherSchools>>;
  /** insert data into the table: "tasks" */
  insert_tasks?: EntireFieldWrapper<Maybe<StudentOrTeacherTasksMutationResponse>>;
  /** insert a single row into the table: "tasks" */
  insert_tasks_one?: EntireFieldWrapper<Maybe<StudentOrTeacherTasks>>;
  /** insert data into the table: "users" */
  insert_users?: EntireFieldWrapper<Maybe<StudentOrTeacherUsersMutationResponse>>;
  /** insert a single row into the table: "users" */
  insert_users_one?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  lost_password?: EntireFieldWrapper<Maybe<StudentOrTeacherMessageResponse>>;
  refresh_token?: EntireFieldWrapper<Maybe<StudentOrTeacherSession>>;
  reset_password?: EntireFieldWrapper<Maybe<StudentOrTeacherMessageResponse>>;
  revoke_token?: EntireFieldWrapper<Maybe<StudentOrTeacherMessageResponse>>;
  studentJoin?: EntireFieldWrapper<Maybe<StudentOrTeacherBbbJoinLink>>;
  /** update data of the table: "assignment_discussion" */
  update_assignment_discussion?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionMutationResponse>>;
  /** update single row of the table: "assignment_discussion" */
  update_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussion>>;
  /** update data of the table: "assignment_discussion_content" */
  update_assignment_discussion_content?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContentMutationResponse>>;
  /** update single row of the table: "assignment_discussion_content" */
  update_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContent>>;
  /** update data of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionMutationResponse>>;
  /** update single row of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionSubscription>>;
  /** update data of the table: "assignment_notes" */
  update_assignment_notes?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotesMutationResponse>>;
  /** update single row of the table: "assignment_notes" */
  update_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotes>>;
  /** update data of the table: "assignment_submits" */
  update_assignment_submits?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentSubmitsMutationResponse>>;
  /** update single row of the table: "assignment_submits" */
  update_assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentSubmits>>;
  /** update data of the table: "assignment_user" */
  update_assignment_user?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentUserMutationResponse>>;
  /** update single row of the table: "assignment_user" */
  update_assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentUser>>;
  /** update data of the table: "auth.account_providers" */
  update_auth_account_providers?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProvidersMutationResponse>>;
  /** update single row of the table: "auth.account_providers" */
  update_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProviders>>;
  /** update data of the table: "auth.account_roles" */
  update_auth_account_roles?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRolesMutationResponse>>;
  /** update single row of the table: "auth.account_roles" */
  update_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRoles>>;
  /** update data of the table: "auth.accounts" */
  update_auth_accounts?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountsMutationResponse>>;
  /** update single row of the table: "auth.accounts" */
  update_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccounts>>;
  /** update data of the table: "auth.providers" */
  update_auth_providers?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProvidersMutationResponse>>;
  /** update single row of the table: "auth.providers" */
  update_auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProviders>>;
  /** update data of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokensMutationResponse>>;
  /** update single row of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokens>>;
  /** update data of the table: "auth.roles" */
  update_auth_roles?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRolesMutationResponse>>;
  /** update single row of the table: "auth.roles" */
  update_auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRoles>>;
  /** update data of the table: "chapter_section_notes" */
  update_chapter_section_notes?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotesMutationResponse>>;
  /** update single row of the table: "chapter_section_notes" */
  update_chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotes>>;
  /** update data of the table: "chapter_section_submits" */
  update_chapter_section_submits?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmitsMutationResponse>>;
  /** update single row of the table: "chapter_section_submits" */
  update_chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmits>>;
  /** update data of the table: "chat_message_reads" */
  update_chat_message_reads?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageReadsMutationResponse>>;
  /** update single row of the table: "chat_message_reads" */
  update_chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageReads>>;
  /** update data of the table: "chat_messages" */
  update_chat_messages?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessagesMutationResponse>>;
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessages>>;
  /** update data of the table: "chats" */
  update_chats?: EntireFieldWrapper<Maybe<StudentOrTeacherChatsMutationResponse>>;
  /** update single row of the table: "chats" */
  update_chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChats>>;
  /** update data of the table: "notifications" */
  update_notifications?: EntireFieldWrapper<Maybe<StudentOrTeacherNotificationsMutationResponse>>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherNotifications>>;
  /** update data of the table: "private.adresses" */
  update_private_adresses?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdressesMutationResponse>>;
  /** update single row of the table: "private.adresses" */
  update_private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdresses>>;
  /** update data of the table: "private.birthdays" */
  update_private_birthdays?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdaysMutationResponse>>;
  /** update single row of the table: "private.birthdays" */
  update_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdays>>;
  /** update data of the table: "private.insurance_numbers" */
  update_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbersMutationResponse>>;
  /** update single row of the table: "private.insurance_numbers" */
  update_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbers>>;
  /** update data of the table: "private.phone_numbers" */
  update_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbersMutationResponse>>;
  /** update single row of the table: "private.phone_numbers" */
  update_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbers>>;
  /** update data of the table: "relationships" */
  update_relationships?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationshipsMutationResponse>>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationships>>;
  /** update data of the table: "school_settings" */
  update_school_settings?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsMutationResponse>>;
  /** update single row of the table: "school_settings" */
  update_school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettings>>;
  /** update data of the table: "school_settings_modules" */
  update_school_settings_modules?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModulesMutationResponse>>;
  /** update single row of the table: "school_settings_modules" */
  update_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModules>>;
  /** update data of the table: "schools" */
  update_schools?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolsMutationResponse>>;
  /** update single row of the table: "schools" */
  update_schools_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchools>>;
  /** update data of the table: "tasks" */
  update_tasks?: EntireFieldWrapper<Maybe<StudentOrTeacherTasksMutationResponse>>;
  /** update single row of the table: "tasks" */
  update_tasks_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTasks>>;
  /** update data of the table: "users" */
  update_users?: EntireFieldWrapper<Maybe<StudentOrTeacherUsersMutationResponse>>;
  /** update single row of the table: "users" */
  update_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootChangePasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentDiscussionArgs {
  where: StudentOrTeacherAssignmentDiscussionBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentDiscussionContentArgs {
  where: StudentOrTeacherAssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentFilesArgs {
  where: StudentOrTeacherAssignmentFilesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentNotesArgs {
  where: StudentOrTeacherAssignmentNotesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthAccountProvidersArgs {
  where: StudentOrTeacherAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthAccountRolesArgs {
  where: StudentOrTeacherAuthAccountRolesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthAccountsArgs {
  where: StudentOrTeacherAuthAccountsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthProvidersArgs {
  where: StudentOrTeacherAuthProvidersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthRefreshTokensArgs {
  where: StudentOrTeacherAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthRolesArgs {
  where: StudentOrTeacherAuthRolesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteAuthRolesByPkArgs {
  role: Scalars['String'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChapterSectionNotesArgs {
  where: StudentOrTeacherChapterSectionNotesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChapterSectionSubmitsArgs {
  where: StudentOrTeacherChapterSectionSubmitsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChatMessageLikesArgs {
  where: StudentOrTeacherChatMessageLikesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChatMessagesArgs {
  where: StudentOrTeacherChatMessagesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChatsArgs {
  where: StudentOrTeacherChatsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteChatsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteFilesArgs {
  where: StudentOrTeacherFilesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivateAdressesArgs {
  where: StudentOrTeacherPrivateAdressesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivateBirthdaysArgs {
  where: StudentOrTeacherPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivateInsuranceNumbersArgs {
  where: StudentOrTeacherPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivatePhoneNumbersArgs {
  where: StudentOrTeacherPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeletePrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteRelationshipsArgs {
  where: StudentOrTeacherRelationshipsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteSchoolSettingsArgs {
  where: StudentOrTeacherSchoolSettingsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteSchoolSettingsModulesArgs {
  where: StudentOrTeacherSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteSchoolsArgs {
  where: StudentOrTeacherSchoolsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteSchoolsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteTasksArgs {
  where: StudentOrTeacherTasksBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteTasksByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteUsersArgs {
  where: StudentOrTeacherUsersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootDeleteUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentDiscussionArgs {
  objects: Array<StudentOrTeacherAssignmentDiscussionInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentDiscussionContentArgs {
  objects: Array<StudentOrTeacherAssignmentDiscussionContentInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentDiscussionContentOneArgs {
  object: StudentOrTeacherAssignmentDiscussionContentInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentDiscussionOneArgs {
  object: StudentOrTeacherAssignmentDiscussionInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentDiscussionSubscriptionArgs {
  objects: Array<StudentOrTeacherAssignmentDiscussionSubscriptionInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentDiscussionSubscriptionOneArgs {
  object: StudentOrTeacherAssignmentDiscussionSubscriptionInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentFilesArgs {
  objects: Array<StudentOrTeacherAssignmentFilesInsertInput>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentFilesOneArgs {
  object: StudentOrTeacherAssignmentFilesInsertInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentNotesArgs {
  objects: Array<StudentOrTeacherAssignmentNotesInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAssignmentNotesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentNotesOneArgs {
  object: StudentOrTeacherAssignmentNotesInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAssignmentNotesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentQuestionAnswersArgs {
  objects: Array<StudentOrTeacherAssignmentQuestionAnswersInsertInput>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentQuestionAnswersOneArgs {
  object: StudentOrTeacherAssignmentQuestionAnswersInsertInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentSubmitsArgs {
  objects: Array<StudentOrTeacherAssignmentSubmitsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAssignmentSubmitsOneArgs {
  object: StudentOrTeacherAssignmentSubmitsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthAccountProvidersArgs {
  objects: Array<StudentOrTeacherAuthAccountProvidersInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthAccountProvidersOneArgs {
  object: StudentOrTeacherAuthAccountProvidersInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthAccountRolesArgs {
  objects: Array<StudentOrTeacherAuthAccountRolesInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthAccountRolesOneArgs {
  object: StudentOrTeacherAuthAccountRolesInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthAccountsArgs {
  objects: Array<StudentOrTeacherAuthAccountsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAuthAccountsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthAccountsOneArgs {
  object: StudentOrTeacherAuthAccountsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAuthAccountsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthProvidersArgs {
  objects: Array<StudentOrTeacherAuthProvidersInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAuthProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthProvidersOneArgs {
  object: StudentOrTeacherAuthProvidersInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAuthProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthRefreshTokensArgs {
  objects: Array<StudentOrTeacherAuthRefreshTokensInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthRefreshTokensOneArgs {
  object: StudentOrTeacherAuthRefreshTokensInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthRolesArgs {
  objects: Array<StudentOrTeacherAuthRolesInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherAuthRolesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertAuthRolesOneArgs {
  object: StudentOrTeacherAuthRolesInsertInput;
  on_conflict?: Maybe<StudentOrTeacherAuthRolesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChapterSectionNotesArgs {
  objects: Array<StudentOrTeacherChapterSectionNotesInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherChapterSectionNotesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChapterSectionNotesOneArgs {
  object: StudentOrTeacherChapterSectionNotesInsertInput;
  on_conflict?: Maybe<StudentOrTeacherChapterSectionNotesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChapterSectionSubmitsArgs {
  objects: Array<StudentOrTeacherChapterSectionSubmitsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherChapterSectionSubmitsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChapterSectionSubmitsOneArgs {
  object: StudentOrTeacherChapterSectionSubmitsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherChapterSectionSubmitsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatMessageLikesArgs {
  objects: Array<StudentOrTeacherChatMessageLikesInsertInput>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatMessageLikesOneArgs {
  object: StudentOrTeacherChatMessageLikesInsertInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatMessageReadsArgs {
  objects: Array<StudentOrTeacherChatMessageReadsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherChatMessageReadsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatMessageReadsOneArgs {
  object: StudentOrTeacherChatMessageReadsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherChatMessageReadsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatMessagesArgs {
  objects: Array<StudentOrTeacherChatMessagesInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherChatMessagesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatMessagesOneArgs {
  object: StudentOrTeacherChatMessagesInsertInput;
  on_conflict?: Maybe<StudentOrTeacherChatMessagesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatUserArgs {
  objects: Array<StudentOrTeacherChatUserInsertInput>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatUserOneArgs {
  object: StudentOrTeacherChatUserInsertInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatsArgs {
  objects: Array<StudentOrTeacherChatsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherChatsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertChatsOneArgs {
  object: StudentOrTeacherChatsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherChatsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertNotificationsArgs {
  objects: Array<StudentOrTeacherNotificationsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherNotificationsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertNotificationsOneArgs {
  object: StudentOrTeacherNotificationsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherNotificationsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivateAdressesArgs {
  objects: Array<StudentOrTeacherPrivateAdressesInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherPrivateAdressesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivateAdressesOneArgs {
  object: StudentOrTeacherPrivateAdressesInsertInput;
  on_conflict?: Maybe<StudentOrTeacherPrivateAdressesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivateBirthdaysArgs {
  objects: Array<StudentOrTeacherPrivateBirthdaysInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivateBirthdaysOneArgs {
  object: StudentOrTeacherPrivateBirthdaysInsertInput;
  on_conflict?: Maybe<StudentOrTeacherPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivateInsuranceNumbersArgs {
  objects: Array<StudentOrTeacherPrivateInsuranceNumbersInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivateInsuranceNumbersOneArgs {
  object: StudentOrTeacherPrivateInsuranceNumbersInsertInput;
  on_conflict?: Maybe<StudentOrTeacherPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivatePhoneNumbersArgs {
  objects: Array<StudentOrTeacherPrivatePhoneNumbersInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertPrivatePhoneNumbersOneArgs {
  object: StudentOrTeacherPrivatePhoneNumbersInsertInput;
  on_conflict?: Maybe<StudentOrTeacherPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertRelationshipsArgs {
  objects: Array<StudentOrTeacherRelationshipsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherRelationshipsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertRelationshipsOneArgs {
  object: StudentOrTeacherRelationshipsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherRelationshipsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertSchoolSettingsArgs {
  objects: Array<StudentOrTeacherSchoolSettingsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherSchoolSettingsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertSchoolSettingsModulesArgs {
  objects: Array<StudentOrTeacherSchoolSettingsModulesInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertSchoolSettingsModulesOneArgs {
  object: StudentOrTeacherSchoolSettingsModulesInsertInput;
  on_conflict?: Maybe<StudentOrTeacherSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertSchoolSettingsOneArgs {
  object: StudentOrTeacherSchoolSettingsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherSchoolSettingsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertSchoolsArgs {
  objects: Array<StudentOrTeacherSchoolsInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherSchoolsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertSchoolsOneArgs {
  object: StudentOrTeacherSchoolsInsertInput;
  on_conflict?: Maybe<StudentOrTeacherSchoolsOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertTasksArgs {
  objects: Array<StudentOrTeacherTasksInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherTasksOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertTasksOneArgs {
  object: StudentOrTeacherTasksInsertInput;
  on_conflict?: Maybe<StudentOrTeacherTasksOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertUsersArgs {
  objects: Array<StudentOrTeacherUsersInsertInput>;
  on_conflict?: Maybe<StudentOrTeacherUsersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootInsertUsersOneArgs {
  object: StudentOrTeacherUsersInsertInput;
  on_conflict?: Maybe<StudentOrTeacherUsersOnConflict>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootLostPasswordArgs {
  email: Scalars['String'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootRefreshTokenArgs {
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootResetPasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootRevokeTokenArgs {
  all?: Maybe<Scalars['Boolean']>;
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface StudentOrTeacherMutationRootStudentJoinArgs {
  meeting_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentDiscussionArgs {
  _set?: Maybe<StudentOrTeacherAssignmentDiscussionSetInput>;
  where: StudentOrTeacherAssignmentDiscussionBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentDiscussionByPkArgs {
  _set?: Maybe<StudentOrTeacherAssignmentDiscussionSetInput>;
  pk_columns: StudentOrTeacherAssignmentDiscussionPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentDiscussionContentArgs {
  _set?: Maybe<StudentOrTeacherAssignmentDiscussionContentSetInput>;
  where: StudentOrTeacherAssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentDiscussionContentByPkArgs {
  _set?: Maybe<StudentOrTeacherAssignmentDiscussionContentSetInput>;
  pk_columns: StudentOrTeacherAssignmentDiscussionContentPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentDiscussionSubscriptionArgs {
  _set?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionSetInput>;
  where: StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentDiscussionSubscriptionByPkArgs {
  _set?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionSetInput>;
  pk_columns: StudentOrTeacherAssignmentDiscussionSubscriptionPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentNotesArgs {
  _set?: Maybe<StudentOrTeacherAssignmentNotesSetInput>;
  where: StudentOrTeacherAssignmentNotesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentNotesByPkArgs {
  _set?: Maybe<StudentOrTeacherAssignmentNotesSetInput>;
  pk_columns: StudentOrTeacherAssignmentNotesPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentSubmitsArgs {
  _set?: Maybe<StudentOrTeacherAssignmentSubmitsSetInput>;
  where: StudentOrTeacherAssignmentSubmitsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentSubmitsByPkArgs {
  _set?: Maybe<StudentOrTeacherAssignmentSubmitsSetInput>;
  pk_columns: StudentOrTeacherAssignmentSubmitsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentUserArgs {
  _set?: Maybe<StudentOrTeacherAssignmentUserSetInput>;
  where: StudentOrTeacherAssignmentUserBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAssignmentUserByPkArgs {
  _set?: Maybe<StudentOrTeacherAssignmentUserSetInput>;
  pk_columns: StudentOrTeacherAssignmentUserPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthAccountProvidersArgs {
  _set?: Maybe<StudentOrTeacherAuthAccountProvidersSetInput>;
  where: StudentOrTeacherAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthAccountProvidersByPkArgs {
  _set?: Maybe<StudentOrTeacherAuthAccountProvidersSetInput>;
  pk_columns: StudentOrTeacherAuthAccountProvidersPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthAccountRolesArgs {
  _set?: Maybe<StudentOrTeacherAuthAccountRolesSetInput>;
  where: StudentOrTeacherAuthAccountRolesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthAccountRolesByPkArgs {
  _set?: Maybe<StudentOrTeacherAuthAccountRolesSetInput>;
  pk_columns: StudentOrTeacherAuthAccountRolesPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthAccountsArgs {
  _set?: Maybe<StudentOrTeacherAuthAccountsSetInput>;
  where: StudentOrTeacherAuthAccountsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthAccountsByPkArgs {
  _set?: Maybe<StudentOrTeacherAuthAccountsSetInput>;
  pk_columns: StudentOrTeacherAuthAccountsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthProvidersArgs {
  _set?: Maybe<StudentOrTeacherAuthProvidersSetInput>;
  where: StudentOrTeacherAuthProvidersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthProvidersByPkArgs {
  _set?: Maybe<StudentOrTeacherAuthProvidersSetInput>;
  pk_columns: StudentOrTeacherAuthProvidersPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthRefreshTokensArgs {
  _set?: Maybe<StudentOrTeacherAuthRefreshTokensSetInput>;
  where: StudentOrTeacherAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthRefreshTokensByPkArgs {
  _set?: Maybe<StudentOrTeacherAuthRefreshTokensSetInput>;
  pk_columns: StudentOrTeacherAuthRefreshTokensPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthRolesArgs {
  _set?: Maybe<StudentOrTeacherAuthRolesSetInput>;
  where: StudentOrTeacherAuthRolesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateAuthRolesByPkArgs {
  _set?: Maybe<StudentOrTeacherAuthRolesSetInput>;
  pk_columns: StudentOrTeacherAuthRolesPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChapterSectionNotesArgs {
  _set?: Maybe<StudentOrTeacherChapterSectionNotesSetInput>;
  where: StudentOrTeacherChapterSectionNotesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChapterSectionNotesByPkArgs {
  _set?: Maybe<StudentOrTeacherChapterSectionNotesSetInput>;
  pk_columns: StudentOrTeacherChapterSectionNotesPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChapterSectionSubmitsArgs {
  _inc?: Maybe<StudentOrTeacherChapterSectionSubmitsIncInput>;
  _set?: Maybe<StudentOrTeacherChapterSectionSubmitsSetInput>;
  where: StudentOrTeacherChapterSectionSubmitsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChapterSectionSubmitsByPkArgs {
  _inc?: Maybe<StudentOrTeacherChapterSectionSubmitsIncInput>;
  _set?: Maybe<StudentOrTeacherChapterSectionSubmitsSetInput>;
  pk_columns: StudentOrTeacherChapterSectionSubmitsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChatMessageReadsArgs {
  _set?: Maybe<StudentOrTeacherChatMessageReadsSetInput>;
  where: StudentOrTeacherChatMessageReadsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChatMessageReadsByPkArgs {
  _set?: Maybe<StudentOrTeacherChatMessageReadsSetInput>;
  pk_columns: StudentOrTeacherChatMessageReadsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChatMessagesArgs {
  _set?: Maybe<StudentOrTeacherChatMessagesSetInput>;
  where: StudentOrTeacherChatMessagesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChatMessagesByPkArgs {
  _set?: Maybe<StudentOrTeacherChatMessagesSetInput>;
  pk_columns: StudentOrTeacherChatMessagesPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChatsArgs {
  _set?: Maybe<StudentOrTeacherChatsSetInput>;
  where: StudentOrTeacherChatsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateChatsByPkArgs {
  _set?: Maybe<StudentOrTeacherChatsSetInput>;
  pk_columns: StudentOrTeacherChatsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateNotificationsArgs {
  _set?: Maybe<StudentOrTeacherNotificationsSetInput>;
  where: StudentOrTeacherNotificationsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateNotificationsByPkArgs {
  _set?: Maybe<StudentOrTeacherNotificationsSetInput>;
  pk_columns: StudentOrTeacherNotificationsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivateAdressesArgs {
  _set?: Maybe<StudentOrTeacherPrivateAdressesSetInput>;
  where: StudentOrTeacherPrivateAdressesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivateAdressesByPkArgs {
  _set?: Maybe<StudentOrTeacherPrivateAdressesSetInput>;
  pk_columns: StudentOrTeacherPrivateAdressesPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivateBirthdaysArgs {
  _set?: Maybe<StudentOrTeacherPrivateBirthdaysSetInput>;
  where: StudentOrTeacherPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivateBirthdaysByPkArgs {
  _set?: Maybe<StudentOrTeacherPrivateBirthdaysSetInput>;
  pk_columns: StudentOrTeacherPrivateBirthdaysPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivateInsuranceNumbersArgs {
  _set?: Maybe<StudentOrTeacherPrivateInsuranceNumbersSetInput>;
  where: StudentOrTeacherPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivateInsuranceNumbersByPkArgs {
  _set?: Maybe<StudentOrTeacherPrivateInsuranceNumbersSetInput>;
  pk_columns: StudentOrTeacherPrivateInsuranceNumbersPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivatePhoneNumbersArgs {
  _set?: Maybe<StudentOrTeacherPrivatePhoneNumbersSetInput>;
  where: StudentOrTeacherPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdatePrivatePhoneNumbersByPkArgs {
  _set?: Maybe<StudentOrTeacherPrivatePhoneNumbersSetInput>;
  pk_columns: StudentOrTeacherPrivatePhoneNumbersPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateRelationshipsArgs {
  _set?: Maybe<StudentOrTeacherRelationshipsSetInput>;
  where: StudentOrTeacherRelationshipsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateRelationshipsByPkArgs {
  _set?: Maybe<StudentOrTeacherRelationshipsSetInput>;
  pk_columns: StudentOrTeacherRelationshipsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateSchoolSettingsArgs {
  _set?: Maybe<StudentOrTeacherSchoolSettingsSetInput>;
  where: StudentOrTeacherSchoolSettingsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateSchoolSettingsByPkArgs {
  _set?: Maybe<StudentOrTeacherSchoolSettingsSetInput>;
  pk_columns: StudentOrTeacherSchoolSettingsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateSchoolSettingsModulesArgs {
  _set?: Maybe<StudentOrTeacherSchoolSettingsModulesSetInput>;
  where: StudentOrTeacherSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateSchoolSettingsModulesByPkArgs {
  _set?: Maybe<StudentOrTeacherSchoolSettingsModulesSetInput>;
  pk_columns: StudentOrTeacherSchoolSettingsModulesPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateSchoolsArgs {
  _set?: Maybe<StudentOrTeacherSchoolsSetInput>;
  where: StudentOrTeacherSchoolsBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateSchoolsByPkArgs {
  _set?: Maybe<StudentOrTeacherSchoolsSetInput>;
  pk_columns: StudentOrTeacherSchoolsPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateTasksArgs {
  _set?: Maybe<StudentOrTeacherTasksSetInput>;
  where: StudentOrTeacherTasksBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateTasksByPkArgs {
  _set?: Maybe<StudentOrTeacherTasksSetInput>;
  pk_columns: StudentOrTeacherTasksPkColumnsInput;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateUsersArgs {
  _set?: Maybe<StudentOrTeacherUsersSetInput>;
  where: StudentOrTeacherUsersBoolExp;
}


/** mutation root */
export interface StudentOrTeacherMutationRootUpdateUsersByPkArgs {
  _set?: Maybe<StudentOrTeacherUsersSetInput>;
  pk_columns: StudentOrTeacherUsersPkColumnsInput;
}

/** columns and relationships of "notifications" */
export interface StudentOrTeacherNotifications {
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "notifications" */
export interface StudentOrTeacherNotificationsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherNotificationsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherNotifications>>;
}

/** aggregate fields of "notifications" */
export interface StudentOrTeacherNotificationsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherNotificationsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherNotificationsMinFields>>;
}


/** aggregate fields of "notifications" */
export interface StudentOrTeacherNotificationsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherNotificationsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherNotificationsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherNotificationsBoolExp>>;
  _not?: Maybe<StudentOrTeacherNotificationsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherNotificationsBoolExp>>;
  content?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_read?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  path?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "notifications" */
export const enum StudentOrTeacherNotificationsConstraint {
  /** unique or primary key constraint */
  NOTIFICATIONS_PKEY = 'notifications_pkey'
};

/** input type for inserting data into table "notifications" */
export interface StudentOrTeacherNotificationsInsertInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherNotificationsMaxFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherNotificationsMinFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "notifications" */
export interface StudentOrTeacherNotificationsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherNotifications>>;
}

/** on conflict condition type for table "notifications" */
export interface StudentOrTeacherNotificationsOnConflict {
  constraint: StudentOrTeacherNotificationsConstraint;
  update_columns?: Array<StudentOrTeacherNotificationsUpdateColumn>;
  where?: Maybe<StudentOrTeacherNotificationsBoolExp>;
}

/** Ordering options when selecting data from "notifications". */
export interface StudentOrTeacherNotificationsOrderBy {
  content?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_read?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: notifications */
export interface StudentOrTeacherNotificationsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "notifications" */
export const enum StudentOrTeacherNotificationsSelectColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "notifications" */
export interface StudentOrTeacherNotificationsSetInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "notifications" */
export const enum StudentOrTeacherNotificationsUpdateColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherNumericComparisonExp {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
}

/** column ordering options */
export const enum StudentOrTeacherOrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
};

/** columns and relationships of "parents" */
export interface StudentOrTeacherParents {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "parents". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherParentsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherParentsBoolExp>>;
  _not?: Maybe<StudentOrTeacherParentsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherParentsBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "parents". */
export interface StudentOrTeacherParentsOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "parents" */
export const enum StudentOrTeacherParentsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.adresses" */
export interface StudentOrTeacherPrivateAdresses {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrTeacherUsers>;
}

/** aggregated selection of "private.adresses" */
export interface StudentOrTeacherPrivateAdressesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdressesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherPrivateAdresses>>;
}

/** aggregate fields of "private.adresses" */
export interface StudentOrTeacherPrivateAdressesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdressesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdressesMinFields>>;
}


/** aggregate fields of "private.adresses" */
export interface StudentOrTeacherPrivateAdressesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherPrivateAdressesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.adresses". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherPrivateAdressesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherPrivateAdressesBoolExp>>;
  _not?: Maybe<StudentOrTeacherPrivateAdressesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherPrivateAdressesBoolExp>>;
  area?: Maybe<StudentOrTeacherStringComparisonExp>;
  city?: Maybe<StudentOrTeacherStringComparisonExp>;
  country?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  postal_code?: Maybe<StudentOrTeacherStringComparisonExp>;
  street?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user?: Maybe<StudentOrTeacherUsersBoolExp>;
}

/** unique or primary key constraints on table "private.adresses" */
export const enum StudentOrTeacherPrivateAdressesConstraint {
  /** unique or primary key constraint */
  ADRESSES_PKEY = 'adresses_pkey'
};

/** input type for inserting data into table "private.adresses" */
export interface StudentOrTeacherPrivateAdressesInsertInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrTeacherUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrTeacherPrivateAdressesMaxFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherPrivateAdressesMinFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.adresses" */
export interface StudentOrTeacherPrivateAdressesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherPrivateAdresses>>;
}

/** input type for inserting object relation for remote table "private.adresses" */
export interface StudentOrTeacherPrivateAdressesObjRelInsertInput {
  data: StudentOrTeacherPrivateAdressesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherPrivateAdressesOnConflict>;
}

/** on conflict condition type for table "private.adresses" */
export interface StudentOrTeacherPrivateAdressesOnConflict {
  constraint: StudentOrTeacherPrivateAdressesConstraint;
  update_columns?: Array<StudentOrTeacherPrivateAdressesUpdateColumn>;
  where?: Maybe<StudentOrTeacherPrivateAdressesBoolExp>;
}

/** Ordering options when selecting data from "private.adresses". */
export interface StudentOrTeacherPrivateAdressesOrderBy {
  area?: Maybe<StudentOrTeacherOrderBy>;
  city?: Maybe<StudentOrTeacherOrderBy>;
  country?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  postal_code?: Maybe<StudentOrTeacherOrderBy>;
  street?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user?: Maybe<StudentOrTeacherUsersOrderBy>;
}

/** primary key columns input for table: private_adresses */
export interface StudentOrTeacherPrivateAdressesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.adresses" */
export const enum StudentOrTeacherPrivateAdressesSelectColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.adresses" */
export interface StudentOrTeacherPrivateAdressesSetInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.adresses" */
export const enum StudentOrTeacherPrivateAdressesUpdateColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdays {
  date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdaysAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherPrivateBirthdays>>;
}

/** aggregate fields of "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdaysMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdaysMinFields>>;
}


/** aggregate fields of "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherPrivateBirthdaysSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.birthdays". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherPrivateBirthdaysBoolExp {
  _and?: Maybe<Array<StudentOrTeacherPrivateBirthdaysBoolExp>>;
  _not?: Maybe<StudentOrTeacherPrivateBirthdaysBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherPrivateBirthdaysBoolExp>>;
  date?: Maybe<StudentOrTeacherDateComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "private.birthdays" */
export const enum StudentOrTeacherPrivateBirthdaysConstraint {
  /** unique or primary key constraint */
  BIRTHDAYS_PKEY = 'birthdays_pkey'
};

/** input type for inserting data into table "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysInsertInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherPrivateBirthdaysMaxFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherPrivateBirthdaysMinFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherPrivateBirthdays>>;
}

/** input type for inserting object relation for remote table "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysObjRelInsertInput {
  data: StudentOrTeacherPrivateBirthdaysInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherPrivateBirthdaysOnConflict>;
}

/** on conflict condition type for table "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysOnConflict {
  constraint: StudentOrTeacherPrivateBirthdaysConstraint;
  update_columns?: Array<StudentOrTeacherPrivateBirthdaysUpdateColumn>;
  where?: Maybe<StudentOrTeacherPrivateBirthdaysBoolExp>;
}

/** Ordering options when selecting data from "private.birthdays". */
export interface StudentOrTeacherPrivateBirthdaysOrderBy {
  date?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: private_birthdays */
export interface StudentOrTeacherPrivateBirthdaysPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.birthdays" */
export const enum StudentOrTeacherPrivateBirthdaysSelectColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** input type for updating data in table "private.birthdays" */
export interface StudentOrTeacherPrivateBirthdaysSetInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "private.birthdays" */
export const enum StudentOrTeacherPrivateBirthdaysUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrTeacherUsers>;
}

/** aggregated selection of "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherPrivateInsuranceNumbers>>;
}

/** aggregate fields of "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbersMinFields>>;
}


/** aggregate fields of "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherPrivateInsuranceNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.insurance_numbers". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherPrivateInsuranceNumbersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherPrivateInsuranceNumbersBoolExp>>;
  _not?: Maybe<StudentOrTeacherPrivateInsuranceNumbersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherPrivateInsuranceNumbersBoolExp>>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  user?: Maybe<StudentOrTeacherUsersBoolExp>;
}

/** unique or primary key constraints on table "private.insurance_numbers" */
export const enum StudentOrTeacherPrivateInsuranceNumbersConstraint {
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_NAME_KEY = 'insurance_numbers_name_key',
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_PKEY = 'insurance_numbers_pkey'
};

/** input type for inserting data into table "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<StudentOrTeacherUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrTeacherPrivateInsuranceNumbersMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherPrivateInsuranceNumbersMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherPrivateInsuranceNumbers>>;
}

/** input type for inserting object relation for remote table "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersObjRelInsertInput {
  data: StudentOrTeacherPrivateInsuranceNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherPrivateInsuranceNumbersOnConflict>;
}

/** on conflict condition type for table "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersOnConflict {
  constraint: StudentOrTeacherPrivateInsuranceNumbersConstraint;
  update_columns?: Array<StudentOrTeacherPrivateInsuranceNumbersUpdateColumn>;
  where?: Maybe<StudentOrTeacherPrivateInsuranceNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.insurance_numbers". */
export interface StudentOrTeacherPrivateInsuranceNumbersOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  user?: Maybe<StudentOrTeacherUsersOrderBy>;
}

/** primary key columns input for table: private_insurance_numbers */
export interface StudentOrTeacherPrivateInsuranceNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.insurance_numbers" */
export const enum StudentOrTeacherPrivateInsuranceNumbersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** input type for updating data in table "private.insurance_numbers" */
export interface StudentOrTeacherPrivateInsuranceNumbersSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
}

/** update columns of table "private.insurance_numbers" */
export const enum StudentOrTeacherPrivateInsuranceNumbersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbers {
  country_code: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  number: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrTeacherUsers>;
}

/** aggregated selection of "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherPrivatePhoneNumbers>>;
}

/** aggregate fields of "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbersMinFields>>;
}


/** aggregate fields of "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherPrivatePhoneNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.phone_numbers". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherPrivatePhoneNumbersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherPrivatePhoneNumbersBoolExp>>;
  _not?: Maybe<StudentOrTeacherPrivatePhoneNumbersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherPrivatePhoneNumbersBoolExp>>;
  country_code?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  number?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user?: Maybe<StudentOrTeacherUsersBoolExp>;
}

/** unique or primary key constraints on table "private.phone_numbers" */
export const enum StudentOrTeacherPrivatePhoneNumbersConstraint {
  /** unique or primary key constraint */
  PHONE_NUMBERS_COUNTRY_CODE_NUMBER_KEY = 'phone_numbers_country_code_number_key',
  /** unique or primary key constraint */
  PHONE_NUMBERS_PKEY = 'phone_numbers_pkey'
};

/** input type for inserting data into table "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersInsertInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrTeacherUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrTeacherPrivatePhoneNumbersMaxFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherPrivatePhoneNumbersMinFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherPrivatePhoneNumbers>>;
}

/** input type for inserting object relation for remote table "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersObjRelInsertInput {
  data: StudentOrTeacherPrivatePhoneNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherPrivatePhoneNumbersOnConflict>;
}

/** on conflict condition type for table "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersOnConflict {
  constraint: StudentOrTeacherPrivatePhoneNumbersConstraint;
  update_columns?: Array<StudentOrTeacherPrivatePhoneNumbersUpdateColumn>;
  where?: Maybe<StudentOrTeacherPrivatePhoneNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.phone_numbers". */
export interface StudentOrTeacherPrivatePhoneNumbersOrderBy {
  country_code?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  number?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user?: Maybe<StudentOrTeacherUsersOrderBy>;
}

/** primary key columns input for table: private_phone_numbers */
export interface StudentOrTeacherPrivatePhoneNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.phone_numbers" */
export const enum StudentOrTeacherPrivatePhoneNumbersSelectColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.phone_numbers" */
export interface StudentOrTeacherPrivatePhoneNumbersSetInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.phone_numbers" */
export const enum StudentOrTeacherPrivatePhoneNumbersUpdateColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "promotions" */
export interface StudentOrTeacherPromotions {
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_promoted: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  year: EntireFieldWrapper<StudentOrTeacherYears>;
  year_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "promotions" */
export interface StudentOrTeacherPromotionsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherPromotionsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherPromotionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "promotions". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherPromotionsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherPromotionsBoolExp>>;
  _not?: Maybe<StudentOrTeacherPromotionsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherPromotionsBoolExp>>;
  class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_promoted?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  year?: Maybe<StudentOrTeacherYearsBoolExp>;
  year_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "promotions" */
export interface StudentOrTeacherPromotionsMaxOrderBy {
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  year_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "promotions" */
export interface StudentOrTeacherPromotionsMinOrderBy {
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  year_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "promotions". */
export interface StudentOrTeacherPromotionsOrderBy {
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_promoted?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  year?: Maybe<StudentOrTeacherYearsOrderBy>;
  year_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "promotions" */
export const enum StudentOrTeacherPromotionsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PROMOTED = 'is_promoted',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  YEAR_ID = 'year_id'
};

export interface StudentOrTeacherQueryRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<StudentOrTeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<StudentOrTeacherAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<StudentOrTeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<StudentOrTeacherAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<StudentOrTeacherAssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionOptions>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentOrTeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<StudentOrTeacherAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<StudentOrTeacherAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrTeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<StudentOrTeacherAttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<StudentOrTeacherAttendances>>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAttendances>>;
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountProviders>>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountProvidersAggregate>;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountProviders>>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: EntireFieldWrapper<Array<StudentOrTeacherAuthAccountRoles>>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountRolesAggregate>;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccountRoles>>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: EntireFieldWrapper<Array<StudentOrTeacherAuthAccounts>>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: EntireFieldWrapper<StudentOrTeacherAuthAccountsAggregate>;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccounts>>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: EntireFieldWrapper<Array<StudentOrTeacherAuthProviders>>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: EntireFieldWrapper<StudentOrTeacherAuthProvidersAggregate>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthProviders>>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: EntireFieldWrapper<Array<StudentOrTeacherAuthRefreshTokens>>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: EntireFieldWrapper<StudentOrTeacherAuthRefreshTokensAggregate>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRefreshTokens>>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: EntireFieldWrapper<Array<StudentOrTeacherAuthRoles>>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: EntireFieldWrapper<StudentOrTeacherAuthRolesAggregate>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthRoles>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<StudentOrTeacherBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrTeacherBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<StudentOrTeacherBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<StudentOrTeacherBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentOrTeacherBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrTeacherChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentOrTeacherChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentOrTeacherChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentOrTeacherChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrTeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrTeacherChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<StudentOrTeacherChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<StudentOrTeacherChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentOrTeacherChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<StudentOrTeacherClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<StudentOrTeacherClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrTeacherClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentOrTeacherClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<StudentOrTeacherCourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<StudentOrTeacherCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<StudentOrTeacherCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<StudentOrTeacherCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentOrTeacherCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<StudentOrTeacherEventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<StudentOrTeacherEvents>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrTeacherFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrTeacherGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrTeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrTeacherGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherGrades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<StudentOrTeacherLatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<StudentOrTeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<StudentOrTeacherLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrTeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentOrTeacherLessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<StudentOrTeacherLiveClassAttendees>>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<StudentOrTeacherLiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<StudentOrTeacherMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherMarks>>;
  me?: EntireFieldWrapper<Maybe<StudentOrTeacherUserData>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<StudentOrTeacherMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<StudentOrTeacherMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherMeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<StudentOrTeacherNotifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<StudentOrTeacherNotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherNotifications>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<StudentOrTeacherParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherParents>>;
  /** fetch data from the table: "private.adresses" */
  private_adresses: EntireFieldWrapper<Array<StudentOrTeacherPrivateAdresses>>;
  /** fetch aggregated fields from the table: "private.adresses" */
  private_adresses_aggregate: EntireFieldWrapper<StudentOrTeacherPrivateAdressesAggregate>;
  /** fetch data from the table: "private.adresses" using primary key columns */
  private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdresses>>;
  /** fetch data from the table: "private.birthdays" */
  private_birthdays: EntireFieldWrapper<Array<StudentOrTeacherPrivateBirthdays>>;
  /** fetch aggregated fields from the table: "private.birthdays" */
  private_birthdays_aggregate: EntireFieldWrapper<StudentOrTeacherPrivateBirthdaysAggregate>;
  /** fetch data from the table: "private.birthdays" using primary key columns */
  private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdays>>;
  /** fetch data from the table: "private.insurance_numbers" */
  private_insurance_numbers: EntireFieldWrapper<Array<StudentOrTeacherPrivateInsuranceNumbers>>;
  /** fetch aggregated fields from the table: "private.insurance_numbers" */
  private_insurance_numbers_aggregate: EntireFieldWrapper<StudentOrTeacherPrivateInsuranceNumbersAggregate>;
  /** fetch data from the table: "private.insurance_numbers" using primary key columns */
  private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbers>>;
  /** fetch data from the table: "private.phone_numbers" */
  private_phone_numbers: EntireFieldWrapper<Array<StudentOrTeacherPrivatePhoneNumbers>>;
  /** fetch aggregated fields from the table: "private.phone_numbers" */
  private_phone_numbers_aggregate: EntireFieldWrapper<StudentOrTeacherPrivatePhoneNumbersAggregate>;
  /** fetch data from the table: "private.phone_numbers" using primary key columns */
  private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbers>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentOrTeacherPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPromotions>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<StudentOrTeacherRelationships>>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<StudentOrTeacherRelationshipsAggregate>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationships>>;
  /** fetch data from the table: "school_settings" */
  school_settings: EntireFieldWrapper<Array<StudentOrTeacherSchoolSettings>>;
  /** fetch aggregated fields from the table: "school_settings" */
  school_settings_aggregate: EntireFieldWrapper<StudentOrTeacherSchoolSettingsAggregate>;
  /** fetch data from the table: "school_settings" using primary key columns */
  school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettings>>;
  /** fetch data from the table: "school_settings_modules" */
  school_settings_modules: EntireFieldWrapper<Array<StudentOrTeacherSchoolSettingsModules>>;
  /** fetch aggregated fields from the table: "school_settings_modules" */
  school_settings_modules_aggregate: EntireFieldWrapper<StudentOrTeacherSchoolSettingsModulesAggregate>;
  /** fetch data from the table: "school_settings_modules" using primary key columns */
  school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModules>>;
  /** fetch data from the table: "schools" */
  schools: EntireFieldWrapper<Array<StudentOrTeacherSchools>>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: EntireFieldWrapper<StudentOrTeacherSchoolsAggregate>;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSchools>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<StudentOrTeacherSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSemesters>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<StudentOrTeacherStudentGroupUsers>>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherStudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<StudentOrTeacherStudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherStudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentOrTeacherStudents>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentOrTeacherStudentsAggregate>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<StudentOrTeacherSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<StudentOrTeacherTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<StudentOrTeacherTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<StudentOrTeacherTeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentOrTeacherTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<StudentOrTeacherTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<StudentOrTeacherTeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructureStudents>>;
  /** fetch data from the table: "teaching_structure_students" using primary key columns */
  teaching_structure_students_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentOrTeacherTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructures>>;
  /** fetch data from the table: "users" */
  users: EntireFieldWrapper<Array<StudentOrTeacherUsers>>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: EntireFieldWrapper<StudentOrTeacherUsersAggregate>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<StudentOrTeacherViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<StudentOrTeacherViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<StudentOrTeacherViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<StudentOrTeacherViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrTeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrTeacherViewGradesAggregate>;
  /** fetch data from the table: "view.grades_for_students" */
  view_grades_for_students: EntireFieldWrapper<Array<StudentOrTeacherViewGradesForStudents>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<StudentOrTeacherViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<StudentOrTeacherViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<StudentOrTeacherViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<StudentOrTeacherViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<StudentOrTeacherViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<StudentOrTeacherYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<StudentOrTeacherYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherYears>>;
}


export interface StudentOrTeacherQueryRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentAttendeeTypeBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface StudentOrTeacherQueryRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentBookChapterBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionContentBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentFilesBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentNotesOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentNotesBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionAnswersBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionOptionsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuizOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuizBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentSubmitsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentTypeBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherQueryRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentUserOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentUserBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


export interface StudentOrTeacherQueryRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAttendanceTypesOrderBy>>;
  where?: Maybe<StudentOrTeacherAttendanceTypesBoolExp>;
}


export interface StudentOrTeacherQueryRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface StudentOrTeacherQueryRootAttendancesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAttendancesOrderBy>>;
  where?: Maybe<StudentOrTeacherAttendancesBoolExp>;
}


export interface StudentOrTeacherQueryRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAuthAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountProvidersBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAuthAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountRolesBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAuthAccountsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthAccountsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAuthProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthProvidersBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthProvidersOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthProvidersBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


export interface StudentOrTeacherQueryRootAuthRefreshTokensArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthRefreshTokensBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthRefreshTokensBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootAuthRolesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthRolesBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAuthRolesOrderBy>>;
  where?: Maybe<StudentOrTeacherAuthRolesBoolExp>;
}


export interface StudentOrTeacherQueryRootAuthRolesByPkArgs {
  role: Scalars['String'];
}


export interface StudentOrTeacherQueryRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookChapterTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherBookChapterTypeBoolExp>;
}


export interface StudentOrTeacherQueryRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherQueryRootBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookChaptersOrderBy>>;
  where?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
}


export interface StudentOrTeacherQueryRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootBookCourseArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookCourseOrderBy>>;
  where?: Maybe<StudentOrTeacherBookCourseBoolExp>;
}


export interface StudentOrTeacherQueryRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootBookUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookUserOrderBy>>;
  where?: Maybe<StudentOrTeacherBookUserBoolExp>;
}


export interface StudentOrTeacherQueryRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootBooksArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBooksOrderBy>>;
  where?: Maybe<StudentOrTeacherBooksBoolExp>;
}


export interface StudentOrTeacherQueryRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
}


export interface StudentOrTeacherQueryRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
}


export interface StudentOrTeacherQueryRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionTypeBoolExp>;
}


export interface StudentOrTeacherQueryRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherQueryRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
}


export interface StudentOrTeacherQueryRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
}


export interface StudentOrTeacherQueryRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
}


export interface StudentOrTeacherQueryRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageReadsOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageReadsBoolExp>;
}


export interface StudentOrTeacherQueryRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


export interface StudentOrTeacherQueryRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


export interface StudentOrTeacherQueryRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChatTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherChatTypeBoolExp>;
}


export interface StudentOrTeacherQueryRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherQueryRootChatUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatUserOrderBy>>;
  where?: Maybe<StudentOrTeacherChatUserBoolExp>;
}


export interface StudentOrTeacherQueryRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootChatsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatsOrderBy>>;
  where?: Maybe<StudentOrTeacherChatsBoolExp>;
}


export interface StudentOrTeacherQueryRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootClassLevelsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassLevelsOrderBy>>;
  where?: Maybe<StudentOrTeacherClassLevelsBoolExp>;
}


export interface StudentOrTeacherQueryRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootClassTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherClassTypeBoolExp>;
}


export interface StudentOrTeacherQueryRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherQueryRootClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassesOrderBy>>;
  where?: Maybe<StudentOrTeacherClassesBoolExp>;
}


export interface StudentOrTeacherQueryRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassroomsOrderBy>>;
  where?: Maybe<StudentOrTeacherClassroomsBoolExp>;
}


export interface StudentOrTeacherQueryRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootCourseClassArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassBoolExp>;
}


export interface StudentOrTeacherQueryRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassroomBoolExp>;
}


export interface StudentOrTeacherQueryRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootCourseStudentArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseStudentOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseStudentBoolExp>;
}


export interface StudentOrTeacherQueryRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseTeacherBoolExp>;
}


export interface StudentOrTeacherQueryRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCoursesOrderBy>>;
  where?: Maybe<StudentOrTeacherCoursesBoolExp>;
}


export interface StudentOrTeacherQueryRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootEventUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherEventUsersOrderBy>>;
  where?: Maybe<StudentOrTeacherEventUsersBoolExp>;
}


export interface StudentOrTeacherQueryRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootEventsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherEventsOrderBy>>;
  where?: Maybe<StudentOrTeacherEventsBoolExp>;
}


export interface StudentOrTeacherQueryRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherFilesBoolExp>;
}


export interface StudentOrTeacherQueryRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradeTypesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
}


export interface StudentOrTeacherQueryRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


export interface StudentOrTeacherQueryRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


export interface StudentOrTeacherQueryRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLatestActivitiesOrderBy>>;
  where?: Maybe<StudentOrTeacherLatestActivitiesBoolExp>;
}


export interface StudentOrTeacherQueryRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonAttendaceTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonAttendaceTypeBoolExp>;
}


export interface StudentOrTeacherQueryRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherQueryRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonAttendancesOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonAttendancesBoolExp>;
}


export interface StudentOrTeacherQueryRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


export interface StudentOrTeacherQueryRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


export interface StudentOrTeacherQueryRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<StudentOrTeacherLiveClassAttendeesBoolExp>;
}


export interface StudentOrTeacherQueryRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootLiveClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLiveClassesOrderBy>>;
  where?: Maybe<StudentOrTeacherLiveClassesBoolExp>;
}


export interface StudentOrTeacherQueryRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootMarksArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherMarksOrderBy>>;
  where?: Maybe<StudentOrTeacherMarksBoolExp>;
}


export interface StudentOrTeacherQueryRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootMeetingUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherMeetingUserOrderBy>>;
  where?: Maybe<StudentOrTeacherMeetingUserBoolExp>;
}


export interface StudentOrTeacherQueryRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherMeetingUserOrderBy>>;
  where?: Maybe<StudentOrTeacherMeetingUserBoolExp>;
}


export interface StudentOrTeacherQueryRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootNotificationsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherNotificationsOrderBy>>;
  where?: Maybe<StudentOrTeacherNotificationsBoolExp>;
}


export interface StudentOrTeacherQueryRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherNotificationsOrderBy>>;
  where?: Maybe<StudentOrTeacherNotificationsBoolExp>;
}


export interface StudentOrTeacherQueryRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootParentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherParentsOrderBy>>;
  where?: Maybe<StudentOrTeacherParentsBoolExp>;
}


export interface StudentOrTeacherQueryRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootPrivateAdressesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivateAdressesOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivateAdressesBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivateAdressesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivateAdressesOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivateAdressesBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootPrivateBirthdaysArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivateBirthdaysOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivateBirthdaysBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivateBirthdaysAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivateBirthdaysOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivateBirthdaysBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootPrivateInsuranceNumbersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivateInsuranceNumbersBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivateInsuranceNumbersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivateInsuranceNumbersBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootPrivatePhoneNumbersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivatePhoneNumbersBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivatePhoneNumbersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<StudentOrTeacherPrivatePhoneNumbersBoolExp>;
}


export interface StudentOrTeacherQueryRootPrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootPromotionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPromotionsOrderBy>>;
  where?: Maybe<StudentOrTeacherPromotionsBoolExp>;
}


export interface StudentOrTeacherQueryRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootRelationshipsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherRelationshipsOrderBy>>;
  where?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
}


export interface StudentOrTeacherQueryRootRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherRelationshipsOrderBy>>;
  where?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
}


export interface StudentOrTeacherQueryRootRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootSchoolSettingsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSchoolSettingsOrderBy>>;
  where?: Maybe<StudentOrTeacherSchoolSettingsBoolExp>;
}


export interface StudentOrTeacherQueryRootSchoolSettingsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSchoolSettingsOrderBy>>;
  where?: Maybe<StudentOrTeacherSchoolSettingsBoolExp>;
}


export interface StudentOrTeacherQueryRootSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootSchoolSettingsModulesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSchoolSettingsModulesOrderBy>>;
  where?: Maybe<StudentOrTeacherSchoolSettingsModulesBoolExp>;
}


export interface StudentOrTeacherQueryRootSchoolSettingsModulesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSchoolSettingsModulesOrderBy>>;
  where?: Maybe<StudentOrTeacherSchoolSettingsModulesBoolExp>;
}


export interface StudentOrTeacherQueryRootSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootSchoolsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSchoolsOrderBy>>;
  where?: Maybe<StudentOrTeacherSchoolsBoolExp>;
}


export interface StudentOrTeacherQueryRootSchoolsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSchoolsOrderBy>>;
  where?: Maybe<StudentOrTeacherSchoolsBoolExp>;
}


export interface StudentOrTeacherQueryRootSchoolsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootSemestersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSemestersOrderBy>>;
  where?: Maybe<StudentOrTeacherSemestersBoolExp>;
}


export interface StudentOrTeacherQueryRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentGroupUsersBoolExp>;
}


export interface StudentOrTeacherQueryRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentGroupsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentGroupsBoolExp>;
}


export interface StudentOrTeacherQueryRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentsBoolExp>;
}


export interface StudentOrTeacherQueryRootStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentsBoolExp>;
}


export interface StudentOrTeacherQueryRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootSubjectsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSubjectsOrderBy>>;
  where?: Maybe<StudentOrTeacherSubjectsBoolExp>;
}


export interface StudentOrTeacherQueryRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootTasksArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTasksOrderBy>>;
  where?: Maybe<StudentOrTeacherTasksBoolExp>;
}


export interface StudentOrTeacherQueryRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTasksOrderBy>>;
  where?: Maybe<StudentOrTeacherTasksBoolExp>;
}


export interface StudentOrTeacherQueryRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeacherSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachersOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachersBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootTeachingStructureLeafsArgs {
  args: StudentOrTeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachingStructureLeafsAggregateArgs {
  args: StudentOrTeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachingStructureParentsArgs {
  args: StudentOrTeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachingStructureParentsAggregateArgs {
  args: StudentOrTeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructureStudentsBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachingStructureStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherQueryRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherUsersOrderBy>>;
  where?: Maybe<StudentOrTeacherUsersBoolExp>;
}


export interface StudentOrTeacherQueryRootUsersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherUsersOrderBy>>;
  where?: Maybe<StudentOrTeacherUsersBoolExp>;
}


export interface StudentOrTeacherQueryRootUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherQueryRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentOrTeacherViewAssignmentClassBoolExp>;
}


export interface StudentOrTeacherQueryRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<StudentOrTeacherViewAssignmentStudentGradeBoolExp>;
}


export interface StudentOrTeacherQueryRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewClassStudentOrderBy>>;
  where?: Maybe<StudentOrTeacherViewClassStudentBoolExp>;
}


export interface StudentOrTeacherQueryRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradeTypeSubjectBoolExp>;
}


export interface StudentOrTeacherQueryRootViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}


export interface StudentOrTeacherQueryRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}


export interface StudentOrTeacherQueryRootViewGradesForStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesForStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesForStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesForStudentsBoolExp>;
}


export interface StudentOrTeacherQueryRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewLatestChatMessagesBoolExp>;
}


export interface StudentOrTeacherQueryRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewLatestChatMessagesBoolExp>;
}


export interface StudentOrTeacherQueryRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface StudentOrTeacherQueryRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewSubjectSemesterOrderBy>>;
  where?: Maybe<StudentOrTeacherViewSubjectSemesterBoolExp>;
}


export interface StudentOrTeacherQueryRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherViewTeacherClassSubjectBoolExp>;
}


export interface StudentOrTeacherQueryRootYearsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherYearsOrderBy>>;
  where?: Maybe<StudentOrTeacherYearsBoolExp>;
}


export interface StudentOrTeacherQueryRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherYearsOrderBy>>;
  where?: Maybe<StudentOrTeacherYearsBoolExp>;
}


export interface StudentOrTeacherQueryRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "relationships" */
export interface StudentOrTeacherRelationships {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  related: EntireFieldWrapper<StudentOrTeacherUsers>;
  related_id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<StudentOrTeacherAuthRoles>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrTeacherUsers>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "relationships" */
export interface StudentOrTeacherRelationshipsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationshipsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherRelationships>>;
}

/** aggregate fields of "relationships" */
export interface StudentOrTeacherRelationshipsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationshipsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherRelationshipsMinFields>>;
}


/** aggregate fields of "relationships" */
export interface StudentOrTeacherRelationshipsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherRelationshipsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "relationships" */
export interface StudentOrTeacherRelationshipsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherRelationshipsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherRelationshipsMinOrderBy>;
}

/** input type for inserting array relation for remote table "relationships" */
export interface StudentOrTeacherRelationshipsArrRelInsertInput {
  data: Array<StudentOrTeacherRelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherRelationshipsOnConflict>;
}

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherRelationshipsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherRelationshipsBoolExp>>;
  _not?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherRelationshipsBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  related?: Maybe<StudentOrTeacherUsersBoolExp>;
  related_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  role?: Maybe<StudentOrTeacherStringComparisonExp>;
  roleByRole?: Maybe<StudentOrTeacherAuthRolesBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user?: Maybe<StudentOrTeacherUsersBoolExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "relationships" */
export const enum StudentOrTeacherRelationshipsConstraint {
  /** unique or primary key constraint */
  RELATIONSHIPS_PKEY = 'relationships_pkey',
  /** unique or primary key constraint */
  RELATIONSHIPS_USER_ID_RELATED_ID_KEY = 'relationships_user_id_related_id_key'
};

/** input type for inserting data into table "relationships" */
export interface StudentOrTeacherRelationshipsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related?: Maybe<StudentOrTeacherUsersObjRelInsertInput>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<StudentOrTeacherAuthRolesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrTeacherUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherRelationshipsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "relationships" */
export interface StudentOrTeacherRelationshipsMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  related_id?: Maybe<StudentOrTeacherOrderBy>;
  role?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherRelationshipsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "relationships" */
export interface StudentOrTeacherRelationshipsMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  related_id?: Maybe<StudentOrTeacherOrderBy>;
  role?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** response of any mutation on the table "relationships" */
export interface StudentOrTeacherRelationshipsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherRelationships>>;
}

/** on conflict condition type for table "relationships" */
export interface StudentOrTeacherRelationshipsOnConflict {
  constraint: StudentOrTeacherRelationshipsConstraint;
  update_columns?: Array<StudentOrTeacherRelationshipsUpdateColumn>;
  where?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
}

/** Ordering options when selecting data from "relationships". */
export interface StudentOrTeacherRelationshipsOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  related?: Maybe<StudentOrTeacherUsersOrderBy>;
  related_id?: Maybe<StudentOrTeacherOrderBy>;
  role?: Maybe<StudentOrTeacherOrderBy>;
  roleByRole?: Maybe<StudentOrTeacherAuthRolesOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user?: Maybe<StudentOrTeacherUsersOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: relationships */
export interface StudentOrTeacherRelationshipsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "relationships" */
export const enum StudentOrTeacherRelationshipsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "relationships" */
export interface StudentOrTeacherRelationshipsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "relationships" */
export const enum StudentOrTeacherRelationshipsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/**
 * General settings for school
 *
 *
 * columns and relationships of "school_settings"
 */
export interface StudentOrTeacherSchoolSettings {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school: EntireFieldWrapper<StudentOrTeacherSchools>;
  school_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school_settings_module?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModules>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings" */
export interface StudentOrTeacherSchoolSettingsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherSchoolSettings>>;
}

/** aggregate fields of "school_settings" */
export interface StudentOrTeacherSchoolSettingsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsMinFields>>;
}


/** aggregate fields of "school_settings" */
export interface StudentOrTeacherSchoolSettingsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherSchoolSettingsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherSchoolSettingsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherSchoolSettingsBoolExp>>;
  _not?: Maybe<StudentOrTeacherSchoolSettingsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherSchoolSettingsBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  school?: Maybe<StudentOrTeacherSchoolsBoolExp>;
  school_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  school_settings_module?: Maybe<StudentOrTeacherSchoolSettingsModulesBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings" */
export const enum StudentOrTeacherSchoolSettingsConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_PKEY = 'school_settings_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_SCHOOL_ID_KEY = 'school_settings_school_id_key'
};

/** input type for inserting data into table "school_settings" */
export interface StudentOrTeacherSchoolSettingsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school?: Maybe<StudentOrTeacherSchoolsObjRelInsertInput>;
  school_id?: Maybe<Scalars['uuid']>;
  school_settings_module?: Maybe<StudentOrTeacherSchoolSettingsModulesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherSchoolSettingsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherSchoolSettingsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/**
 * Enable or disable module in application for school of choice
 *
 *
 * columns and relationships of "school_settings_modules"
 */
export interface StudentOrTeacherSchoolSettingsModules {
  assignments: EntireFieldWrapper<Scalars['Boolean']>;
  chat: EntireFieldWrapper<Scalars['Boolean']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  grading: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  live_class: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  school_setting: EntireFieldWrapper<StudentOrTeacherSchoolSettings>;
  school_settings_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModulesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherSchoolSettingsModules>>;
}

/** aggregate fields of "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModulesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettingsModulesMinFields>>;
}


/** aggregate fields of "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherSchoolSettingsModulesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings_modules". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherSchoolSettingsModulesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherSchoolSettingsModulesBoolExp>>;
  _not?: Maybe<StudentOrTeacherSchoolSettingsModulesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherSchoolSettingsModulesBoolExp>>;
  assignments?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  chat?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  grading?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  live_class?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  school_setting?: Maybe<StudentOrTeacherSchoolSettingsBoolExp>;
  school_settings_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings_modules" */
export const enum StudentOrTeacherSchoolSettingsModulesConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_PKEY = 'school_settings_modules_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_SCHOOL_SETTINGS_ID_KEY = 'school_settings_modules_school_settings_id_key'
};

/** input type for inserting data into table "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesInsertInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_setting?: Maybe<StudentOrTeacherSchoolSettingsObjRelInsertInput>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherSchoolSettingsModulesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherSchoolSettingsModulesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherSchoolSettingsModules>>;
}

/** input type for inserting object relation for remote table "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesObjRelInsertInput {
  data: StudentOrTeacherSchoolSettingsModulesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherSchoolSettingsModulesOnConflict>;
}

/** on conflict condition type for table "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesOnConflict {
  constraint: StudentOrTeacherSchoolSettingsModulesConstraint;
  update_columns?: Array<StudentOrTeacherSchoolSettingsModulesUpdateColumn>;
  where?: Maybe<StudentOrTeacherSchoolSettingsModulesBoolExp>;
}

/** Ordering options when selecting data from "school_settings_modules". */
export interface StudentOrTeacherSchoolSettingsModulesOrderBy {
  assignments?: Maybe<StudentOrTeacherOrderBy>;
  chat?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grading?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  live_class?: Maybe<StudentOrTeacherOrderBy>;
  school_setting?: Maybe<StudentOrTeacherSchoolSettingsOrderBy>;
  school_settings_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: school_settings_modules */
export interface StudentOrTeacherSchoolSettingsModulesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings_modules" */
export const enum StudentOrTeacherSchoolSettingsModulesSelectColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings_modules" */
export interface StudentOrTeacherSchoolSettingsModulesSetInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings_modules" */
export const enum StudentOrTeacherSchoolSettingsModulesUpdateColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** response of any mutation on the table "school_settings" */
export interface StudentOrTeacherSchoolSettingsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherSchoolSettings>>;
}

/** input type for inserting object relation for remote table "school_settings" */
export interface StudentOrTeacherSchoolSettingsObjRelInsertInput {
  data: StudentOrTeacherSchoolSettingsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherSchoolSettingsOnConflict>;
}

/** on conflict condition type for table "school_settings" */
export interface StudentOrTeacherSchoolSettingsOnConflict {
  constraint: StudentOrTeacherSchoolSettingsConstraint;
  update_columns?: Array<StudentOrTeacherSchoolSettingsUpdateColumn>;
  where?: Maybe<StudentOrTeacherSchoolSettingsBoolExp>;
}

/** Ordering options when selecting data from "school_settings". */
export interface StudentOrTeacherSchoolSettingsOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  school?: Maybe<StudentOrTeacherSchoolsOrderBy>;
  school_id?: Maybe<StudentOrTeacherOrderBy>;
  school_settings_module?: Maybe<StudentOrTeacherSchoolSettingsModulesOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: school_settings */
export interface StudentOrTeacherSchoolSettingsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings" */
export const enum StudentOrTeacherSchoolSettingsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings" */
export interface StudentOrTeacherSchoolSettingsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings" */
export const enum StudentOrTeacherSchoolSettingsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Used for UUID tokens for schools.
 *
 *
 * columns and relationships of "schools"
 */
export interface StudentOrTeacherSchools {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  path: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  school_setting?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolSettings>>;
  serial: EntireFieldWrapper<Scalars['String']>;
}

/** aggregated selection of "schools" */
export interface StudentOrTeacherSchoolsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherSchools>>;
}

/** aggregate fields of "schools" */
export interface StudentOrTeacherSchoolsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherSchoolsMinFields>>;
}


/** aggregate fields of "schools" */
export interface StudentOrTeacherSchoolsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherSchoolsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "schools". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherSchoolsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherSchoolsBoolExp>>;
  _not?: Maybe<StudentOrTeacherSchoolsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherSchoolsBoolExp>>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  path?: Maybe<StudentOrTeacherStringComparisonExp>;
  school_setting?: Maybe<StudentOrTeacherSchoolSettingsBoolExp>;
  serial?: Maybe<StudentOrTeacherStringComparisonExp>;
}

/** unique or primary key constraints on table "schools" */
export const enum StudentOrTeacherSchoolsConstraint {
  /** unique or primary key constraint */
  SCHOOLS_PKEY = 'schools_pkey'
};

/** input type for inserting data into table "schools" */
export interface StudentOrTeacherSchoolsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  school_setting?: Maybe<StudentOrTeacherSchoolSettingsObjRelInsertInput>;
  serial?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherSchoolsMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherSchoolsMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "schools" */
export interface StudentOrTeacherSchoolsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherSchools>>;
}

/** input type for inserting object relation for remote table "schools" */
export interface StudentOrTeacherSchoolsObjRelInsertInput {
  data: StudentOrTeacherSchoolsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherSchoolsOnConflict>;
}

/** on conflict condition type for table "schools" */
export interface StudentOrTeacherSchoolsOnConflict {
  constraint: StudentOrTeacherSchoolsConstraint;
  update_columns?: Array<StudentOrTeacherSchoolsUpdateColumn>;
  where?: Maybe<StudentOrTeacherSchoolsBoolExp>;
}

/** Ordering options when selecting data from "schools". */
export interface StudentOrTeacherSchoolsOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  path?: Maybe<StudentOrTeacherOrderBy>;
  school_setting?: Maybe<StudentOrTeacherSchoolSettingsOrderBy>;
  serial?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: schools */
export interface StudentOrTeacherSchoolsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "schools" */
export const enum StudentOrTeacherSchoolsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** input type for updating data in table "schools" */
export interface StudentOrTeacherSchoolsSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
}

/** update columns of table "schools" */
export const enum StudentOrTeacherSchoolsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** columns and relationships of "semesters" */
export interface StudentOrTeacherSemesters {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_at: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  start_at: EntireFieldWrapper<Scalars['date']>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "semesters". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherSemestersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherSemestersBoolExp>>;
  _not?: Maybe<StudentOrTeacherSemestersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherSemestersBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  end_at?: Maybe<StudentOrTeacherDateComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  start_at?: Maybe<StudentOrTeacherDateComparisonExp>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "semesters". */
export interface StudentOrTeacherSemestersOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  end_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  start_at?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "semesters" */
export const enum StudentOrTeacherSemestersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_AT = 'end_at',
  /** column name */
  ID = 'id',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "student_group_users" */
export interface StudentOrTeacherStudentGroupUsers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  live_class_group: EntireFieldWrapper<Array<StudentOrTeacherStudentGroups>>;
  student_group_id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_group_users" */
export interface StudentOrTeacherStudentGroupUsersLiveClassGroupArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentGroupsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentGroupsBoolExp>;
}

/** order by aggregate values of table "student_group_users" */
export interface StudentOrTeacherStudentGroupUsersAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherStudentGroupUsersMaxOrderBy>;
  min?: Maybe<StudentOrTeacherStudentGroupUsersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "student_group_users". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherStudentGroupUsersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherStudentGroupUsersBoolExp>>;
  _not?: Maybe<StudentOrTeacherStudentGroupUsersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherStudentGroupUsersBoolExp>>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  live_class_group?: Maybe<StudentOrTeacherStudentGroupsBoolExp>;
  student_group_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "student_group_users" */
export interface StudentOrTeacherStudentGroupUsersMaxOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_group_id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "student_group_users" */
export interface StudentOrTeacherStudentGroupUsersMinOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_group_id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "student_group_users". */
export interface StudentOrTeacherStudentGroupUsersOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  live_class_group_aggregate?: Maybe<StudentOrTeacherStudentGroupsAggregateOrderBy>;
  student_group_id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "student_group_users" */
export const enum StudentOrTeacherStudentGroupUsersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_GROUP_ID = 'student_group_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "student_groups" */
export interface StudentOrTeacherStudentGroups {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lesson: EntireFieldWrapper<Array<StudentOrTeacherLessons>>;
  /** An aggregate relationship */
  lesson_aggregate: EntireFieldWrapper<StudentOrTeacherLessonsAggregate>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentOrTeacherStudentGroupUsers>>;
  /** An array relationship */
  teacher: EntireFieldWrapper<Array<StudentOrTeacherTeachers>>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_groups" */
export interface StudentOrTeacherStudentGroupsLessonArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentOrTeacherStudentGroupsLessonAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentOrTeacherStudentGroupsStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentGroupUsersBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentOrTeacherStudentGroupsTeacherArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachersOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachersBoolExp>;
}

/** order by aggregate values of table "student_groups" */
export interface StudentOrTeacherStudentGroupsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherStudentGroupsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherStudentGroupsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "student_groups". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherStudentGroupsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherStudentGroupsBoolExp>>;
  _not?: Maybe<StudentOrTeacherStudentGroupsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherStudentGroupsBoolExp>>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  lesson?: Maybe<StudentOrTeacherLessonsBoolExp>;
  lesson_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  students?: Maybe<StudentOrTeacherStudentGroupUsersBoolExp>;
  teacher?: Maybe<StudentOrTeacherTeachersBoolExp>;
  teacher_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "student_groups" */
export interface StudentOrTeacherStudentGroupsMaxOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "student_groups" */
export interface StudentOrTeacherStudentGroupsMinOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "student_groups". */
export interface StudentOrTeacherStudentGroupsOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  lesson_aggregate?: Maybe<StudentOrTeacherLessonsAggregateOrderBy>;
  lesson_id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  students_aggregate?: Maybe<StudentOrTeacherStudentGroupUsersAggregateOrderBy>;
  teacher_aggregate?: Maybe<StudentOrTeacherTeachersAggregateOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "student_groups" */
export const enum StudentOrTeacherStudentGroupsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  NAME = 'name',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "students" */
export interface StudentOrTeacherStudents {
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionSubmits>>;
  /** An object relationship */
  class: EntireFieldWrapper<StudentOrTeacherClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  course_students: EntireFieldWrapper<Array<StudentOrTeacherCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrTeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrTeacherGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
}


/** columns and relationships of "students" */
export interface StudentOrTeacherStudentsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrTeacherStudentsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrTeacherStudentsCourseStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseStudentOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseStudentBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrTeacherStudentsGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrTeacherStudentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}

/** aggregated selection of "students" */
export interface StudentOrTeacherStudentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherStudentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherStudents>>;
}

/** aggregate fields of "students" */
export interface StudentOrTeacherStudentsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherStudentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherStudentsMinFields>>;
}


/** aggregate fields of "students" */
export interface StudentOrTeacherStudentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherStudentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "students" */
export interface StudentOrTeacherStudentsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherStudentsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherStudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "students". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherStudentsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherStudentsBoolExp>>;
  _not?: Maybe<StudentOrTeacherStudentsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherStudentsBoolExp>>;
  chapter_section_notes?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
  class?: Maybe<StudentOrTeacherClassesBoolExp>;
  class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  course_students?: Maybe<StudentOrTeacherCourseStudentBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  grades?: Maybe<StudentOrTeacherGradesBoolExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherStudentsMaxFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "students" */
export interface StudentOrTeacherStudentsMaxOrderBy {
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherStudentsMinFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "students" */
export interface StudentOrTeacherStudentsMinOrderBy {
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "students". */
export interface StudentOrTeacherStudentsOrderBy {
  chapter_section_notes_aggregate?: Maybe<StudentOrTeacherChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<StudentOrTeacherChapterSectionSubmitsAggregateOrderBy>;
  class?: Maybe<StudentOrTeacherClassesOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  course_students_aggregate?: Maybe<StudentOrTeacherCourseStudentAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grades_aggregate?: Maybe<StudentOrTeacherGradesAggregateOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "students" */
export const enum StudentOrTeacherStudentsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjects {
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentOrTeacherBooks>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentOrTeacherClassrooms>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentOrTeacherCourses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrTeacherViewGradeTypeSubject>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  statistics: EntireFieldWrapper<Array<StudentOrTeacherViewStatisticsSemesterSubjectMark>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<StudentOrTeacherTeacherSubject>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrTeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrTeacherViewGradesAggregate>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsBooksArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBooksOrderBy>>;
  where?: Maybe<StudentOrTeacherBooksBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassroomsOrderBy>>;
  where?: Maybe<StudentOrTeacherClassroomsBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCoursesOrderBy>>;
  where?: Maybe<StudentOrTeacherCoursesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradeTypeSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsStatisticsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeacherSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrTeacherSubjectsViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}

/** order by aggregate values of table "subjects" */
export interface StudentOrTeacherSubjectsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherSubjectsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherSubjectsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "subjects". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherSubjectsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherSubjectsBoolExp>>;
  _not?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherSubjectsBoolExp>>;
  books?: Maybe<StudentOrTeacherBooksBoolExp>;
  classrooms?: Maybe<StudentOrTeacherClassroomsBoolExp>;
  courses?: Maybe<StudentOrTeacherCoursesBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  grade_types?: Maybe<StudentOrTeacherViewGradeTypeSubjectBoolExp>;
  icon?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  statistics?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp>;
  teacher_subjects?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  view_grades?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}

/** order by max() on columns of table "subjects" */
export interface StudentOrTeacherSubjectsMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  icon?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "subjects" */
export interface StudentOrTeacherSubjectsMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  icon?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "subjects". */
export interface StudentOrTeacherSubjectsOrderBy {
  books_aggregate?: Maybe<StudentOrTeacherBooksAggregateOrderBy>;
  classrooms_aggregate?: Maybe<StudentOrTeacherClassroomsAggregateOrderBy>;
  courses_aggregate?: Maybe<StudentOrTeacherCoursesAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  grade_types_aggregate?: Maybe<StudentOrTeacherViewGradeTypeSubjectAggregateOrderBy>;
  icon?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  statistics_aggregate?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkAggregateOrderBy>;
  teacher_subjects_aggregate?: Maybe<StudentOrTeacherTeacherSubjectAggregateOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  view_grades_aggregate?: Maybe<StudentOrTeacherViewGradesAggregateOrderBy>;
}

/** select columns of table "subjects" */
export const enum StudentOrTeacherSubjectsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ICON = 'icon',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface StudentOrTeacherSubscriptionRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<StudentOrTeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<StudentOrTeacherAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<StudentOrTeacherAssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<StudentOrTeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<StudentOrTeacherAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<StudentOrTeacherAssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestionOptions>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<StudentOrTeacherAssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentOrTeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<StudentOrTeacherAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<StudentOrTeacherAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrTeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<StudentOrTeacherAttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<StudentOrTeacherAttendances>>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherAttendances>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<StudentOrTeacherBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrTeacherBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<StudentOrTeacherBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<StudentOrTeacherBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentOrTeacherBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<StudentOrTeacherChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrTeacherChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentOrTeacherChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentOrTeacherChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentOrTeacherChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrTeacherChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrTeacherChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<StudentOrTeacherChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<StudentOrTeacherChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentOrTeacherChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<StudentOrTeacherClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<StudentOrTeacherClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrTeacherClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentOrTeacherClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<StudentOrTeacherCourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<StudentOrTeacherCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<StudentOrTeacherCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<StudentOrTeacherCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentOrTeacherCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<StudentOrTeacherEventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<StudentOrTeacherEvents>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrTeacherFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrTeacherGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrTeacherGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrTeacherGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherGrades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<StudentOrTeacherLatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<StudentOrTeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<StudentOrTeacherLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrTeacherLessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<StudentOrTeacherLessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<StudentOrTeacherLiveClassAttendees>>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<StudentOrTeacherLiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<StudentOrTeacherMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherMarks>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<StudentOrTeacherMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<StudentOrTeacherMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherMeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<StudentOrTeacherNotifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<StudentOrTeacherNotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherNotifications>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<StudentOrTeacherParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherParents>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentOrTeacherPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherPromotions>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<StudentOrTeacherSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSemesters>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<StudentOrTeacherStudentGroupUsers>>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherStudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<StudentOrTeacherStudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherStudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentOrTeacherStudents>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentOrTeacherStudentsAggregate>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<StudentOrTeacherSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<StudentOrTeacherTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<StudentOrTeacherTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<StudentOrTeacherTeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentOrTeacherTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<StudentOrTeacherTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<StudentOrTeacherTeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructureStudents>>;
  /** fetch data from the table: "teaching_structure_students" using primary key columns */
  teaching_structure_students_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentOrTeacherTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructures>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<StudentOrTeacherViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<StudentOrTeacherViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<StudentOrTeacherViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<StudentOrTeacherViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrTeacherViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrTeacherViewGradesAggregate>;
  /** fetch data from the table: "view.grades_for_students" */
  view_grades_for_students: EntireFieldWrapper<Array<StudentOrTeacherViewGradesForStudents>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<StudentOrTeacherViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<StudentOrTeacherViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<StudentOrTeacherViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<StudentOrTeacherViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<StudentOrTeacherViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<StudentOrTeacherYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<StudentOrTeacherYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<StudentOrTeacherYears>>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentAttendeeTypeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentBookChapterBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionContentOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionContentBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentDiscussionSubscriptionBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentFilesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentNotesOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentNotesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionAnswersBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionOptionRelationsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionOptionsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuestionsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuestionsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentQuizOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentQuizBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentSubmitsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentTypeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentUserOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentUserBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAttendanceTypesOrderBy>>;
  where?: Maybe<StudentOrTeacherAttendanceTypesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootAttendancesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAttendancesOrderBy>>;
  where?: Maybe<StudentOrTeacherAttendancesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookChapterTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherBookChapterTypeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookChaptersOrderBy>>;
  where?: Maybe<StudentOrTeacherBookChaptersBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootBookCourseArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookCourseOrderBy>>;
  where?: Maybe<StudentOrTeacherBookCourseBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootBookUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBookUserOrderBy>>;
  where?: Maybe<StudentOrTeacherBookUserBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootBooksArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherBooksOrderBy>>;
  where?: Maybe<StudentOrTeacherBooksBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionNotesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionSubmitsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionTypeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrTeacherChapterSectionsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageLikesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessageReadsOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessageReadsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherChatMessagesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChatTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherChatTypeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootChatUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatUserOrderBy>>;
  where?: Maybe<StudentOrTeacherChatUserBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootChatsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherChatsOrderBy>>;
  where?: Maybe<StudentOrTeacherChatsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootClassLevelsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassLevelsOrderBy>>;
  where?: Maybe<StudentOrTeacherClassLevelsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootClassTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherClassTypeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassesOrderBy>>;
  where?: Maybe<StudentOrTeacherClassesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassroomsOrderBy>>;
  where?: Maybe<StudentOrTeacherClassroomsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootCourseClassArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseClassroomBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootCourseStudentArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseStudentOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseStudentBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseTeacherBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCoursesOrderBy>>;
  where?: Maybe<StudentOrTeacherCoursesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootEventUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherEventUsersOrderBy>>;
  where?: Maybe<StudentOrTeacherEventUsersBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootEventsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherEventsOrderBy>>;
  where?: Maybe<StudentOrTeacherEventsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootFilesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherFilesOrderBy>>;
  where?: Maybe<StudentOrTeacherFilesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradeTypesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLatestActivitiesOrderBy>>;
  where?: Maybe<StudentOrTeacherLatestActivitiesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonAttendaceTypeOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonAttendaceTypeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrTeacherSubscriptionRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonAttendancesOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonAttendancesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLessonsOrderBy>>;
  where?: Maybe<StudentOrTeacherLessonsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLiveClassAttendeesOrderBy>>;
  where?: Maybe<StudentOrTeacherLiveClassAttendeesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootLiveClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherLiveClassesOrderBy>>;
  where?: Maybe<StudentOrTeacherLiveClassesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootMarksArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherMarksOrderBy>>;
  where?: Maybe<StudentOrTeacherMarksBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootMeetingUserArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherMeetingUserOrderBy>>;
  where?: Maybe<StudentOrTeacherMeetingUserBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherMeetingUserOrderBy>>;
  where?: Maybe<StudentOrTeacherMeetingUserBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootNotificationsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherNotificationsOrderBy>>;
  where?: Maybe<StudentOrTeacherNotificationsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherNotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherNotificationsOrderBy>>;
  where?: Maybe<StudentOrTeacherNotificationsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootParentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherParentsOrderBy>>;
  where?: Maybe<StudentOrTeacherParentsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootPromotionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPromotionsOrderBy>>;
  where?: Maybe<StudentOrTeacherPromotionsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootSemestersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSemestersOrderBy>>;
  where?: Maybe<StudentOrTeacherSemestersBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentGroupUsersOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentGroupUsersBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentGroupsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentGroupsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherStudentsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootSubjectsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSubjectsOrderBy>>;
  where?: Maybe<StudentOrTeacherSubjectsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootTasksArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTasksOrderBy>>;
  where?: Maybe<StudentOrTeacherTasksBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTasksOrderBy>>;
  where?: Maybe<StudentOrTeacherTasksBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeacherSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachersOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachersBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootTeachingStructureLeafsArgs {
  args: StudentOrTeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachingStructureLeafsAggregateArgs {
  args: StudentOrTeacherTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachingStructureParentsArgs {
  args: StudentOrTeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachingStructureParentsAggregateArgs {
  args: StudentOrTeacherTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructureStudentsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachingStructureStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrTeacherSubscriptionRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentOrTeacherViewAssignmentClassBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<StudentOrTeacherViewAssignmentStudentGradeBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewClassStudentOrderBy>>;
  where?: Maybe<StudentOrTeacherViewClassStudentBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradeTypeSubjectBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewGradesForStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewGradesForStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewGradesForStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherViewGradesForStudentsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewLatestChatMessagesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrTeacherViewLatestChatMessagesBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewSubjectSemesterOrderBy>>;
  where?: Maybe<StudentOrTeacherViewSubjectSemesterBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherViewTeacherClassSubjectBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootYearsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherYearsOrderBy>>;
  where?: Maybe<StudentOrTeacherYearsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherYearsOrderBy>>;
  where?: Maybe<StudentOrTeacherYearsBoolExp>;
}


export interface StudentOrTeacherSubscriptionRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "tasks" */
export interface StudentOrTeacherTasks {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** The user this tasks belongs. */
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "tasks" */
export interface StudentOrTeacherTasksAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherTasksAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherTasks>>;
}

/** aggregate fields of "tasks" */
export interface StudentOrTeacherTasksAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherTasksMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherTasksMinFields>>;
}


/** aggregate fields of "tasks" */
export interface StudentOrTeacherTasksAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherTasksSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherTasksBoolExp {
  _and?: Maybe<Array<StudentOrTeacherTasksBoolExp>>;
  _not?: Maybe<StudentOrTeacherTasksBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherTasksBoolExp>>;
  body?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  is_completed?: Maybe<StudentOrTeacherBooleanComparisonExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** unique or primary key constraints on table "tasks" */
export const enum StudentOrTeacherTasksConstraint {
  /** unique or primary key constraint */
  TASKS_PKEY = 'tasks_pkey'
};

/** input type for inserting data into table "tasks" */
export interface StudentOrTeacherTasksInsertInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherTasksMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherTasksMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "tasks" */
export interface StudentOrTeacherTasksMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherTasks>>;
}

/** on conflict condition type for table "tasks" */
export interface StudentOrTeacherTasksOnConflict {
  constraint: StudentOrTeacherTasksConstraint;
  update_columns?: Array<StudentOrTeacherTasksUpdateColumn>;
  where?: Maybe<StudentOrTeacherTasksBoolExp>;
}

/** Ordering options when selecting data from "tasks". */
export interface StudentOrTeacherTasksOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  is_completed?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: tasks */
export interface StudentOrTeacherTasksPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "tasks" */
export const enum StudentOrTeacherTasksSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "tasks" */
export interface StudentOrTeacherTasksSetInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "tasks" */
export const enum StudentOrTeacherTasksUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Connection between teachers and subjects with relevant teaching structure
 *
 *
 * columns and relationships of "teacher_subject"
 */
export interface StudentOrTeacherTeacherSubject {
  /** An object relationship */
  subject: EntireFieldWrapper<StudentOrTeacherSubjects>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentOrTeacherTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  teaching_structure: EntireFieldWrapper<StudentOrTeacherTeachingStructures>;
}

/** order by aggregate values of table "teacher_subject" */
export interface StudentOrTeacherTeacherSubjectAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherTeacherSubjectMaxOrderBy>;
  min?: Maybe<StudentOrTeacherTeacherSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teacher_subject". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherTeacherSubjectBoolExp {
  _and?: Maybe<Array<StudentOrTeacherTeacherSubjectBoolExp>>;
  _not?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherTeacherSubjectBoolExp>>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  teacher?: Maybe<StudentOrTeacherTeachersBoolExp>;
  teacher_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}

/** order by max() on columns of table "teacher_subject" */
export interface StudentOrTeacherTeacherSubjectMaxOrderBy {
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "teacher_subject" */
export interface StudentOrTeacherTeacherSubjectMinOrderBy {
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "teacher_subject". */
export interface StudentOrTeacherTeacherSubjectOrderBy {
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  teacher?: Maybe<StudentOrTeacherTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
}

/** select columns of table "teacher_subject" */
export const enum StudentOrTeacherTeacherSubjectSelectColumn {
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "teachers" */
export interface StudentOrTeacherTeachers {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrTeacherClasses>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<StudentOrTeacherClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<StudentOrTeacherCourseTeacher>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<StudentOrTeacherTeacherSubject>>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
}


/** columns and relationships of "teachers" */
export interface StudentOrTeacherTeachersClassesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherClassesOrderBy>>;
  where?: Maybe<StudentOrTeacherClassesBoolExp>;
}


/** columns and relationships of "teachers" */
export interface StudentOrTeacherTeachersCourseTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrTeacherCourseTeacherBoolExp>;
}


/** columns and relationships of "teachers" */
export interface StudentOrTeacherTeachersTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeacherSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
}

/** order by aggregate values of table "teachers" */
export interface StudentOrTeacherTeachersAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherTeachersMaxOrderBy>;
  min?: Maybe<StudentOrTeacherTeachersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherTeachersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherTeachersBoolExp>>;
  _not?: Maybe<StudentOrTeacherTeachersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherTeachersBoolExp>>;
  classes?: Maybe<StudentOrTeacherClassesBoolExp>;
  classroom?: Maybe<StudentOrTeacherClassroomsBoolExp>;
  classroom_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  course_teachers?: Maybe<StudentOrTeacherCourseTeacherBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teacher_subjects?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
  type?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** order by max() on columns of table "teachers" */
export interface StudentOrTeacherTeachersMaxOrderBy {
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "teachers" */
export interface StudentOrTeacherTeachersMinOrderBy {
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "teachers". */
export interface StudentOrTeacherTeachersOrderBy {
  classes_aggregate?: Maybe<StudentOrTeacherClassesAggregateOrderBy>;
  classroom?: Maybe<StudentOrTeacherClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrTeacherOrderBy>;
  course_teachers_aggregate?: Maybe<StudentOrTeacherCourseTeacherAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  teacher_subjects_aggregate?: Maybe<StudentOrTeacherTeacherSubjectAggregateOrderBy>;
  type?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "teachers" */
export const enum StudentOrTeacherTeachersSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface StudentOrTeacherTeachingStructureLeafsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

export interface StudentOrTeacherTeachingStructureParentsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

/** columns and relationships of "teaching_structure_students" */
export interface StudentOrTeacherTeachingStructureStudents {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrTeacherStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrTeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure: EntireFieldWrapper<StudentOrTeacherTeachingStructures>;
  teaching_structure_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teaching_structure_students_subject: EntireFieldWrapper<Array<StudentOrTeacherSubjects>>;
}


/** columns and relationships of "teaching_structure_students" */
export interface StudentOrTeacherTeachingStructureStudentsTeachingStructureStudentsSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherSubjectsOrderBy>>;
  where?: Maybe<StudentOrTeacherSubjectsBoolExp>;
}

/** order by aggregate values of table "teaching_structure_students" */
export interface StudentOrTeacherTeachingStructureStudentsAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherTeachingStructureStudentsMaxOrderBy>;
  min?: Maybe<StudentOrTeacherTeachingStructureStudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structure_students". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherTeachingStructureStudentsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsBoolExp>>;
  _not?: Maybe<StudentOrTeacherTeachingStructureStudentsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsBoolExp>>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teaching_structure_students_subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
}

/** order by max() on columns of table "teaching_structure_students" */
export interface StudentOrTeacherTeachingStructureStudentsMaxOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "teaching_structure_students" */
export interface StudentOrTeacherTeachingStructureStudentsMinOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "teaching_structure_students". */
export interface StudentOrTeacherTeachingStructureStudentsOrderBy {
  id?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrTeacherOrderBy>;
  teaching_structure_students_subject_aggregate?: Maybe<StudentOrTeacherSubjectsAggregateOrderBy>;
}

/** select columns of table "teaching_structure_students" */
export const enum StudentOrTeacherTeachingStructureStudentsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id'
};

/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrTeacherTeachingStructures {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrTeacherAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrTeacherAssignmentsAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  depth: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  ltr: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  parent?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructures>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<StudentOrTeacherSemesters>>;
  /** A computed field, executes function "subject_icon" */
  subject_icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<StudentOrTeacherTeacherSubject>>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentOrTeacherTeachingStructuresAggregate>;
  title: EntireFieldWrapper<Scalars['String']>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrTeacherTeachingStructuresAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrTeacherTeachingStructuresAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherAssignmentsOrderBy>>;
  where?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrTeacherTeachingStructuresTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeacherSubjectOrderBy>>;
  where?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrTeacherTeachingStructuresTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructureStudentsOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructureStudentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrTeacherTeachingStructuresTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrTeacherTeachingStructuresTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
}

/** aggregated selection of "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherTeachingStructures>>;
}

/** aggregate fields of "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrTeacherTeachingStructuresVarianceFields>>;
}


/** aggregate fields of "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherTeachingStructuresSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherTeachingStructuresAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherTeachingStructuresMaxOrderBy>;
  min?: Maybe<StudentOrTeacherTeachingStructuresMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherTeachingStructuresStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherTeachingStructuresStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherTeachingStructuresStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherTeachingStructuresSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherTeachingStructuresVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherTeachingStructuresVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherTeachingStructuresVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrTeacherTeachingStructuresAvgFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresAvgOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structures". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherTeachingStructuresBoolExp {
  _and?: Maybe<Array<StudentOrTeacherTeachingStructuresBoolExp>>;
  _not?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherTeachingStructuresBoolExp>>;
  assignments?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  depth?: Maybe<StudentOrTeacherIntComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  ltr?: Maybe<StudentOrTeacherIntComparisonExp>;
  parent?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  parent_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  rtl?: Maybe<StudentOrTeacherIntComparisonExp>;
  semester?: Maybe<StudentOrTeacherSemestersBoolExp>;
  subject_icon?: Maybe<StudentOrTeacherStringComparisonExp>;
  teacher_subjects?: Maybe<StudentOrTeacherTeacherSubjectBoolExp>;
  teaching_structure_students?: Maybe<StudentOrTeacherTeachingStructureStudentsBoolExp>;
  teaching_structures?: Maybe<StudentOrTeacherTeachingStructuresBoolExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  type_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherTeachingStructuresMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  depth?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  parent_id?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherTeachingStructuresMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  depth?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  parent_id?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "teaching_structures". */
export interface StudentOrTeacherTeachingStructuresOrderBy {
  assignments_aggregate?: Maybe<StudentOrTeacherAssignmentsAggregateOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  depth?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  parent?: Maybe<StudentOrTeacherTeachingStructuresOrderBy>;
  parent_id?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
  semester?: Maybe<StudentOrTeacherSemestersOrderBy>;
  subject_icon?: Maybe<StudentOrTeacherOrderBy>;
  teacher_subjects_aggregate?: Maybe<StudentOrTeacherTeacherSubjectAggregateOrderBy>;
  teaching_structure_students_aggregate?: Maybe<StudentOrTeacherTeachingStructureStudentsAggregateOrderBy>;
  teaching_structures_aggregate?: Maybe<StudentOrTeacherTeachingStructuresAggregateOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  type_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "teaching_structures" */
export const enum StudentOrTeacherTeachingStructuresSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEPTH = 'depth',
  /** column name */
  ID = 'id',
  /** column name */
  LTR = 'ltr',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  RTL = 'rtl',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE_ID = 'type_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface StudentOrTeacherTeachingStructuresStddevFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresStddevOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrTeacherTeachingStructuresStddevPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresStddevPopOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrTeacherTeachingStructuresStddevSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresStddevSampOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrTeacherTeachingStructuresSumFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresSumOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrTeacherTeachingStructuresVarPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresVarPopOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrTeacherTeachingStructuresVarSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresVarSampOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrTeacherTeachingStructuresVarianceFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "teaching_structures" */
export interface StudentOrTeacherTeachingStructuresVarianceOrderBy {
  depth?: Maybe<StudentOrTeacherOrderBy>;
  ltr?: Maybe<StudentOrTeacherOrderBy>;
  rtl?: Maybe<StudentOrTeacherOrderBy>;
}


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherTimestampComparisonExp {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
}


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherTimestamptzComparisonExp {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
}


/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherTimetzComparisonExp {
  _eq?: Maybe<Scalars['timetz']>;
  _gt?: Maybe<Scalars['timetz']>;
  _gte?: Maybe<Scalars['timetz']>;
  _in?: Maybe<Array<Scalars['timetz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timetz']>;
  _lte?: Maybe<Scalars['timetz']>;
  _neq?: Maybe<Scalars['timetz']>;
  _nin?: Maybe<Array<Scalars['timetz']>>;
}

/** columns and relationships of "users" */
export interface StudentOrTeacherUsers {
  /** An object relationship */
  account?: EntireFieldWrapper<Maybe<StudentOrTeacherAuthAccounts>>;
  /** An object relationship */
  address?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateAdresses>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  birthday?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateBirthdays>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** A computed field, executes function "user_full_name" */
  full_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivateInsuranceNumbers>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  phone_number?: EntireFieldWrapper<Maybe<StudentOrTeacherPrivatePhoneNumbers>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<StudentOrTeacherRelationships>>;
  /** An array relationship */
  relationshipsByUserId: EntireFieldWrapper<Array<StudentOrTeacherRelationships>>;
  /** An aggregate relationship */
  relationshipsByUserId_aggregate: EntireFieldWrapper<StudentOrTeacherRelationshipsAggregate>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<StudentOrTeacherRelationshipsAggregate>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "users" */
export interface StudentOrTeacherUsersRelationshipsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherRelationshipsOrderBy>>;
  where?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentOrTeacherUsersRelationshipsByUserIdArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherRelationshipsOrderBy>>;
  where?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentOrTeacherUsersRelationshipsByUserIdAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherRelationshipsOrderBy>>;
  where?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentOrTeacherUsersRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherRelationshipsOrderBy>>;
  where?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
}

/** aggregated selection of "users" */
export interface StudentOrTeacherUsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherUsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherUsers>>;
}

/** aggregate fields of "users" */
export interface StudentOrTeacherUsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherUsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherUsersMinFields>>;
}


/** aggregate fields of "users" */
export interface StudentOrTeacherUsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherUsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherUsersBoolExp {
  _and?: Maybe<Array<StudentOrTeacherUsersBoolExp>>;
  _not?: Maybe<StudentOrTeacherUsersBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherUsersBoolExp>>;
  account?: Maybe<StudentOrTeacherAuthAccountsBoolExp>;
  address?: Maybe<StudentOrTeacherPrivateAdressesBoolExp>;
  avatar_url?: Maybe<StudentOrTeacherStringComparisonExp>;
  birthday?: Maybe<StudentOrTeacherPrivateBirthdaysBoolExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  first_name?: Maybe<StudentOrTeacherStringComparisonExp>;
  full_name?: Maybe<StudentOrTeacherStringComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  insurance_number?: Maybe<StudentOrTeacherPrivateInsuranceNumbersBoolExp>;
  last_name?: Maybe<StudentOrTeacherStringComparisonExp>;
  phone_number?: Maybe<StudentOrTeacherPrivatePhoneNumbersBoolExp>;
  relationships?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
  relationshipsByUserId?: Maybe<StudentOrTeacherRelationshipsBoolExp>;
  title?: Maybe<StudentOrTeacherStringComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "users" */
export const enum StudentOrTeacherUsersConstraint {
  /** unique or primary key constraint */
  USERS_PKEY = 'users_pkey'
};

/** input type for inserting data into table "users" */
export interface StudentOrTeacherUsersInsertInput {
  account?: Maybe<StudentOrTeacherAuthAccountsObjRelInsertInput>;
  address?: Maybe<StudentOrTeacherPrivateAdressesObjRelInsertInput>;
  avatar_url?: Maybe<Scalars['String']>;
  birthday?: Maybe<StudentOrTeacherPrivateBirthdaysObjRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<StudentOrTeacherPrivateInsuranceNumbersObjRelInsertInput>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<StudentOrTeacherPrivatePhoneNumbersObjRelInsertInput>;
  relationships?: Maybe<StudentOrTeacherRelationshipsArrRelInsertInput>;
  relationshipsByUserId?: Maybe<StudentOrTeacherRelationshipsArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrTeacherUsersMaxFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherUsersMinFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "users" */
export interface StudentOrTeacherUsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrTeacherUsers>>;
}

/** input type for inserting object relation for remote table "users" */
export interface StudentOrTeacherUsersObjRelInsertInput {
  data: StudentOrTeacherUsersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrTeacherUsersOnConflict>;
}

/** on conflict condition type for table "users" */
export interface StudentOrTeacherUsersOnConflict {
  constraint: StudentOrTeacherUsersConstraint;
  update_columns?: Array<StudentOrTeacherUsersUpdateColumn>;
  where?: Maybe<StudentOrTeacherUsersBoolExp>;
}

/** Ordering options when selecting data from "users". */
export interface StudentOrTeacherUsersOrderBy {
  account?: Maybe<StudentOrTeacherAuthAccountsOrderBy>;
  address?: Maybe<StudentOrTeacherPrivateAdressesOrderBy>;
  avatar_url?: Maybe<StudentOrTeacherOrderBy>;
  birthday?: Maybe<StudentOrTeacherPrivateBirthdaysOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  first_name?: Maybe<StudentOrTeacherOrderBy>;
  full_name?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  insurance_number?: Maybe<StudentOrTeacherPrivateInsuranceNumbersOrderBy>;
  last_name?: Maybe<StudentOrTeacherOrderBy>;
  phone_number?: Maybe<StudentOrTeacherPrivatePhoneNumbersOrderBy>;
  relationshipsByUserId_aggregate?: Maybe<StudentOrTeacherRelationshipsAggregateOrderBy>;
  relationships_aggregate?: Maybe<StudentOrTeacherRelationshipsAggregateOrderBy>;
  title?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** primary key columns input for table: users */
export interface StudentOrTeacherUsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "users" */
export const enum StudentOrTeacherUsersSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "users" */
export interface StudentOrTeacherUsersSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "users" */
export const enum StudentOrTeacherUsersUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface StudentOrTeacherUuidComparisonExp {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
}

/** columns and relationships of "view.assignment_class" */
export interface StudentOrTeacherViewAssignmentClass {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentOrTeacherClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.assignment_class" */
export interface StudentOrTeacherViewAssignmentClassAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherViewAssignmentClassMaxOrderBy>;
  min?: Maybe<StudentOrTeacherViewAssignmentClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.assignment_class". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewAssignmentClassBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewAssignmentClassBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewAssignmentClassBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewAssignmentClassBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  class?: Maybe<StudentOrTeacherClassesBoolExp>;
  class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "view.assignment_class" */
export interface StudentOrTeacherViewAssignmentClassMaxOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "view.assignment_class" */
export interface StudentOrTeacherViewAssignmentClassMinOrderBy {
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "view.assignment_class". */
export interface StudentOrTeacherViewAssignmentClassOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  class?: Maybe<StudentOrTeacherClassesOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.assignment_class" */
export const enum StudentOrTeacherViewAssignmentClassSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CLASS_ID = 'class_id'
};

/** columns and relationships of "view.assignment_student_grade" */
export interface StudentOrTeacherViewAssignmentStudentGrade {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  grade?: EntireFieldWrapper<Maybe<StudentOrTeacherGrades>>;
  grade_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentOrTeacherStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.assignment_student_grade". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewAssignmentStudentGradeBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewAssignmentStudentGradeBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewAssignmentStudentGradeBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewAssignmentStudentGradeBoolExp>>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  grade?: Maybe<StudentOrTeacherGradesBoolExp>;
  grade_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.assignment_student_grade". */
export interface StudentOrTeacherViewAssignmentStudentGradeOrderBy {
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  grade?: Maybe<StudentOrTeacherGradesOrderBy>;
  grade_id?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.assignment_student_grade" */
export const enum StudentOrTeacherViewAssignmentStudentGradeSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  GRADE_ID = 'grade_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.class_student" */
export interface StudentOrTeacherViewClassStudent {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentOrTeacherClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentOrTeacherStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.class_student". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewClassStudentBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewClassStudentBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewClassStudentBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewClassStudentBoolExp>>;
  class?: Maybe<StudentOrTeacherClassesBoolExp>;
  class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student?: Maybe<StudentOrTeacherStudentsBoolExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.class_student". */
export interface StudentOrTeacherViewClassStudentOrderBy {
  class?: Maybe<StudentOrTeacherClassesOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  student?: Maybe<StudentOrTeacherStudentsOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.class_student" */
export const enum StudentOrTeacherViewClassStudentSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.grade_type_subject" */
export interface StudentOrTeacherViewGradeTypeSubject {
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentOrTeacherGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrTeacherGradeTypes>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "view.grade_type_subject" */
export interface StudentOrTeacherViewGradeTypeSubjectGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherGradeTypesOrderBy>>;
  where?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
}

/** order by aggregate values of table "view.grade_type_subject" */
export interface StudentOrTeacherViewGradeTypeSubjectAggregateOrderBy {
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherViewGradeTypeSubjectMaxOrderBy>;
  min?: Maybe<StudentOrTeacherViewGradeTypeSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grade_type_subject". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewGradeTypeSubjectBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewGradeTypeSubjectBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewGradeTypeSubjectBoolExp>>;
  grade_type?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  grade_types?: Maybe<StudentOrTeacherGradeTypesBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "view.grade_type_subject" */
export interface StudentOrTeacherViewGradeTypeSubjectMaxOrderBy {
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "view.grade_type_subject" */
export interface StudentOrTeacherViewGradeTypeSubjectMinOrderBy {
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "view.grade_type_subject". */
export interface StudentOrTeacherViewGradeTypeSubjectOrderBy {
  grade_type?: Maybe<StudentOrTeacherGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  grade_types_aggregate?: Maybe<StudentOrTeacherGradeTypesAggregateOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.grade_type_subject" */
export const enum StudentOrTeacherViewGradeTypeSubjectSelectColumn {
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.grades" */
export interface StudentOrTeacherViewGrades {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<StudentOrTeacherSemesters>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** aggregated selection of "view.grades" */
export interface StudentOrTeacherViewGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherViewGrades>>;
}

/** aggregate fields of "view.grades" */
export interface StudentOrTeacherViewGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrTeacherViewGradesVarianceFields>>;
}


/** aggregate fields of "view.grades" */
export interface StudentOrTeacherViewGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherViewGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "view.grades" */
export interface StudentOrTeacherViewGradesAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherViewGradesAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherViewGradesMaxOrderBy>;
  min?: Maybe<StudentOrTeacherViewGradesMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherViewGradesStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherViewGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherViewGradesStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherViewGradesSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherViewGradesVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherViewGradesVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherViewGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrTeacherViewGradesAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesAvgOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grades". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewGradesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewGradesBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewGradesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewGradesBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimetzComparisonExp>;
  created_date?: Maybe<StudentOrTeacherDateComparisonExp>;
  grade_type?: Maybe<StudentOrTeacherStringComparisonExp>;
  grade_type_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  semester?: Maybe<StudentOrTeacherSemestersBoolExp>;
  semester_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  student_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  value?: Maybe<StudentOrTeacherIntComparisonExp>;
  weight?: Maybe<StudentOrTeacherIntComparisonExp>;
}

/** columns and relationships of "view.grades_for_students" */
export interface StudentOrTeacherViewGradesForStudents {
  assigment_date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentOrTeacherAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentOrTeacherMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrTeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.grades_for_students". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewGradesForStudentsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewGradesForStudentsBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewGradesForStudentsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewGradesForStudentsBoolExp>>;
  assigment_date?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  assignment?: Maybe<StudentOrTeacherAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  comment?: Maybe<StudentOrTeacherStringComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  mark?: Maybe<StudentOrTeacherMarksBoolExp>;
  mark_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.grades_for_students". */
export interface StudentOrTeacherViewGradesForStudentsOrderBy {
  assigment_date?: Maybe<StudentOrTeacherOrderBy>;
  assignment?: Maybe<StudentOrTeacherAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrTeacherOrderBy>;
  comment?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  mark?: Maybe<StudentOrTeacherMarksOrderBy>;
  mark_id?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.grades_for_students" */
export const enum StudentOrTeacherViewGradesForStudentsSelectColumn {
  /** column name */
  ASSIGMENT_DATE = 'assigment_date',
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate max on columns */
export interface StudentOrTeacherViewGradesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesMaxOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  created_date?: Maybe<StudentOrTeacherOrderBy>;
  grade_type?: Maybe<StudentOrTeacherOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrTeacherViewGradesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesMinOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  created_date?: Maybe<StudentOrTeacherOrderBy>;
  grade_type?: Maybe<StudentOrTeacherOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "view.grades". */
export interface StudentOrTeacherViewGradesOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  created_date?: Maybe<StudentOrTeacherOrderBy>;
  grade_type?: Maybe<StudentOrTeacherOrderBy>;
  grade_type_id?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  semester?: Maybe<StudentOrTeacherSemestersOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  student_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.grades" */
export const enum StudentOrTeacherViewGradesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_DATE = 'created_date',
  /** column name */
  GRADE_TYPE = 'grade_type',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  VALUE = 'value',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface StudentOrTeacherViewGradesStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesStddevOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrTeacherViewGradesStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesStddevPopOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrTeacherViewGradesStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesStddevSampOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrTeacherViewGradesSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesSumOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrTeacherViewGradesVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesVarPopOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrTeacherViewGradesVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesVarSampOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrTeacherViewGradesVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "view.grades" */
export interface StudentOrTeacherViewGradesVarianceOrderBy {
  value?: Maybe<StudentOrTeacherOrderBy>;
  weight?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "view.latest_chat_messages" */
export interface StudentOrTeacherViewLatestChatMessages {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<StudentOrTeacherChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user?: EntireFieldWrapper<Maybe<StudentOrTeacherUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregated selection of "view.latest_chat_messages" */
export interface StudentOrTeacherViewLatestChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherViewLatestChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherViewLatestChatMessages>>;
}

/** aggregate fields of "view.latest_chat_messages" */
export interface StudentOrTeacherViewLatestChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherViewLatestChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherViewLatestChatMessagesMinFields>>;
}


/** aggregate fields of "view.latest_chat_messages" */
export interface StudentOrTeacherViewLatestChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "view.latest_chat_messages". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewLatestChatMessagesBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewLatestChatMessagesBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewLatestChatMessagesBoolExp>>;
  body?: Maybe<StudentOrTeacherStringComparisonExp>;
  chat?: Maybe<StudentOrTeacherChatsBoolExp>;
  chat_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  user_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherViewLatestChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherViewLatestChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "view.latest_chat_messages". */
export interface StudentOrTeacherViewLatestChatMessagesOrderBy {
  body?: Maybe<StudentOrTeacherOrderBy>;
  chat?: Maybe<StudentOrTeacherChatsOrderBy>;
  chat_id?: Maybe<StudentOrTeacherOrderBy>;
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  user_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.latest_chat_messages" */
export const enum StudentOrTeacherViewLatestChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMark {
  avg?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
  count?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  max?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  min?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkAggregateOrderBy {
  avg?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkAvgOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkMaxOrderBy>;
  min?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkMinOrderBy>;
  stddev?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkStddevSampOrderBy>;
  sum?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkSumOrderBy>;
  var_pop?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkVarPopOrderBy>;
  var_samp?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkVarSampOrderBy>;
  variance?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkVarianceOrderBy>;
}

/** order by avg() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkAvgOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** Boolean expression to filter rows from the table "view.statistics_semester_subject_mark". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewStatisticsSemesterSubjectMarkBoolExp>>;
  avg?: Maybe<StudentOrTeacherNumericComparisonExp>;
  count?: Maybe<StudentOrTeacherBigintComparisonExp>;
  max?: Maybe<StudentOrTeacherIntComparisonExp>;
  min?: Maybe<StudentOrTeacherIntComparisonExp>;
  semester_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** order by max() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkMaxOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by min() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkMinOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** Ordering options when selecting data from "view.statistics_semester_subject_mark". */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.statistics_semester_subject_mark" */
export const enum StudentOrTeacherViewStatisticsSemesterSubjectMarkSelectColumn {
  /** column name */
  AVG = 'avg',
  /** column name */
  COUNT = 'count',
  /** column name */
  MAX = 'max',
  /** column name */
  MIN = 'min',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** order by stddev() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkStddevOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkStddevPopOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by stddev_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkStddevSampOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by sum() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkSumOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkVarPopOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by var_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkVarSampOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** order by variance() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrTeacherViewStatisticsSemesterSubjectMarkVarianceOrderBy {
  avg?: Maybe<StudentOrTeacherOrderBy>;
  count?: Maybe<StudentOrTeacherOrderBy>;
  max?: Maybe<StudentOrTeacherOrderBy>;
  min?: Maybe<StudentOrTeacherOrderBy>;
}

/** columns and relationships of "view.subject_semester" */
export interface StudentOrTeacherViewSubjectSemester {
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrTeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.subject_semester". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewSubjectSemesterBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewSubjectSemesterBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewSubjectSemesterBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewSubjectSemesterBoolExp>>;
  semester_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.subject_semester". */
export interface StudentOrTeacherViewSubjectSemesterOrderBy {
  semester_id?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.subject_semester" */
export const enum StudentOrTeacherViewSubjectSemesterSelectColumn {
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.teacher_class_subject" */
export interface StudentOrTeacherViewTeacherClassSubject {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentOrTeacherClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrTeacherSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.teacher_class_subject". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherViewTeacherClassSubjectBoolExp {
  _and?: Maybe<Array<StudentOrTeacherViewTeacherClassSubjectBoolExp>>;
  _not?: Maybe<StudentOrTeacherViewTeacherClassSubjectBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherViewTeacherClassSubjectBoolExp>>;
  class?: Maybe<StudentOrTeacherClassesBoolExp>;
  class_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  subject?: Maybe<StudentOrTeacherSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  teacher_id?: Maybe<StudentOrTeacherUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.teacher_class_subject". */
export interface StudentOrTeacherViewTeacherClassSubjectOrderBy {
  class?: Maybe<StudentOrTeacherClassesOrderBy>;
  class_id?: Maybe<StudentOrTeacherOrderBy>;
  subject?: Maybe<StudentOrTeacherSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrTeacherOrderBy>;
  teacher_id?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "view.teacher_class_subject" */
export const enum StudentOrTeacherViewTeacherClassSubjectSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "years" */
export interface StudentOrTeacherYears {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "year_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentOrTeacherPromotions>>;
  start_date: EntireFieldWrapper<Scalars['date']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "years" */
export interface StudentOrTeacherYearsPromotionsArgs {
  distinct_on?: Maybe<Array<StudentOrTeacherPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrTeacherPromotionsOrderBy>>;
  where?: Maybe<StudentOrTeacherPromotionsBoolExp>;
}

/** aggregated selection of "years" */
export interface StudentOrTeacherYearsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrTeacherYearsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrTeacherYears>>;
}

/** aggregate fields of "years" */
export interface StudentOrTeacherYearsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrTeacherYearsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrTeacherYearsMinFields>>;
}


/** aggregate fields of "years" */
export interface StudentOrTeacherYearsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrTeacherYearsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "years". All fields are combined with a logical 'AND'. */
export interface StudentOrTeacherYearsBoolExp {
  _and?: Maybe<Array<StudentOrTeacherYearsBoolExp>>;
  _not?: Maybe<StudentOrTeacherYearsBoolExp>;
  _or?: Maybe<Array<StudentOrTeacherYearsBoolExp>>;
  created_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
  end_date?: Maybe<StudentOrTeacherDateComparisonExp>;
  id?: Maybe<StudentOrTeacherUuidComparisonExp>;
  name?: Maybe<StudentOrTeacherStringComparisonExp>;
  promotions?: Maybe<StudentOrTeacherPromotionsBoolExp>;
  start_date?: Maybe<StudentOrTeacherDateComparisonExp>;
  updated_at?: Maybe<StudentOrTeacherTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrTeacherYearsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrTeacherYearsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** Ordering options when selecting data from "years". */
export interface StudentOrTeacherYearsOrderBy {
  created_at?: Maybe<StudentOrTeacherOrderBy>;
  end_date?: Maybe<StudentOrTeacherOrderBy>;
  id?: Maybe<StudentOrTeacherOrderBy>;
  name?: Maybe<StudentOrTeacherOrderBy>;
  promotions_aggregate?: Maybe<StudentOrTeacherPromotionsAggregateOrderBy>;
  start_date?: Maybe<StudentOrTeacherOrderBy>;
  updated_at?: Maybe<StudentOrTeacherOrderBy>;
}

/** select columns of table "years" */
export const enum StudentOrTeacherYearsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_DATE = 'end_date',
  /** column name */
  ID = 'id',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export type StudentOrTeacherAdressFragment = { street?: Maybe<string>, area?: Maybe<string>, city?: Maybe<string>, postal_code?: Maybe<string>, country?: Maybe<string>, created_at: string, updated_at: string };

export type StudentOrTeacherAssignmentFragment = { id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> };

export type StudentOrTeacherAggregateAssignmentFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrTeacherAssignmentClassFragment = { class?: Maybe<{ name?: Maybe<string>, id: string }> };

export type StudentOrTeacherAssignmentGradeFragment = { id: string, student: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> }, mark?: Maybe<{ id: string, value: number }> };

export type StudentOrTeacherAssignmentStudentFragment = { user?: Maybe<{ id: string, full_name?: Maybe<string> }>, assignment: { id: string } };

export type StudentOrTeacherAssignmentStudentGradeFragment = { student?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }>, grade?: Maybe<{ id: string, mark?: Maybe<{ id: string, value: number }> }> };

export type StudentOrTeacherAssignmentTotalCountFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrTeacherAssignmentTypeFragment = { name: string, icon?: Maybe<string> };

export type StudentOrTeacherBookFragment = { id: string, title: string, book_chapters: Array<{ id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> }> };

export type StudentOrTeacherChapterFragment = { id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> };

export type StudentOrTeacherChatFragment = { id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type StudentOrTeacherChatMessageFragment = { id: string, body: string, user_id: string, chat_id: string, created_at: string };

export type StudentOrTeacherKClassFragment = { name?: Maybe<string>, id: string };

export type StudentOrTeacherClassStudentFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type StudentOrTeacherChatTypeFragment = { name: string, description: string };

export type StudentOrTeacherFileFragment = { id: string, file_name: string, foreign_id: string, path: string };

export type StudentOrTeacherGradeFragment = { id: string, weight: number, comment?: Maybe<string>, mark?: Maybe<{ id: string, name: string, value: number }>, assignment: { title: string, type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { id: string, name: string } } }> } };

export type StudentOrTeacherLessonFragment = { id: string, start_at?: Maybe<any>, start_date?: Maybe<any>, description?: Maybe<string>, course: { id: string, subject: { id: string, name: string }, course_teachers: Array<{ teacher: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> } }> } };

export type StudentOrTeacherMarkFragment = { name: string, value: number };

export type StudentOrTeacherMessageFragment = { id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, replys?: Maybe<Array<{ id: string, body: string, user_id: string, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>>, likes: Array<{ id: string, chat_message_id: string, chat_like_user?: Maybe<{ id: string, first_name?: Maybe<string>, full_name?: Maybe<string> }> }>, responding?: Maybe<{ id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type StudentOrTeacherMessageAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrTeacherNoteFragment = { id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type StudentOrTeacherPhoneNumberFragment = { country_code: string, number: string, created_at: string, updated_at: string };

export type StudentOrTeacherPrivateChatFragment = { id: string, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type StudentOrTeacherSectionFragment = { id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> };

export type StudentOrTeacherSectionTypeFragment = { name: string, icon?: Maybe<string> };

export type StudentOrTeacherSemesterFragment = { id: string, start_at: any, end_at: any };

export type StudentOrTeacherStudentFragment = { id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> };

export type StudentOrTeacherSubjectFragment = { id: string, name: string, icon?: Maybe<string> };

export type StudentOrTeacherTaskFragment = { id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean };

export type StudentOrTeacherTasksAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrTeacherTeacherFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type StudentOrTeacherUserFragment = { id?: Maybe<string>, last_name?: Maybe<string>, first_name: string, email: string, birthday_at?: Maybe<string>, avatar_url?: Maybe<string>, mobile?: Maybe<string>, street_address?: Maybe<string>, title?: Maybe<string>, role?: Maybe<string>, is_verified?: Maybe<boolean>, assignments?: Maybe<boolean>, live_class?: Maybe<boolean>, grading?: Maybe<boolean>, chat?: Maybe<boolean> };

export type StudentOrTeacherYearFragment = { id: string, name?: Maybe<string>, start_date: any, end_date: any };

export type StudentOrTeacherAssignmentToggleMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
}>;


export type StudentOrTeacherAssignmentToggleMutation = { insert_assignment_submits_one?: Maybe<{ assignment: { id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> } }> };

export type StudentOrTeacherChatInsertUsersMutationVariables = Exact<{
  participants: Array<StudentOrTeacherChatUserInsertInput> | StudentOrTeacherChatUserInsertInput;
}>;


export type StudentOrTeacherChatInsertUsersMutation = { insert_chat_user?: Maybe<{ affected_rows: number }> };

export type StudentOrTeacherTogglePinMessageMutationVariables = Exact<{
  is_pinned?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
}>;


export type StudentOrTeacherTogglePinMessageMutation = { update_chat_messages_by_pk?: Maybe<{ id: string }> };

export type StudentOrTeacherTaskInsertMutationVariables = Exact<{
  task: StudentOrTeacherTasksInsertInput;
}>;


export type StudentOrTeacherTaskInsertMutation = { insert_tasks_one?: Maybe<{ id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean }> };

export type StudentOrTeacherTaskToggleMutationVariables = Exact<{
  id: Scalars['uuid'];
  is_completed: Scalars['Boolean'];
}>;


export type StudentOrTeacherTaskToggleMutation = { update_tasks_by_pk?: Maybe<{ id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean }> };

export type StudentOrTeacherUpdateMyTaskMutationVariables = Exact<{
  id: Scalars['uuid'];
  task: StudentOrTeacherTasksSetInput;
}>;


export type StudentOrTeacherUpdateMyTaskMutation = { update_tasks_by_pk?: Maybe<{ id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean }> };

export type StudentOrTeacherAssignmentQuestionOptionsFragment = { comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string };

export type StudentOrTeacherAssignmentQuestionsFragment = { content?: Maybe<string>, assignment_id: string, id: string, title: string, type: StudentOrTeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> };

export type StudentOrTeacherAssignmentQuizFragment = { attempts?: Maybe<number>, pass_percentage: number, time_control: boolean };

export type StudentOrTeacherClassFragment = { id: string, name?: Maybe<string>, identifier?: Maybe<string>, level: { name: string, number: number } };

export type StudentOrTeacherClassSubjectFragment = { subject?: Maybe<{ id: string, name: string }>, class?: Maybe<{ id: string, name?: Maybe<string> }> };

export type StudentOrTeacherQuizFragment = { id: string, title: string, is_completed?: Maybe<boolean>, duration: number, description?: Maybe<string>, created_at: string, due_at: string, teaching_structure_id?: Maybe<string>, assignment_quiz?: Maybe<{ attempts?: Maybe<number>, pass_percentage: number, time_control: boolean }>, teaching_structure?: Maybe<{ id: string, title: string }>, assignment_questions: Array<{ content?: Maybe<string>, assignment_id: string, id: string, title: string, type: StudentOrTeacherAssignmentQuestionTypesEnum, created_at: string, assignment_question_options: Array<{ comment?: Maybe<string>, created_at?: Maybe<string>, id: string, is_correct?: Maybe<boolean>, order?: Maybe<number>, score?: Maybe<number>, title: string }> }> };

export type StudentOrTeacherStudentGradesSemesterFragment = { id: string, name: string, icon?: Maybe<string>, statistics: Array<{ max?: Maybe<number>, min?: Maybe<number>, avg?: Maybe<any> }>, grades: { aggregate?: Maybe<{ max?: Maybe<{ value?: Maybe<number> }> }> }, parent_types: Array<{ parent_type?: Maybe<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> }, child_types: Array<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> } }> }> }> };

export const StudentOrTeacherAdressFragmentDoc = gql`
    fragment Adress on private_adresses {
  street
  area
  city
  postal_code
  country
  created_at
  updated_at
}
    `;
export const StudentOrTeacherAssignmentTypeFragmentDoc = gql`
    fragment AssignmentType on assignment_type {
  name
  icon
}
    `;
export const StudentOrTeacherFileFragmentDoc = gql`
    fragment File on files {
  id
  file_name
  foreign_id
  path
}
    `;
export const StudentOrTeacherAssignmentFragmentDoc = gql`
    fragment Assignment on assignments {
  id
  title
  description
  duration
  due_at
  due_at_filter
  created_at
  assignment_users {
    user_id
    id
  }
  chat {
    title
    id
  }
  teaching_structure {
    subject_icon
    subject_icon
    id
    ltr
    rtl
  }
  assignment_type {
    ...AssignmentType
  }
  lesson {
    course {
      subject {
        name
      }
    }
  }
  is_gradeable
  is_completed
  lesson {
    course {
      subject {
        name
      }
    }
  }
  user {
    full_name
  }
  grade_weight: assignment_grade_weight {
    id
    value
    comment
  }
  files {
    ...File
  }
}
    ${StudentOrTeacherAssignmentTypeFragmentDoc}
${StudentOrTeacherFileFragmentDoc}`;
export const StudentOrTeacherAggregateAssignmentFragmentDoc = gql`
    fragment AggregateAssignment on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrTeacherKClassFragmentDoc = gql`
    fragment KClass on classes {
  name
  id
}
    `;
export const StudentOrTeacherAssignmentClassFragmentDoc = gql`
    fragment AssignmentClass on view_assignment_class {
  class {
    ...KClass
  }
}
    ${StudentOrTeacherKClassFragmentDoc}`;
export const StudentOrTeacherAssignmentGradeFragmentDoc = gql`
    fragment AssignmentGrade on grades {
  id
  student {
    id
    user {
      full_name
    }
  }
  mark {
    id
    value
  }
}
    `;
export const StudentOrTeacherAssignmentStudentFragmentDoc = gql`
    fragment AssignmentStudent on assignment_user {
  user {
    id
    full_name
  }
  assignment {
    id
  }
}
    `;
export const StudentOrTeacherAssignmentStudentGradeFragmentDoc = gql`
    fragment AssignmentStudentGrade on view_assignment_student_grade {
  student {
    id
    user {
      full_name
    }
  }
  grade {
    id
    mark {
      id
      value
    }
  }
}
    `;
export const StudentOrTeacherAssignmentTotalCountFragmentDoc = gql`
    fragment AssignmentTotalCount on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrTeacherSectionTypeFragmentDoc = gql`
    fragment SectionType on chapter_section_type {
  name
  icon
}
    `;
export const StudentOrTeacherNoteFragmentDoc = gql`
    fragment Note on chapter_section_notes {
  id
  body
  created_at
  user {
    full_name
    avatar_url
  }
}
    `;
export const StudentOrTeacherSectionFragmentDoc = gql`
    fragment Section on chapter_sections {
  id
  title
  body @include(if: $with_body)
  duration_left
  duration_total: duration
  is_completed
  type: chapter_section_type {
    ...SectionType
  }
  notes: chapter_section_notes @include(if: $with_notes) {
    ...Note
  }
}
    ${StudentOrTeacherSectionTypeFragmentDoc}
${StudentOrTeacherNoteFragmentDoc}`;
export const StudentOrTeacherChapterFragmentDoc = gql`
    fragment Chapter on book_chapters {
  id
  title
  duration_left
  due_at
  type: book_chapter_type {
    name
    description
  }
  sections: chapter_sections(order_by: {sort: asc}) {
    ...Section
  }
}
    ${StudentOrTeacherSectionFragmentDoc}`;
export const StudentOrTeacherBookFragmentDoc = gql`
    fragment Book on books {
  id
  title
  book_chapters {
    ...Chapter
  }
}
    ${StudentOrTeacherChapterFragmentDoc}`;
export const StudentOrTeacherChatFragmentDoc = gql`
    fragment Chat on chats {
  id
  title
  avatar_url
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const StudentOrTeacherChatMessageFragmentDoc = gql`
    fragment ChatMessage on chat_messages {
  id
  body
  user_id
  chat_id
  created_at
}
    `;
export const StudentOrTeacherClassStudentFragmentDoc = gql`
    fragment ClassStudent on students {
  id
  user {
    full_name
  }
}
    `;
export const StudentOrTeacherChatTypeFragmentDoc = gql`
    fragment ChatType on chat_type {
  name
  description
}
    `;
export const StudentOrTeacherGradeFragmentDoc = gql`
    fragment Grade on grades {
  id
  weight
  comment
  mark {
    id
    name
    value
  }
  assignment {
    title
    type: assignment_type {
      name
      icon
    }
    lesson {
      course {
        subject {
          id
          name
        }
      }
    }
  }
}
    `;
export const StudentOrTeacherTeacherFragmentDoc = gql`
    fragment Teacher on teachers {
  id
  user {
    full_name
  }
}
    `;
export const StudentOrTeacherLessonFragmentDoc = gql`
    fragment Lesson on lessons {
  id
  start_at
  start_date
  course {
    id
    subject {
      id
      name
    }
    course_teachers {
      teacher {
        ...Teacher
      }
    }
  }
  description
}
    ${StudentOrTeacherTeacherFragmentDoc}`;
export const StudentOrTeacherMarkFragmentDoc = gql`
    fragment Mark on marks {
  name
  value
}
    `;
export const StudentOrTeacherMessageFragmentDoc = gql`
    fragment Message on chat_messages {
  id
  body
  user_id
  chat_id
  is_pinned
  created_at
  replys {
    id
    body
    user_id
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  likes: chat_message_likes {
    id
    chat_message_id
    chat_like_user {
      id
      first_name
      full_name
    }
  }
  responding: chat_message {
    id
    body
    user_id
    chat_id
    is_pinned
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  user {
    first_name
    last_name
    avatar_url
  }
}
    `;
export const StudentOrTeacherMessageAggregateFragmentDoc = gql`
    fragment MessageAggregate on chat_messages_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrTeacherPhoneNumberFragmentDoc = gql`
    fragment PhoneNumber on private_phone_numbers {
  country_code
  number
  created_at
  updated_at
}
    `;
export const StudentOrTeacherPrivateChatFragmentDoc = gql`
    fragment PrivateChat on chats {
  id
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const StudentOrTeacherSemesterFragmentDoc = gql`
    fragment Semester on semesters {
  id
  start_at
  end_at
}
    `;
export const StudentOrTeacherStudentFragmentDoc = gql`
    fragment Student on students {
  id
  user {
    avatar_url
    full_name
  }
}
    `;
export const StudentOrTeacherSubjectFragmentDoc = gql`
    fragment Subject on subjects {
  id
  name
  icon
}
    `;
export const StudentOrTeacherTaskFragmentDoc = gql`
    fragment Task on tasks {
  id
  body
  title
  is_completed
}
    `;
export const StudentOrTeacherTasksAggregateFragmentDoc = gql`
    fragment TasksAggregate on tasks_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrTeacherUserFragmentDoc = gql`
    fragment User on UserData {
  id
  last_name
  first_name
  email
  birthday_at
  avatar_url
  mobile
  street_address
  title
  role
  is_verified
  assignments
  live_class
  grading
  chat
}
    `;
export const StudentOrTeacherYearFragmentDoc = gql`
    fragment Year on years {
  id
  name
  start_date
  end_date
}
    `;
export const StudentOrTeacherClassFragmentDoc = gql`
    fragment Class on classes {
  id
  name
  identifier
  level {
    name
    number
  }
}
    `;
export const StudentOrTeacherClassSubjectFragmentDoc = gql`
    fragment ClassSubject on view_teacher_class_subject {
  subject {
    id
    name
  }
  class {
    id
    name
  }
}
    `;
export const StudentOrTeacherAssignmentQuizFragmentDoc = gql`
    fragment AssignmentQuiz on assignment_quiz {
  attempts
  pass_percentage
  time_control
}
    `;
export const StudentOrTeacherAssignmentQuestionOptionsFragmentDoc = gql`
    fragment AssignmentQuestionOptions on assignment_question_options {
  comment
  created_at
  id
  is_correct
  order
  score
  title
}
    `;
export const StudentOrTeacherAssignmentQuestionsFragmentDoc = gql`
    fragment AssignmentQuestions on assignment_questions {
  content
  assignment_id
  id
  title
  type
  created_at
  assignment_question_options {
    ...AssignmentQuestionOptions
  }
}
    ${StudentOrTeacherAssignmentQuestionOptionsFragmentDoc}`;
export const StudentOrTeacherQuizFragmentDoc = gql`
    fragment Quiz on assignments {
  id
  title
  is_completed
  duration
  description
  created_at
  due_at
  teaching_structure_id
  assignment_quiz {
    ...AssignmentQuiz
  }
  teaching_structure {
    id
    title
  }
  assignment_questions {
    ...AssignmentQuestions
  }
}
    ${StudentOrTeacherAssignmentQuizFragmentDoc}
${StudentOrTeacherAssignmentQuestionsFragmentDoc}`;
export const StudentOrTeacherStudentGradesSemesterFragmentDoc = gql`
    fragment StudentGradesSemester on subjects {
  id
  name
  icon
  statistics(where: {semester_id: {_eq: $semester_id}}) {
    max
    min
    avg
  }
  grades: view_grades_aggregate(where: {semester_id: {_eq: $semester_id}}) {
    aggregate {
      max {
        value
      }
    }
  }
  parent_types: grade_types(
    where: {grade_type: {grade_type_id: {_is_null: true}}}
  ) {
    parent_type: grade_type {
      id
      name
      grades: view_grades_aggregate(
        where: {semester_id: {_eq: $semester_id}, student_id: {_eq: $student_id}}
      ) {
        aggregate {
          avg {
            value
          }
        }
      }
      child_types: grade_types {
        id
        name
        grades: view_grades_aggregate(
          where: {semester_id: {_eq: $semester_id}, student_id: {_eq: $student_id}}
        ) {
          aggregate {
            avg {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const StudentOrTeacherAssignmentToggleDocument = gql`
    mutation AssignmentToggle($id: uuid, $completed_at: timestamptz) {
  insert_assignment_submits_one(
    object: {assignment_id: $id, completed_at: $completed_at}
    on_conflict: {constraint: assignment_submits_assignment_id_user_id_key, update_columns: completed_at, where: {assignment_id: {_eq: $id}}}
  ) {
    assignment {
      ...Assignment
    }
  }
}
    ${StudentOrTeacherAssignmentFragmentDoc}`;
export type StudentOrTeacherAssignmentToggleMutationFn = Apollo.MutationFunction<StudentOrTeacherAssignmentToggleMutation, StudentOrTeacherAssignmentToggleMutationVariables>;

/**
 * __useAssignmentToggleMutation__
 *
 * To run a mutation, you first call `useAssignmentToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignmentToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignmentToggleMutation, { data, loading, error }] = useAssignmentToggleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      completed_at: // value for 'completed_at'
 *   },
 * });
 */
export function useAssignmentToggleMutation(baseOptions?: Apollo.MutationHookOptions<StudentOrTeacherAssignmentToggleMutation, StudentOrTeacherAssignmentToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentOrTeacherAssignmentToggleMutation, StudentOrTeacherAssignmentToggleMutationVariables>(StudentOrTeacherAssignmentToggleDocument, options);
      }
export type AssignmentToggleMutationHookResult = ReturnType<typeof useAssignmentToggleMutation>;
export type AssignmentToggleMutationResult = Apollo.MutationResult<StudentOrTeacherAssignmentToggleMutation>;
export type AssignmentToggleMutationOptions = Apollo.BaseMutationOptions<StudentOrTeacherAssignmentToggleMutation, StudentOrTeacherAssignmentToggleMutationVariables>;
export const StudentOrTeacherChatInsertUsersDocument = gql`
    mutation ChatInsertUsers($participants: [chat_user_insert_input!]!) {
  insert_chat_user(objects: $participants) {
    affected_rows
  }
}
    `;
export type StudentOrTeacherChatInsertUsersMutationFn = Apollo.MutationFunction<StudentOrTeacherChatInsertUsersMutation, StudentOrTeacherChatInsertUsersMutationVariables>;

/**
 * __useChatInsertUsersMutation__
 *
 * To run a mutation, you first call `useChatInsertUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatInsertUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatInsertUsersMutation, { data, loading, error }] = useChatInsertUsersMutation({
 *   variables: {
 *      participants: // value for 'participants'
 *   },
 * });
 */
export function useChatInsertUsersMutation(baseOptions?: Apollo.MutationHookOptions<StudentOrTeacherChatInsertUsersMutation, StudentOrTeacherChatInsertUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentOrTeacherChatInsertUsersMutation, StudentOrTeacherChatInsertUsersMutationVariables>(StudentOrTeacherChatInsertUsersDocument, options);
      }
export type ChatInsertUsersMutationHookResult = ReturnType<typeof useChatInsertUsersMutation>;
export type ChatInsertUsersMutationResult = Apollo.MutationResult<StudentOrTeacherChatInsertUsersMutation>;
export type ChatInsertUsersMutationOptions = Apollo.BaseMutationOptions<StudentOrTeacherChatInsertUsersMutation, StudentOrTeacherChatInsertUsersMutationVariables>;
export const StudentOrTeacherTogglePinMessageDocument = gql`
    mutation TogglePinMessage($is_pinned: Boolean, $id: uuid!) {
  update_chat_messages_by_pk(_set: {is_pinned: $is_pinned}, pk_columns: {id: $id}) {
    id
  }
}
    `;
export type StudentOrTeacherTogglePinMessageMutationFn = Apollo.MutationFunction<StudentOrTeacherTogglePinMessageMutation, StudentOrTeacherTogglePinMessageMutationVariables>;

/**
 * __useTogglePinMessageMutation__
 *
 * To run a mutation, you first call `useTogglePinMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinMessageMutation, { data, loading, error }] = useTogglePinMessageMutation({
 *   variables: {
 *      is_pinned: // value for 'is_pinned'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTogglePinMessageMutation(baseOptions?: Apollo.MutationHookOptions<StudentOrTeacherTogglePinMessageMutation, StudentOrTeacherTogglePinMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentOrTeacherTogglePinMessageMutation, StudentOrTeacherTogglePinMessageMutationVariables>(StudentOrTeacherTogglePinMessageDocument, options);
      }
export type TogglePinMessageMutationHookResult = ReturnType<typeof useTogglePinMessageMutation>;
export type TogglePinMessageMutationResult = Apollo.MutationResult<StudentOrTeacherTogglePinMessageMutation>;
export type TogglePinMessageMutationOptions = Apollo.BaseMutationOptions<StudentOrTeacherTogglePinMessageMutation, StudentOrTeacherTogglePinMessageMutationVariables>;
export const StudentOrTeacherTaskInsertDocument = gql`
    mutation TaskInsert($task: tasks_insert_input!) {
  insert_tasks_one(object: $task) {
    ...Task
  }
}
    ${StudentOrTeacherTaskFragmentDoc}`;
export type StudentOrTeacherTaskInsertMutationFn = Apollo.MutationFunction<StudentOrTeacherTaskInsertMutation, StudentOrTeacherTaskInsertMutationVariables>;

/**
 * __useTaskInsertMutation__
 *
 * To run a mutation, you first call `useTaskInsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskInsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskInsertMutation, { data, loading, error }] = useTaskInsertMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useTaskInsertMutation(baseOptions?: Apollo.MutationHookOptions<StudentOrTeacherTaskInsertMutation, StudentOrTeacherTaskInsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentOrTeacherTaskInsertMutation, StudentOrTeacherTaskInsertMutationVariables>(StudentOrTeacherTaskInsertDocument, options);
      }
export type TaskInsertMutationHookResult = ReturnType<typeof useTaskInsertMutation>;
export type TaskInsertMutationResult = Apollo.MutationResult<StudentOrTeacherTaskInsertMutation>;
export type TaskInsertMutationOptions = Apollo.BaseMutationOptions<StudentOrTeacherTaskInsertMutation, StudentOrTeacherTaskInsertMutationVariables>;
export const StudentOrTeacherTaskToggleDocument = gql`
    mutation TaskToggle($id: uuid!, $is_completed: Boolean!) {
  update_tasks_by_pk(pk_columns: {id: $id}, _set: {is_completed: $is_completed}) {
    ...Task
  }
}
    ${StudentOrTeacherTaskFragmentDoc}`;
export type StudentOrTeacherTaskToggleMutationFn = Apollo.MutationFunction<StudentOrTeacherTaskToggleMutation, StudentOrTeacherTaskToggleMutationVariables>;

/**
 * __useTaskToggleMutation__
 *
 * To run a mutation, you first call `useTaskToggleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskToggleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskToggleMutation, { data, loading, error }] = useTaskToggleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_completed: // value for 'is_completed'
 *   },
 * });
 */
export function useTaskToggleMutation(baseOptions?: Apollo.MutationHookOptions<StudentOrTeacherTaskToggleMutation, StudentOrTeacherTaskToggleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentOrTeacherTaskToggleMutation, StudentOrTeacherTaskToggleMutationVariables>(StudentOrTeacherTaskToggleDocument, options);
      }
export type TaskToggleMutationHookResult = ReturnType<typeof useTaskToggleMutation>;
export type TaskToggleMutationResult = Apollo.MutationResult<StudentOrTeacherTaskToggleMutation>;
export type TaskToggleMutationOptions = Apollo.BaseMutationOptions<StudentOrTeacherTaskToggleMutation, StudentOrTeacherTaskToggleMutationVariables>;
export const StudentOrTeacherUpdateMyTaskDocument = gql`
    mutation UpdateMyTask($id: uuid!, $task: tasks_set_input!) {
  update_tasks_by_pk(_set: $task, pk_columns: {id: $id}) {
    ...Task
  }
}
    ${StudentOrTeacherTaskFragmentDoc}`;
export type StudentOrTeacherUpdateMyTaskMutationFn = Apollo.MutationFunction<StudentOrTeacherUpdateMyTaskMutation, StudentOrTeacherUpdateMyTaskMutationVariables>;

/**
 * __useUpdateMyTaskMutation__
 *
 * To run a mutation, you first call `useUpdateMyTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyTaskMutation, { data, loading, error }] = useUpdateMyTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      task: // value for 'task'
 *   },
 * });
 */
export function useUpdateMyTaskMutation(baseOptions?: Apollo.MutationHookOptions<StudentOrTeacherUpdateMyTaskMutation, StudentOrTeacherUpdateMyTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentOrTeacherUpdateMyTaskMutation, StudentOrTeacherUpdateMyTaskMutationVariables>(StudentOrTeacherUpdateMyTaskDocument, options);
      }
export type UpdateMyTaskMutationHookResult = ReturnType<typeof useUpdateMyTaskMutation>;
export type UpdateMyTaskMutationResult = Apollo.MutationResult<StudentOrTeacherUpdateMyTaskMutation>;
export type UpdateMyTaskMutationOptions = Apollo.BaseMutationOptions<StudentOrTeacherUpdateMyTaskMutation, StudentOrTeacherUpdateMyTaskMutationVariables>;